import {
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instanceat14thlj150z as Unit_instance,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  toString30pk9tzaqopn as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  println2shhhgwwt4c61 as println,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  printStackTrace18lnx7a39cni as printStackTrace,
  getKClass1s3j9wy1cofik as getKClass,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  first58ocm7j58k3q as first,
  CoroutineContext3n9ge8bnnq7z2 as CoroutineContext,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  CancellationException3b36o9qz53rgr as CancellationException,
  captureStack1fzi4aczwc4hg as captureStack,
  lazy2hsh8ze7j6ikd as lazy,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  emptyList1g2z5xcrvp2zy as emptyList,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  toList383f556t1dixk as toList,
  Duration5ynfiptaqcrg as Duration,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  protoOf180f3jzyo7rfj as protoOf,
  KProperty02ce7r476m8633 as KProperty0,
  THROW_ISE25y4rao9gcv5s as THROW_ISE,
  getLocalDelegateReferencenlta2y7wt3po as getLocalDelegateReference,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  ArrayList3it5z8td81qkl as ArrayList,
  intercepted2ogpsikxxj4u0 as intercepted,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  numberToDouble210hrknaofnhf as numberToDouble,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  maxOrNull5i0eu9xqz7pb as maxOrNull,
  returnIfSuspendednggonvg9333x as returnIfSuspended,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  compareTo3ankvs086tmwq as compareTo,
  Comparator2b3maoeh98xtg as Comparator,
  sortWith4fnm6b3vw03s as sortWith,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  KtList3hktaavzmj137 as KtList,
  listOfvhqybd2zx248 as listOf,
  firstOrNull1982767dljvdy as firstOrNull,
  coerceAtMost322komnqp70ag as coerceAtMost,
  Enum3alwj03lh1n41 as Enum,
  contains1tccixv8iwdcq as contains,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Duration__times_impl_sfuzvp1gzave8ckyu1a as Duration__times_impl_sfuzvp,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  HashMap1a0ld5kgwhmhv as HashMap,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  replace3le3ie7l9k8aq as replace,
  get_lastIndex327lnwnipm748 as get_lastIndex,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_0,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Level_TRACE_getInstance1ni95vo21pald as Level_TRACE_getInstance,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  Companion_getInstancet6d3dkp9rzuf as Companion_getInstance_1,
  AsyncSignal3p186s2w7f15b as AsyncSignal,
  Signal3nnez3346azzf as Signal,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope1245ljoj2flcu as coroutineScope,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  cancel2en0dn4yvpufo as cancel,
  Key_instance2expa55gr45sc as Key_instance,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  TimeoutCancellationException198b5zwr3v3uw as TimeoutCancellationException,
  withTimeout2wixyx2dhn9kz as withTimeout,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
} from './kotlinx-coroutines-core.mjs';
import {
  get_RegisteredImageFormats243xf60qkmjxj as get_RegisteredImageFormats,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  RGBA34obx2i62wcl3 as RGBA,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  readBitmapdk80pcjw6p8f as readBitmap,
  Bitmaps_instance27726euemn90u as Bitmaps_instance,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  RGBA__withAd_impl_cralao1ojb8pkalp2nb as RGBA__withAd_impl_cralao,
  Companion_getInstance2ou2xyvohty1g as Companion_getInstance_2,
  get_Bitmaps_transparent3nm2857y3u3hn as get_Bitmaps_transparent,
  get_bmpevghw2zw2fa7 as get_bmp,
  NativeImageOrBitmap3211fg7set8uiki as NativeImageOrBitmap32,
  slice2pfxfvku0ybgy as slice,
  get_isLow1k7uocm2ojjr8 as get_isLow,
  ShapeBuilderk05da5wk16e9 as ShapeBuilder,
  EmptyShape_instance1905h5dvjxi3r as EmptyShape_instance,
  readBitmapSlice2r7knpwifec2u as readBitmapSlice,
  readFont34z4s2654u5hd as readFont,
  HorizontalAlign__getOffsetX_impl_urzzxfa8fekmmr9non as HorizontalAlign__getOffsetX_impl_urzzxf,
  VerticalAlign__getOffsetY_impl_iso0y6m9d6k6n5h47j as VerticalAlign__getOffsetY_impl_iso0y6,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  Companion_getInstancezw1wxvwtmh0g as Companion_getInstance_3,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  Text2TextRendererActions1307nbc4pqqhs as Text2TextRendererActions,
  Entry3jfmfe0iy8gwc as Entry,
  FontMetrics1b1o1zbrk6cew as FontMetrics,
  TextMetrics1vfyzci74zdhy as TextMetrics,
  BitmapFont35unsvaxq1brd as BitmapFont,
  Font2bg7nte760csr as Font,
  getTextBoundsio1pfpt2q8ze as getTextBounds,
  TextMetricsResult1qr6b0fc6i56z as TextMetricsResult,
  invoke2ot88cm6qcfmr as invoke,
  LineInfo27uw564y6w2d2 as LineInfo,
  _HorizontalAlign___get_ratio__impl__x9wlea2fkrj6kbsj2fk as _HorizontalAlign___get_ratio__impl__x9wlea,
  _VerticalAlign___get_ratioFake__impl__1h2fwv1dj21d0zq5uhq as _VerticalAlign___get_ratioFake__impl__1h2fwv,
  Companion_getInstance2w9pdpq8h2ue0 as Companion_getInstance_4,
  ColorTransformMul2rawiv5hyxh9p as ColorTransformMul,
  _RGBA___get_hexString__impl__kocngmis57bfwjkwav as _RGBA___get_hexString__impl__kocngm,
  _RGBA___get_rgb__impl__tijaqtysv8goadjy9q as _RGBA___get_rgb__impl__tijaqt,
  PolylineShape2w5p5crr94b97 as PolylineShape,
  FillShape13c5zk3dmjgcf as FillShape,
  TextShape3u9vrw15swk1x as TextShape,
  CompoundShape2jsp34o6wp7wp as CompoundShape,
  _RGBA___get_premultiplied__impl__3bulqc3rk78ta2124j5 as _RGBA___get_premultiplied__impl__3bulqc,
  Bitmap321klycakvwgb5w as Bitmap32,
  _RgbaPremultipliedArray___init__impl__lx83hy2e5m664sv80uc as _RgbaPremultipliedArray___init__impl__lx83hy,
  GradientPaint1uc4xuo0s2w8w as GradientPaint,
  BitmapPaintgyia0tdij0bl as BitmapPaint,
  NonePaint2h93brzruznft as NonePaint,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  Companion_instance3gshkh79a96f7 as Companion_instance_0,
  Companion_instance293l0r179rei7 as Companion_instance_1,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_5,
  DateTime2gld4ho36azq9 as DateTime,
  TimeProvider2j6wl2le6n0p3 as TimeProvider,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds,
  FastDuration3d3pupg2e5ora as FastDuration,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237,
  get_fast37cu8s8qwnuyi as get_fast,
  get_DURATION_NIL2lkiawowwp1us as get_DURATION_NIL,
  FastDuration__times_impl_h6amcp3u6kv4tju4mnx as FastDuration__times_impl_h6amcp,
  FastDuration__div_impl_rlslck3eqcfgtjve915 as FastDuration__div_impl_rlslck,
  FastDuration__compareTo_impl_4fhnj73optjj2wg605h as FastDuration__compareTo_impl_4fhnj7_0,
  _FastDuration___get_nanoseconds__impl__pxizcb1ry8wyoc0dr5c as _FastDuration___get_nanoseconds__impl__pxizcb,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  get_slowaqovrrnrezzv as get_slow,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds_0,
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  div1s6t4x2ts64sh as div,
  get_fastMicroseconds16wth98xujxdo as get_fastMicroseconds_0,
  _FastDuration___get_fastMicroseconds__impl__e641g11wrcl3xo4cr7g as _FastDuration___get_fastMicroseconds__impl__e641g1,
  FastDuration__div_impl_rlslck2moqkr2wlhp55 as FastDuration__div_impl_rlslck_0,
  DateTime__minus_impl_10njw812puhhvc4b9kf as DateTime__minus_impl_10njw8,
  toDuration15w5sljvx2ut2 as toDuration_0,
  FastDuration__toString_impl_c9xohb3u75ye94mx1dw as FastDuration__toString_impl_c9xohb,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Injectorxjyp19tp5mfu as Injector,
  InjectorContextps0ngmjb9onz as InjectorContext,
  InjectorDependency2f8dsqe1kn3nn as InjectorDependency,
  injectorznx5rgygah7n as injector,
} from './korlibs-inject-root-korlibs-inject.mjs';
import {
  Companion_getInstance1dp345vz250gb as Companion_getInstance_6,
  DefaultViewport_getInstance3ta8638tkh0q1 as DefaultViewport_getInstance,
  Quality_PERFORMANCE_getInstance2edcjnp9auwx5 as Quality_PERFORMANCE_getInstance,
  GameWindowCreationConfigbzmga8g39et1 as GameWindowCreationConfig,
  configure1a7py4k2lj4vi as configure,
  Input3ljaq07eyi73v as Input,
  Statslnkcsgem8jjl as Stats,
  AGPrint2do8iynklt71b as AGPrint,
  GameWindow35197f3hcbh1b as GameWindow,
  KorgeReload_getInstance1jsrcs9uzp4z9 as KorgeReload_getInstance,
  configureLoggerFromProperties2zy8apzr93pqp as configureLoggerFromProperties,
  CoroutineKey_getInstance2jikmq30sknr8 as CoroutineKey_getInstance,
  CreateDefaultGameWindow1l94icsbq4y8h as CreateDefaultGameWindow,
  Kind_MOUSE_getInstance104tc4m897tyy as Kind_MOUSE_getInstance,
  ResourcesRoot36ooexy6oq69y as ResourcesRoot,
  Type_START_getInstance27oonvh9zpi1o as Type_START_getInstance,
  Status_ADD_getInstance22apyg5ct4px7 as Status_ADD_getInstance,
  Type_END_getInstance3ekhp9k4xqwsb as Type_END_getInstance,
  Status_REMOVE_getInstance19drpw6lfvon8 as Status_REMOVE_getInstance,
  Type_MOVE_getInstanceavavmobr5nzz as Type_MOVE_getInstance,
  Status_KEEP_getInstance3tj4183qdgyi5 as Status_KEEP_getInstance,
  MouseButton_LEFT_getInstance2pxjdxrpl68c5 as MouseButton_LEFT_getInstance,
  Type_DRAG_getInstance1oyczma3u1sfi as Type_DRAG_getInstance,
  Type_UP_getInstance1azeslmnft6l5 as Type_UP_getInstance,
  Type_DOWN_getInstance1zas01g4tazis as Type_DOWN_getInstance,
  AG35f0xk1ko87rh as AG,
  TouchEvent37l81isz00qgj as TouchEvent,
  Companion_getInstancekjblelnta22u as Companion_getInstance_7,
  Companion_getInstance1wltq3fgn1avz as Companion_getInstance_8,
  Companion_getInstance2ckr5i14ndxro as Companion_getInstance_9,
  Companion_getInstance18y91gyxi2z7 as Companion_getInstance_10,
  Companion_instance3i2v9jzzqvdkl as Companion_instance_2,
  Companion_instance2ovjg7lp6gfg7 as Companion_instance_3,
  Companion_instancef7estul0zruo as Companion_instance_4,
  Companion_instance99w5lpdgjzr4 as Companion_instance_5,
  MouseEventmt8xebywpdp9 as MouseEvent,
  Companion_getInstance6ryfwvwg9trm as Companion_getInstance_11,
  Companion_getInstanceok0yphc67vv6 as Companion_getInstance_12,
  Companion_instancekcgdgz2aik3h as Companion_instance_6,
  Companion_instance12t49ingjwxzt as Companion_instance_7,
  ReshapeEvent3137ki3m95agm as ReshapeEvent,
  Companion_instance7uo85wjiqj61 as Companion_instance_8,
  Type_TYPE_getInstance3kl3gtiytkq1p as Type_TYPE_getInstance,
  Type_DOWN_getInstance3w3upujzs6x5 as Type_DOWN_getInstance_0,
  Type_UP_getInstance2onpl7vaj0n6f as Type_UP_getInstance_0,
  Cursor_DEFAULT_getInstancemdqrzfwu4c9e as Cursor_DEFAULT_getInstance,
  Companion_getInstance1ifu77pbb1si2 as Companion_getInstance_13,
  drawText2ld6eqw3mc9xd as drawText,
  ScrollDeltaMode_PIXEL_getInstancen2y5xk1auels as ScrollDeltaMode_PIXEL_getInstance,
  V22su20mpwty0v0 as V2,
  _interpolateRatio2cj6ldbl0g6ae as _interpolateRatio,
  ProgramBuilderDefault3573mhybddt0b as ProgramBuilderDefault,
  get_BB_MAX_TEXTURES19x2awozztfc7 as get_BB_MAX_TEXTURES,
  SDFShaders_getInstance2aqc6fv2u457r as SDFShaders_getInstance,
  FragmentShader2u3ycaqbgbmdi as FragmentShader,
  Companion_instanceyamrbth4pjfq as Companion_instance_9,
  BaseEventListener6clplq3qhf9k as BaseEventListener,
  Companion_getInstance23l94gq35u9ye as Companion_getInstance_14,
  TextureBase31xvoisoo1pp7 as TextureBase,
  Texture39uvj3jju6ujd as Texture,
  AGScissor1lpa42gfyr1p2 as AGScissor,
  ProjViewUB_getInstance2c14wyrj73xek as ProjViewUB_getInstance,
  get_debugLineRenderContext3s3h9yq8a0rtj as get_debugLineRenderContext,
  Companion_getInstance2vwksse73neff as Companion_getInstance_15,
  get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz as get_TEXTURED_ARRAY_QUAD_INDICES,
  TexturedVertexArrayt1cf0uhgxqi1 as TexturedVertexArray,
  BoundsProvideri69utw6h2duh as BoundsProvider,
  debugBmpFont2i7i2ml66o1iy as debugBmpFont,
  Basef4lqzcfsxjhi as Base,
  UpdateEvent2wwv3f0im2cby as UpdateEvent,
  RenderContext3l27as458i66g as RenderContext,
  EventResult1qajuo9ssrvv5 as EventResult,
  Key_F12_getInstance20smmrbslhgku as Key_F12_getInstance,
  Key_F7_getInstance1fxfgbmldwoq6 as Key_F7_getInstance,
  KeyEvent3kdv2rq8w0dew as KeyEvent,
  StopPropagatingException3fryyzw9pc422 as StopPropagatingException,
  DeviceDimensionsProvider22igvmdnpe2w1 as DeviceDimensionsProvider,
  Eventnral6s6c3h27 as Event,
  Texture2obedkmljq67n as Texture_0,
  Companion_getInstanceae40js4gnuwg as Companion_getInstance_16,
  Companion_getInstance2cx7brx0y6bm1 as Companion_getInstance_17,
  Companion_getInstance3dym1csqm206y as Companion_getInstance_18,
  toAGScissor50oxbqy8vpfx as toAGScissor,
  plus3tmekjwnqrsa6 as plus,
  _AGColorMask___init__impl__j38ai819ejt5rq8iy6o as _AGColorMask___init__impl__j38ai8,
  Companion_getInstancei2plsq4vst79 as Companion_getInstance_19,
  AGStencilOpFunc__withEnabled_impl_mpcwmr3endm713vq1t4 as AGStencilOpFunc__withEnabled_impl_mpcwmr,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv2a7p3ocsjaav3 as AGStencilOpFunc__withCompareMode$default_impl_rzbauv,
  Companion_getInstance203qp9xyfv543 as Companion_getInstance_20,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgoupfk5vp49hcf as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo,
  AGStencilReference__withWriteMask$default_impl_b7j7b425xwuml31ig42 as AGStencilReference__withWriteMask$default_impl_b7j7b4,
  Companion_getInstance14dcva8uz4sb6 as Companion_getInstance_21,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at1fkyyctti87u0 as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at,
  AGStencilReference__withReadMask$default_impl_7mdffx3h4nrtbyv01sb as AGStencilReference__withReadMask$default_impl_7mdffx,
  AGCompareMode__inverted_impl_7xxk8m1fvhgazpgzedy as AGCompareMode__inverted_impl_7xxk8m,
  AGStencilReference__withReferenceValue$default_impl_2trj0vn7k078mgur5t as AGStencilReference__withReferenceValue$default_impl_2trj0v,
  _AGColorMask___init__impl__j38ai828hvpfxybxjk7 as _AGColorMask___init__impl__j38ai8_0,
  Companion_getInstance29a9zmyrrw3c9 as Companion_getInstance_22,
  AGDrawType__toString_impl_eonaeb3ais8d8qrz6pw as AGDrawType__toString_impl_eonaeb,
  AGColorMask__toString_impl_5i5oqgpd3xxn1kc5a as AGColorMask__toString_impl_5i5oqg,
  AGStencilOpFunc__toString_impl_pl8quy1rqibzqlcrdqz as AGStencilOpFunc__toString_impl_pl8quy,
  AGStencilReference__toString_impl_qu5r8s2c4bvb2linrx as AGStencilReference__toString_impl_qu5r8s,
  AGCullFace__toString_impl_7d891w3d9dwll45l9u7 as AGCullFace__toString_impl_7d891w,
  AGDrawType__hashCode_impl_ylaurytzzq8sas7cp2 as AGDrawType__hashCode_impl_ylaury,
  AGColorMask__hashCode_impl_g9082fge542b8j3bn5 as AGColorMask__hashCode_impl_g9082f,
  AGStencilOpFunc__hashCode_impl_nopebb37r56bx19rj5s as AGStencilOpFunc__hashCode_impl_nopebb,
  AGStencilReference__hashCode_impl_52zufx32vlakxm4newn as AGStencilReference__hashCode_impl_52zufx,
  AGCullFace__hashCode_impl_t4e5urey2md6modztx as AGCullFace__hashCode_impl_t4e5ur,
  AGTextureUnits3k80ikbk5qbv9 as AGTextureUnits,
  AGDrawType11vxw4gf0yugk as AGDrawType,
  AGColorMaskwqd86t1dhpnk as AGColorMask,
  AGStencilOpFunc1juigl5mvjr07 as AGStencilOpFunc,
  AGStencilReference8at184sv64zi as AGStencilReference,
  AGCullFaceff7di2v9k2ne as AGCullFace,
  AgCachedBuffer8k1i505isl6b as AgCachedBuffer,
  AGVertexArrayObjectp6l6cor3jhq8 as AGVertexArrayObject,
  AGVertexDatawn78bdwnwjab as AGVertexData,
  DefaultShaders_getInstance2nkm3g7twu3qg as DefaultShaders_getInstance,
  applyMatrixBounds3j13fpymjibm6 as applyMatrixBounds,
  AGBatch2bse24318tbhc as AGBatch,
  draw3n7i8s75fp58g as draw,
  UniformBlock2qoqszhm3r9i2 as UniformBlock,
  UniformBlockBuffer2p2oao2ic417b as UniformBlockBuffer,
  VarType_Float2_getInstance321ftm11bbyai as VarType_Float2_getInstance,
  If1av5krmfyt44s as If,
  Attribute3obvnbxr5w4xd as Attribute,
  VarType_Float1_getInstance1fp6gxp2vmo7y as VarType_Float1_getInstance,
  Precision_MEDIUM_getInstancewn61okav7bh4 as Precision_MEDIUM_getInstance,
  Varying105nnu9x9j75f as Varying,
  ProgramLayout373hh4xkth3qt as ProgramLayout,
  VertexShader26kcg39ndf3s1 as VertexShader,
  Program1hnygp9hph4ry as Program,
  Companion_instance31en7fj48z7ti as Companion_instance_10,
  Companion_getInstance31h96uhdj5cc as Companion_getInstance_23,
} from './korge-root-korge-core.mjs';
import {
  Companion_getInstance23o88a0u6ly94 as Companion_getInstance_24,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance_25,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance_26,
  Size2Dum5ayuyhhau7 as Size2D,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_27,
  Rectangle3q03woyn9k8x1 as Rectangle,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_28,
  Scale2cm697xlulcp5 as Scale,
  Companion_getInstance2yu48324co92b as Companion_getInstance_29,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_30,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_31,
  interpolatewhd2sgxffql5 as interpolate,
  _Angle___get_degrees__impl__qg56vw2n539uvc01e1n as _Angle___get_degrees__impl__qg56vw,
  _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle as _Angle___get_absoluteValue__impl__4qoakv,
  SizeInte6w85oa6mz6v as SizeInt,
  toFloat3b315y36g90cd as toFloat,
  toIntp2twe4onfbic as toInt,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_32,
  BoundsBuilder__plus_impl_cz7f7xiu6sbkxslhhl as BoundsBuilder__plus_impl_cz7f7x_0,
  _BoundsBuilder___get_xmax__impl__gsz0km31n4zf6la54qa as _BoundsBuilder___get_xmax__impl__gsz0km,
  _BoundsBuilder___get_xmin__impl__o2sib0fqg01yornfcx as _BoundsBuilder___get_xmin__impl__o2sib0,
  _BoundsBuilder___get_ymax__impl__oia4uz2kb33iwdnvg1r as _BoundsBuilder___get_ymax__impl__oia4uz,
  _BoundsBuilder___get_ymin__impl__5n2e8j1x2fwruhjr6r5 as _BoundsBuilder___get_ymin__impl__5n2e8j,
  MarginInt3jiec8xsxkfd as MarginInt,
  Vector4F1clr35ctch8js as Vector4F,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_33,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_34,
  Ratio136tf4z2t0p2d as Ratio,
  Ratio__toString_impl_mfgt3e2iqv27qr9i5ak as Ratio__toString_impl_mfgt3e,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
  clampdicp8njiht45 as clamp,
  clamp1qclpmpfxm7xb as clamp_0,
  toRatio1hooqit5gulhr as toRatio,
  toLongRound7crzegvo2qbo as toLongRound,
  toIntCeil3h286vm49zgwd as toIntCeil,
  clamp31lhm66c28ic8 as clamp_1,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  roundDecimalPlacespck2j5mpzhqn as roundDecimalPlaces,
  convertRange24n2xnngpze54 as convertRange,
  convertRange1a6ancvyn151r as convertRange_0,
  niceStr1ftz2qvn4gdyq as niceStr,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
  toIntRoundjnzmk86x1qp5 as toIntRound,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  get_immutablepxpdoj6e54ll as get_immutable,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  HitTestDirection_ANY_getInstance1hlnrhgqmsigf as HitTestDirection_ANY_getInstance,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance3u9930f4wm838 as StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance,
  toStrokePointsList2dojuc3rfktd4 as toStrokePointsList,
  get_cachedPoints16ehjcv6uuio1 as get_cachedPoints,
  getPoints2List1zux0vi6zk0wt as getPoints2List,
  Winding_NON_ZERO_getInstance38kh1ikwl48ly as Winding_NON_ZERO_getInstance,
  LineScaleMode_NONE_getInstance2mlqkio15xcm4 as LineScaleMode_NONE_getInstance,
  LineCap_BUTT_getInstancetv7srcehoz43 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance35lw9h64apo2h as LineJoin_MITER_getInstance,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_35,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  cancel1n0qjc93h2v6w as cancel_0,
  Closeable2m9yv0b0gma2l as Closeable,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_11,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  PerformanceCounter_getInstance3b8d94s1bsc37 as PerformanceCounter_getInstance,
  toFrequency3flbtmp5xney7 as toFrequency,
  _Frequency___get_hertz__impl__9m7k6x25q6mu7133pq1 as _Frequency___get_hertz__impl__9m7k6x,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediately11za8mkid9pxu as launchImmediately,
  Companion_instance20wy3vp7551rj as Companion_instance_12,
  get_workerImpl14jb6v5ie8q11 as get_workerImpl,
  get_DEBUG_WORKER2r7zp31jch3ip as get_DEBUG_WORKER,
  get_localCurrentDirVfs2lka1gsv26an5 as get_localCurrentDirVfs,
  Resources1ysf2j4wd5yk7 as Resources,
  launchImmediatelylnv8lnistpdy as launchImmediately_0,
  Once1q3lxlgflq3fq as Once,
  launchUnscopedAndWait1ibbocika451b as launchUnscopedAndWait,
  launchUnscopedpyoa01nqmf1z as launchUnscoped,
  launchUnscoped2lqe6wwpvfo83 as launchUnscoped_0,
  StandardPaths_instanceid246em8v040 as StandardPaths_instance,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  Companion_instance2nobhthyyb9yj as Companion_instance_13,
  Dyn__set_impl_2ozvx82bmztjcahblz8 as Dyn__set_impl_2ozvx8,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import { get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider } from './korlibs-audio-core-root-korlibs-audio-core.mjs';
import {
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  getExtra307y0o9pd6mp3 as getExtra,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  toFastList1btvvxvv57pw as toFastList,
  Resourceable38whwgli3ts8g as Resourceable,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  IntArrayList3liuagbdnwmna as IntArrayList,
  Ref2y4j4snnxo6gs as Ref,
  IntDeque2ebok66x2sofm as IntDeque,
  Pool1zbsw0zhvh8ca as Pool,
  toRef3av6zm8yavumw as toRef,
  Ref11k43t82thcp3 as Ref_0,
  floatArrayListOfa8snvg2p0fhc as floatArrayListOf,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  arrayfill2iqmyqqqfwuaf as arrayfill,
  arraycopy3uxsqjlixmnz3 as arraycopy,
  arrayequal25g4om83vd8w1 as arrayequal,
  _Float32Buffer___init__impl__403k2m1hlz2hcoqnaef as _Float32Buffer___init__impl__403k2m,
  _Float32Buffer___get_buffer__impl__x5nu9xp04xjj40882q as _Float32Buffer___get_buffer__impl__x5nu9x,
} from './korlibs-memory-root-korlibs-memory.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance_14 = this;
    this.c9n_1 = Companion_getInstance_0().ey('Korge');
    this.d9n_1 = 'korlibs.korge.unknown';
  }
}
class Korge$_init_$slambda_ys8r4w {
  e9n(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  de(p1, $completion) {
    return this.e9n(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$start$slambda {
  constructor(this$0, $entry) {
    this.q9l_1 = this$0;
    this.r9l_1 = $entry;
  }
  k1q($this$withContext, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withContext), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Korge {
  constructor(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    Companion_getInstance_36();
    var tmp;
    if (args === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    injector = injector === VOID ? new Injector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$_init_$lambda_95dffl;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_36().d9n_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().o8e_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? DefaultViewport_getInstance().a8c_1 : windowSize;
    virtualSize = virtualSize === VOID ? windowSize : virtualSize;
    displayMode = displayMode === VOID ? Companion_getInstance_37().g3r() : displayMode;
    title = title === VOID ? 'Game' : title;
    backgroundColor = backgroundColor === VOID ? Colors_getInstance().h40_1 : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? new GameWindowCreationConfig(multithreaded, VOID, VOID, VOID, VOID, VOID, fullscreen) : windowCreationConfig;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$_init_$slambda_ys8r4w_0();
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().g40_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$_init_$lambda_95dffl_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
    unit = unit === VOID ? Unit_instance : unit;
    this.s9l_1 = args;
    this.t9l_1 = imageFormats;
    this.u9l_1 = gameWindow;
    this.v9l_1 = mainSceneClass;
    this.w9l_1 = timeProvider;
    this.x9l_1 = injector;
    this.y9l_1 = configInjector;
    this.z9l_1 = debug;
    this.a9m_1 = trace;
    this.b9m_1 = context;
    this.c9m_1 = fullscreen;
    this.d9m_1 = blocking;
    this.e9m_1 = gameId;
    this.f9m_1 = settingsFolder;
    this.g9m_1 = batchMaxQuads;
    this.h9m_1 = windowSize;
    this.i9m_1 = virtualSize;
    this.j9m_1 = displayMode;
    this.k9m_1 = title;
    this.l9m_1 = backgroundColor;
    this.m9m_1 = quality;
    this.n9m_1 = icon;
    this.o9m_1 = multithreaded;
    this.p9m_1 = forceRenderEveryFrame;
    this.q9m_1 = windowCreationConfig;
    this.r9m_1 = main;
    this.s9m_1 = debugAg;
    this.t9m_1 = debugFontExtraScale;
    this.u9m_1 = debugFontColor;
    this.v9m_1 = stageBuilder;
    this.w9m_1 = targetFps;
    this.x9m_1 = preferSyncIo;
    this.y9m_1 = debugCoroutines;
    this.z9m_1 = unit;
  }
  z9p(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_start__v5y7pu.bind(VOID, this, entry), $completion);
  }
  a9q(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    return new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
  }
  a9n(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit, $super) {
    args = args === VOID ? this.s9l_1 : args;
    imageFormats = imageFormats === VOID ? this.t9l_1 : imageFormats;
    gameWindow = gameWindow === VOID ? this.u9l_1 : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? this.v9l_1 : mainSceneClass;
    timeProvider = timeProvider === VOID ? this.w9l_1 : timeProvider;
    injector = injector === VOID ? this.x9l_1 : injector;
    configInjector = configInjector === VOID ? this.y9l_1 : configInjector;
    debug = debug === VOID ? this.z9l_1 : debug;
    trace = trace === VOID ? this.a9m_1 : trace;
    context = context === VOID ? this.b9m_1 : context;
    fullscreen = fullscreen === VOID ? this.c9m_1 : fullscreen;
    blocking = blocking === VOID ? this.d9m_1 : blocking;
    gameId = gameId === VOID ? this.e9m_1 : gameId;
    settingsFolder = settingsFolder === VOID ? this.f9m_1 : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? this.g9m_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? this.h9m_1 : windowSize;
    virtualSize = virtualSize === VOID ? this.i9m_1 : virtualSize;
    displayMode = displayMode === VOID ? this.j9m_1 : displayMode;
    title = title === VOID ? this.k9m_1 : title;
    backgroundColor = backgroundColor === VOID ? this.l9m_1 : backgroundColor;
    quality = quality === VOID ? this.m9m_1 : quality;
    icon = icon === VOID ? this.n9m_1 : icon;
    multithreaded = multithreaded === VOID ? this.o9m_1 : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? this.p9m_1 : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? this.q9m_1 : windowCreationConfig;
    main = main === VOID ? this.r9m_1 : main;
    debugAg = debugAg === VOID ? this.s9m_1 : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? this.t9m_1 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? this.u9m_1 : debugFontColor;
    stageBuilder = stageBuilder === VOID ? this.v9m_1 : stageBuilder;
    targetFps = targetFps === VOID ? this.w9m_1 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? this.x9m_1 : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? this.y9m_1 : debugCoroutines;
    unit = unit === VOID ? this.z9m_1 : unit;
    var tmp;
    if ($super === VOID) {
      tmp = this.a9q(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
    } else {
      var tmp_0 = $super.a9q;
      var tmp_1 = backgroundColor;
      var tmp_2 = tmp_1 == null ? null : new RGBA(tmp_1);
      tmp = tmp_0.call(this, args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, tmp_2, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, new RGBA(debugFontColor), stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance);
    }
    return tmp;
  }
  toString() {
    var tmp = toString(this.s9l_1);
    var tmp_0 = this.t9l_1.toString();
    var tmp_1 = toString_0(this.u9l_1);
    var tmp_2 = toString_0(this.v9l_1);
    var tmp_3 = toString(this.w9l_1);
    var tmp_4 = this.x9l_1.toString();
    var tmp_5 = toString(this.y9l_1);
    var tmp_6 = toString_0(this.b9m_1);
    var tmp_7 = this.h9m_1.toString();
    var tmp_8 = this.i9m_1.toString();
    var tmp_9 = this.j9m_1.toString();
    var tmp_10 = this.l9m_1;
    return 'Korge(args=' + tmp + ', imageFormats=' + tmp_0 + ', gameWindow=' + tmp_1 + ', mainSceneClass=' + tmp_2 + ', timeProvider=' + tmp_3 + ', injector=' + tmp_4 + ', configInjector=' + tmp_5 + ', debug=' + this.z9l_1 + ', trace=' + this.a9m_1 + ', context=' + tmp_6 + ', fullscreen=' + this.c9m_1 + ', blocking=' + this.d9m_1 + ', gameId=' + this.e9m_1 + ', settingsFolder=' + this.f9m_1 + ', batchMaxQuads=' + this.g9m_1 + ', windowSize=' + tmp_7 + ', virtualSize=' + tmp_8 + ', displayMode=' + tmp_9 + ', title=' + this.k9m_1 + ', backgroundColor=' + toString_0(tmp_10 == null ? null : new RGBA(tmp_10)) + ', quality=' + toString(this.m9m_1) + ', icon=' + this.n9m_1 + ', multithreaded=' + this.o9m_1 + ', forceRenderEveryFrame=' + this.p9m_1 + ', windowCreationConfig=' + this.q9m_1.toString() + ', main=' + toString(this.r9m_1) + ', debugAg=' + this.s9m_1 + ', debugFontExtraScale=' + this.t9m_1 + ', debugFontColor=' + RGBA__toString_impl_4lw6dp(this.u9m_1) + ', stageBuilder=' + toString(this.v9m_1) + ', targetFps=' + this.w9m_1 + ', preferSyncIo=' + this.x9m_1 + ', debugCoroutines=' + this.y9m_1 + ', unit=' + this.z9m_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.s9l_1);
    result = imul(result, 31) + hashCode(this.t9l_1) | 0;
    result = imul(result, 31) + (this.u9l_1 == null ? 0 : hashCode(this.u9l_1)) | 0;
    result = imul(result, 31) + (this.v9l_1 == null ? 0 : this.v9l_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.w9l_1) | 0;
    result = imul(result, 31) + hashCode(this.x9l_1) | 0;
    result = imul(result, 31) + hashCode(this.y9l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z9l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a9m_1) | 0;
    result = imul(result, 31) + (this.b9m_1 == null ? 0 : hashCode(this.b9m_1)) | 0;
    result = imul(result, 31) + (this.c9m_1 == null ? 0 : getBooleanHashCode(this.c9m_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d9m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e9m_1) | 0;
    result = imul(result, 31) + (this.f9m_1 == null ? 0 : getStringHashCode(this.f9m_1)) | 0;
    result = imul(result, 31) + this.g9m_1 | 0;
    result = imul(result, 31) + this.h9m_1.hashCode() | 0;
    result = imul(result, 31) + this.i9m_1.hashCode() | 0;
    result = imul(result, 31) + this.j9m_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.k9m_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.l9m_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.l9m_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + this.m9m_1.hashCode() | 0;
    result = imul(result, 31) + (this.n9m_1 == null ? 0 : getStringHashCode(this.n9m_1)) | 0;
    result = imul(result, 31) + (this.o9m_1 == null ? 0 : getBooleanHashCode(this.o9m_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p9m_1) | 0;
    result = imul(result, 31) + this.q9m_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.r9m_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s9m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t9m_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.u9m_1) | 0;
    result = imul(result, 31) + hashCode(this.v9m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w9m_1) | 0;
    result = imul(result, 31) + (this.x9m_1 == null ? 0 : getBooleanHashCode(this.x9m_1)) | 0;
    result = imul(result, 31) + (this.y9m_1 == null ? 0 : getBooleanHashCode(this.y9m_1)) | 0;
    var tmp_2 = imul(result, 31);
    result = tmp_2 + hashCode(Unit_instance) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Korge))
      return false;
    var tmp0_other_with_cast = other instanceof Korge ? other : THROW_CCE();
    if (!equals(this.s9l_1, tmp0_other_with_cast.s9l_1))
      return false;
    if (!equals(this.t9l_1, tmp0_other_with_cast.t9l_1))
      return false;
    if (!equals(this.u9l_1, tmp0_other_with_cast.u9l_1))
      return false;
    if (!equals(this.v9l_1, tmp0_other_with_cast.v9l_1))
      return false;
    if (!equals(this.w9l_1, tmp0_other_with_cast.w9l_1))
      return false;
    if (!equals(this.x9l_1, tmp0_other_with_cast.x9l_1))
      return false;
    if (!equals(this.y9l_1, tmp0_other_with_cast.y9l_1))
      return false;
    if (!(this.z9l_1 === tmp0_other_with_cast.z9l_1))
      return false;
    if (!(this.a9m_1 === tmp0_other_with_cast.a9m_1))
      return false;
    if (!equals(this.b9m_1, tmp0_other_with_cast.b9m_1))
      return false;
    if (!(this.c9m_1 == tmp0_other_with_cast.c9m_1))
      return false;
    if (!(this.d9m_1 === tmp0_other_with_cast.d9m_1))
      return false;
    if (!(this.e9m_1 === tmp0_other_with_cast.e9m_1))
      return false;
    if (!(this.f9m_1 == tmp0_other_with_cast.f9m_1))
      return false;
    if (!(this.g9m_1 === tmp0_other_with_cast.g9m_1))
      return false;
    if (!this.h9m_1.equals(tmp0_other_with_cast.h9m_1))
      return false;
    if (!this.i9m_1.equals(tmp0_other_with_cast.i9m_1))
      return false;
    if (!this.j9m_1.equals(tmp0_other_with_cast.j9m_1))
      return false;
    if (!(this.k9m_1 === tmp0_other_with_cast.k9m_1))
      return false;
    var tmp = this.l9m_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.l9m_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!this.m9m_1.equals(tmp0_other_with_cast.m9m_1))
      return false;
    if (!(this.n9m_1 == tmp0_other_with_cast.n9m_1))
      return false;
    if (!(this.o9m_1 == tmp0_other_with_cast.o9m_1))
      return false;
    if (!(this.p9m_1 === tmp0_other_with_cast.p9m_1))
      return false;
    if (!this.q9m_1.equals(tmp0_other_with_cast.q9m_1))
      return false;
    if (!equals(this.r9m_1, tmp0_other_with_cast.r9m_1))
      return false;
    if (!(this.s9m_1 === tmp0_other_with_cast.s9m_1))
      return false;
    if (!equals(this.t9m_1, tmp0_other_with_cast.t9m_1))
      return false;
    if (!(this.u9m_1 === tmp0_other_with_cast.u9m_1))
      return false;
    if (!equals(this.v9m_1, tmp0_other_with_cast.v9m_1))
      return false;
    if (!equals(this.w9m_1, tmp0_other_with_cast.w9m_1))
      return false;
    if (!(this.x9m_1 == tmp0_other_with_cast.x9m_1))
      return false;
    if (!(this.y9m_1 == tmp0_other_with_cast.y9m_1))
      return false;
    if (!equals(Unit_instance, Unit_instance))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_15 = this;
    this.v9p_1 = new KorgeDisplayMode(Companion_getInstance_24().y2j_1, Companion_getInstance_25().n29(), true);
    this.w9p_1 = new KorgeDisplayMode(Companion_getInstance_24().y2j_1, Companion_getInstance_25().n29(), false);
    this.x9p_1 = new KorgeDisplayMode(Companion_getInstance_24().y2j_1, Companion_getInstance_25().b29_1, false);
    this.y9p_1 = new KorgeDisplayMode(Companion_getInstance_24().a2k_1, Companion_getInstance_25().b29_1, false);
  }
  g3r() {
    return this.v9p_1;
  }
}
class KorgeDisplayMode {
  constructor(scaleMode, scaleAnchor, clipBorders) {
    Companion_getInstance_37();
    this.b9q_1 = scaleMode;
    this.c9q_1 = scaleAnchor;
    this.d9q_1 = clipBorders;
  }
  toString() {
    return 'KorgeDisplayMode(scaleMode=' + this.b9q_1.toString() + ', scaleAnchor=' + this.c9q_1.toString() + ', clipBorders=' + this.d9q_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.b9q_1);
    result = imul(result, 31) + this.c9q_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d9q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeDisplayMode))
      return false;
    var tmp0_other_with_cast = other instanceof KorgeDisplayMode ? other : THROW_CCE();
    if (!equals(this.b9q_1, tmp0_other_with_cast.b9q_1))
      return false;
    if (!this.c9q_1.equals(tmp0_other_with_cast.c9q_1))
      return false;
    if (!(this.d9q_1 === tmp0_other_with_cast.d9q_1))
      return false;
    return true;
  }
}
class KorgeRunner$invoke$slambda$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.s9s_1 = $config;
    this.t9s_1 = $views;
    this.u9s_1 = $entry;
    this.v9s_1 = $gameWindow;
  }
  k1q($this$coroutineScope, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$coroutineScope), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$invoke$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.y9x_1 = $config;
    this.z9x_1 = $views;
    this.a9y_1 = $entry;
    this.b9y_1 = $gameWindow;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class KorgeRunner$invoke$slambda {
  constructor($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
    this.c9y_1 = $realGameWindow;
    this.d9y_1 = $windowSize;
    this.e9y_1 = $config;
    this.f9y_1 = $iconPath;
    this.g9y_1 = $imageFormats;
    this.h9y_1 = $entry;
  }
  p9y($this$loop, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$loop), $completion);
  }
  de(p1, $completion) {
    return this.p9y(p1 instanceof GameWindow ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$prepareViewsBase$lambda$slambda {
  constructor($views) {
    this.q9y_1 = $views;
  }
  ce($completion) {
    this.q9y_1.n6();
  }
}
class KorgeRunner {
  b9n(config, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, config), $completion);
  }
  l9y(views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, forceRenderEveryFrame, configInjector) {
    var injector = views.l9q_1;
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    injector.c6c(getKClass(Views), views);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance = views.k9q_1;
    injector.c6c(getKClass(AG), instance);
    injector.c6c(getKClass(Resources), views.s9y());
    var tmp = getKClass(ResourcesRoot);
    injector.f6c(tmp, KorgeRunner$prepareViewsBase$lambda);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_0 = views.m9q_1;
    injector.c6c(getKClass(Input), instance_0);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_1 = views.o9q_1;
    injector.c6c(getKClass(Stats), instance_1);
    injector.c6c(getKClass(CoroutineContext), views.j9q_1);
    var tmp_0 = getKClass(EmptyScene);
    injector.g6c(tmp_0, KorgeRunner$prepareViewsBase$lambda_0);
    injector.c6c(getKClass(TimeProvider), views.n9q_1);
    configInjector(injector);
    var input = views.m9q_1;
    var ag = views.k9q_1;
    var downPos = {_v: Companion_getInstance_27().c2a_1};
    var upPos = {_v: Companion_getInstance_27().c2a_1};
    var downTime = {_v: new DateTime(Companion_getInstance_5().o1x_1)};
    var moveTime = {_v: new DateTime(Companion_getInstance_5().o1x_1)};
    var upTime = Companion_getInstance_5().o1x_1;
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    views.t9y(forceRenderEveryFrame);
    var mouseTouchEvent = new TouchEvent();
    var tmp_1 = Companion_getInstance_7().a6h_1.slice();
    eventDispatcher.j6f(tmp_1, KorgeRunner$prepareViewsBase$lambda_1(views, input, downPos, downTime, mouseTouchEvent, upPos, moveTime, moveMouseOutsideInNextFrame));
    var tmp_2 = Companion_getInstance_8().m6g_1.slice();
    eventDispatcher.j6f(tmp_2, KorgeRunner$prepareViewsBase$lambda_2(views));
    var tmp_3 = Companion_getInstance_9().c6i_1.slice();
    eventDispatcher.j6f(tmp_3, KorgeRunner$prepareViewsBase$lambda_3(views));
    var tmp_4 = Companion_getInstance_10().j6i_1.slice();
    eventDispatcher.j6f(tmp_4, KorgeRunner$prepareViewsBase$lambda_4(views));
    var tmp_5 = Companion_instance_2;
    eventDispatcher.x6e(tmp_5, KorgeRunner$prepareViewsBase$lambda_5(views));
    var tmp_6 = Companion_instance_3;
    eventDispatcher.x6e(tmp_6, KorgeRunner$prepareViewsBase$lambda_6(views));
    var tmp_7 = Companion_instance_4;
    eventDispatcher.x6e(tmp_7, KorgeRunner$prepareViewsBase$lambda_7(views));
    var tmp_8 = Companion_instance_5;
    eventDispatcher.x6e(tmp_8, KorgeRunner$prepareViewsBase$lambda_8(views));
    var touchMouseEvent = new MouseEvent();
    var tmp_9 = Companion_getInstance_11().e6j_1.slice();
    eventDispatcher.j6f(tmp_9, KorgeRunner$prepareViewsBase$lambda_9(input, views, touchMouseEvent, moveMouseOutsideInNextFrame, downPos, downTime, upPos, moveTime));
    var tmp_10 = Companion_getInstance_12().j6l_1.slice();
    eventDispatcher.j6f(tmp_10, KorgeRunner$prepareViewsBase$lambda_10(views));
    var tmp_11 = Companion_instance_6;
    eventDispatcher.x6e(tmp_11, KorgeRunner$prepareViewsBase$lambda_11(views, input));
    var tmp_12 = Companion_instance_7;
    eventDispatcher.x6e(tmp_12, KorgeRunner$prepareViewsBase$lambda_12(views, ag));
    eventDispatcher.i6f(new ReshapeEvent(0, 0, views.u9y(), views.v9y()));
    var tmp_13 = Companion_instance_8;
    eventDispatcher.x6e(tmp_13, KorgeRunner$prepareViewsBase$lambda_13(views));
    var renderShown = {_v: false};
    views.j9r_1 = clearEachFrame;
    views.k9r_1 = bgcolor;
    var firstRenderDeferred = CompletableDeferred();
    views.p9q_1.b8q(KorgeRunner$prepareViewsBase$lambda_14(views, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  }
}
class Korge$slambda {
  e9n(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  de(p1, $completion) {
    return this.e9n(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$slambda_0 {
  e9n(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  de(p1, $completion) {
    return this.e9n(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$lambda$slambda {
  constructor(this$0, $event) {
    this.c9z_1 = this$0;
    this.d9z_1 = $event;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_0 {
  constructor(this$0, $event) {
    this.e9z_1 = this$0;
    this.f9z_1 = $event;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_1 {
  constructor(this$0, $event) {
    this.g9z_1 = this$0;
    this.h9z_1 = $event;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
  }
}
class KeysEvents {
  constructor(view) {
    this.w9y_1 = view;
    this.y9y_1 = new AsyncSignal();
    this.z9y_1 = new AsyncSignal();
    this.a9z_1 = new AsyncSignal();
    this.b9z_1 = new CancellableGroup();
    var tmp = Type_TYPE_getInstance();
    this.w9y_1.x6e(tmp, KeysEvents$lambda(this));
    var tmp_0 = Type_DOWN_getInstance_0();
    this.w9y_1.x6e(tmp_0, KeysEvents$lambda_0(this));
    var tmp_1 = Type_UP_getInstance_0();
    this.w9y_1.x6e(tmp_1, KeysEvents$lambda_1(this));
  }
  i9z() {
    var tmp = this.x9y_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  n6() {
    this.b9z_1.n6();
  }
}
class Companion_1 {
  fa1(views) {
    // Inline function 'korlibs.io.util.Once.invoke' call
    var this_0 = get_mouseDebugHandlerOnce(views);
    if (!this_0.u38_1) {
      this_0.u38_1 = true;
      // Inline function 'korlibs.korge.input.Companion.installDebugExtensionOnce.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = views.b9s_1;
      var element = MouseEvents$Companion$installDebugExtensionOnce$lambda(views);
      this_1.h(element);
    }
  }
}
class MouseEventsUpdate {
  constructor($outer, view) {
    this.ia1_1 = $outer;
    this.ga1_1 = new Mixin();
    this.ha1_1 = view;
    addUpdaterWithViews(this.ha1_1, MouseEvents$MouseEventsUpdate$lambda(this.ia1_1));
  }
  yz(value) {
    this.ga1_1.yz(value);
  }
  zz() {
    return this.ga1_1.zz();
  }
}
class MouseEvents {
  constructor(view) {
    this.p9z_1 = new Mixin();
    this.q9z_1 = view;
    this.q9z_1.ma1(true);
    this.s9z_1 = new Signal();
    this.t9z_1 = new Signal();
    this.u9z_1 = new Signal();
    this.v9z_1 = new Signal();
    this.w9z_1 = new Signal();
    this.x9z_1 = new Signal();
    this.y9z_1 = new Signal();
    this.z9z_1 = new Signal();
    this.aa0_1 = new Signal();
    this.ba0_1 = new Signal();
    this.ca0_1 = new Signal();
    this.da0_1 = new Signal();
    this.ea0_1 = new Signal();
    this.fa0_1 = new Signal();
    this.ga0_1 = new Signal();
    this.ha0_1 = new Signal();
    this.ia0_1 = new Signal();
    this.ja0_1 = new Signal();
    this.ka0_1 = new Signal();
    this.la0_1 = null;
    this.ma0_1 = false;
    this.na0_1 = false;
    this.oa0_1 = false;
    this.pa0_1 = PerformanceCounter_getInstance().x6c();
    this.qa0_1 = PerformanceCounter_getInstance().x6c();
    this.ra0_1 = Vector2D.v2c();
    this.sa0_1 = Vector2D.v2c();
    this.ta0_1 = Vector2D.v2c();
    this.ua0_1 = Vector2D.v2c();
    this.va0_1 = Vector2D.v2c();
    this.wa0_1 = 0;
    this.xa0_1 = false;
    this.ya0_1 = null;
    this.za0_1 = new MouseEvent();
    this.aa1_1 = false;
    this.ba1_1 = new MouseEvent();
    var tmp = this;
    var tmp_0 = Companion_getInstance_7().a6h_1.slice();
    tmp.ca1_1 = this.q9z_1.j6f(tmp_0, MouseEvents$closeable$lambda(this));
    this.da1_1 = new MouseEventsUpdate(this, this.q9z_1);
  }
  ka1() {
    var tmp = this.r9z_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  na1() {
    return this.ka1().j9q_1;
  }
  oa1() {
    return this.q9z_1.pa1(this.va0_1);
  }
  qa1() {
    return this.ka1().v9r_1.pa1(this.va0_1);
  }
  ra1() {
    var tmp0_safe_receiver = this.ya0_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.t6f();
    }
  }
  la1() {
    var tmp0_safe_receiver = this.la0_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, this.q9z_1);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  sa1() {
    return this.za0_1.l6h_1;
  }
  ta1() {
    // Inline function 'korlibs.event.MouseEvent.scrollDeltaYPixels' call
    return this.za0_1.a6i(ScrollDeltaMode_PIXEL_getInstance());
  }
  ua1() {
    return !(this.ka1().m9q_1.a8b_1 === 0);
  }
  toString() {
    return this.za0_1.toString();
  }
  ea1(views, dt) {
    if (!this.q9z_1.ja1())
      return Unit_instance;
    this.r9z_1 = views;
    Companion_instance_16.fa1(views);
    this.la0_1 = mouseHitTest(Companion_instance_16, views);
    var over = this.la1();
    var inside = views.m9q_1.c8b_1;
    if (over) {
      set_mouseHitResultUsed(views.m9q_1, this.q9z_1);
    }
    var overChanged = !(this.ma0_1 === over);
    var insideChanged = !(this.na0_1 === inside);
    var pressingChanged = !(this.ua1() === this.oa0_1);
    this.va0_1 = views.m9q_1.q8b();
    if (!overChanged && over && !this.va0_1.equals(this.ua0_1)) {
      this.ea0_1.x20(this);
    }
    if (!overChanged && !over && !this.va0_1.equals(this.ua0_1)) {
      this.ga0_1.x20(this);
    }
    if (!this.va0_1.equals(this.ua0_1)) {
      this.fa0_1.x20(this);
    }
    if (overChanged && over) {
      this.u9z_1.x20(this);
    }
    if (overChanged && !over) {
      this.v9z_1.x20(this);
    }
    if (pressingChanged && this.ua1()) {
      this.ta0_1 = this.va0_1;
      if (over) {
        this.w9z_1.x20(this);
      }
      if (!over) {
        this.x9z_1.x20(this);
      }
    }
    if (overChanged && this.ua1()) {
      this.y9z_1.x20(this);
    }
    if (pressingChanged && !this.ua1()) {
      var tmp = this.ba1_1;
      temporalLastEvent(this, tmp, MouseEvents$update$lambda(over, this));
    }
    over && this.wa0_1 > 0;
    if (insideChanged && !inside) {
      this.ga0_1.x20(this);
      this.v9z_1.x20(this);
      this.ba0_1.x20(this);
      this.ca0_1.x20(this);
      this.ha0_1.x20(this);
    }
    this.ma0_1 = over;
    this.na0_1 = inside;
    this.oa0_1 = this.ua1();
    this.ua0_1 = this.va0_1;
    this.wa0_1 = 0;
  }
  n6() {
    this.ca1_1.n6();
  }
  yz(value) {
    this.p9z_1.yz(value);
  }
  zz() {
    return this.p9z_1.zz();
  }
}
class SceneCancellationException extends CancellationException {
  static ba2(scene) {
    var $this = this.ud('Scene.sceneAfterDestroyInternal:' + toString(scene));
    captureStack($this, $this.aa2_1);
    $this.za1_1 = scene;
    return $this;
  }
}
class Scene {
  constructor() {
    this.ca2_1 = new Mixin();
    this.ha2_1 = Container.za4();
    this.ia2_1 = new CancellableGroup();
    var tmp = this;
    tmp.ja2_1 = lazy(Scene$coroutineContext$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.ka2_1 = lazy(Scene$sceneView$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.la2_1 = lazy(Scene$resources$delegate$lambda(this));
  }
  na2() {
    var tmp = this.da2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  }
  aa5(_set____db54di) {
    this.ea2_1 = _set____db54di;
  }
  ka1() {
    var tmp = this.ea2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  oa2() {
    var tmp = this.fa2_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  }
  ba5() {
    return this.ka1().v9r_1;
  }
  b17() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ja2_1;
    coroutineContext$factory();
    return this_0.s1();
  }
  ca5() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ka2_1;
    sceneView$factory();
    return this_0.s1();
  }
  pa2(size) {
    return SContainer.oa7(size);
  }
  n6c(injector) {
    this.da2_1 = injector;
    // Inline function 'korlibs.inject.Injector.get' call
    var tmp$ret$0 = injector.l6c(getKClass(Views));
    this.aa5(tmp$ret$0);
    var tmp = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp.fa2_1 = injector.l6c(getKClass(SceneContainer));
    var tmp_0 = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp_0.ga2_1 = injector.l6c(getKClass(ResourcesRoot));
  }
  pa7(_this__u8e3s4, $completion) {
  }
  qa7(_this__u8e3s4, $completion) {
  }
  ra7($completion) {
  }
  sa7($completion) {
  }
  ta7($completion) {
  }
  ua7() {
    cancel_0(this.ia2_1);
    this.na2().o6c();
  }
  ma2($completion) {
  }
  va7($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneAfterDestroyInternal__rup219.bind(VOID, this), $completion);
  }
  wa7(size_0) {
    size(this.ca5(), size_0);
  }
  yz(value) {
    this.ca2_1.yz(value);
  }
  zz() {
    return this.ca2_1.zz();
  }
}
class EmptyScene extends Scene {
  qa7(_this__u8e3s4, $completion) {
  }
}
class VisitEntry {
  constructor(clazz, injects) {
    this.nab_1 = clazz;
    this.oab_1 = injects;
  }
  toString() {
    return 'VisitEntry(clazz=' + toString(this.nab_1) + ', injects=' + toString(this.oab_1) + ')';
  }
  hashCode() {
    var result = this.nab_1.hashCode();
    result = imul(result, 31) + hashCode(this.oab_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this.nab_1.equals(tmp0_other_with_cast.nab_1))
      return false;
    if (!equals(this.oab_1, tmp0_other_with_cast.oab_1))
      return false;
    return true;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_17 = this;
    this.ra8_1 = Companion_getInstance_0().ey('SceneContainer');
    var tmp = this;
    var tmp_0 = getKClass(EmptyScene);
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp.sa8_1 = new VisitEntry(tmp_0, tmp$ret$0);
  }
}
class SceneContainer$lambda$slambda {
  constructor(this$0, $event) {
    this.ha8_1 = this$0;
    this.ia8_1 = $event;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda {
  constructor($newScene) {
    this.ua8_1 = $newScene;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_0 {
  constructor($newScene) {
    this.va8_1 = $newScene;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_1 {
  constructor($oldScene) {
    this.wa8_1 = $oldScene;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_2 {
  constructor($oldScene) {
    this.xa8_1 = $oldScene;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_3 {
  constructor($oldScene) {
    this.ya8_1 = $oldScene;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_4 {
  constructor($newScene) {
    this.za8_1 = $newScene;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this), $completion);
  }
}
class BaseView extends BaseEventListener {
  static may() {
    return this.v6e();
  }
  kah() {
  }
}
class View extends BaseView {
  static tb3(isContainer) {
    var $this = this.may();
    $this.a9t_1 = isContainer;
    var tmp = $this;
    tmp.b9t_1 = lazy(View$bviewAll$delegate$lambda($this));
    $this.c9t_1 = true;
    $this.d9t_1 = null;
    $this.e9t_1 = null;
    $this.f9t_1 = null;
    $this.g9t_1 = 0;
    $this.h9t_1 = null;
    $this.i9t_1 = 1.0;
    $this.j9t_1 = null;
    $this.k9t_1 = null;
    $this.l9t_1 = null;
    $this.m9t_1 = Companion_getInstance_13().r86_1;
    $this.n9t_1 = 0.0;
    $this.o9t_1 = 0.0;
    $this.p9t_1 = 1.0;
    $this.q9t_1 = 1.0;
    $this.r9t_1 = Companion_getInstance_31().r29_1;
    $this.s9t_1 = Companion_getInstance_31().r29_1;
    $this.t9t_1 = Companion_getInstance_31().r29_1;
    $this.u9t_1 = 0.0;
    $this.v9t_1 = scale$factory($this);
    $this.w9t_1 = false;
    $this.x9t_1 = true;
    $this.y9t_1 = true;
    $this.z9t_1 = true;
    $this.a9u_1 = true;
    $this.b9u_1 = Companion_getInstance_30().m2d_1;
    $this.c9u_1 = Companion_getInstance_30().m2d_1;
    $this.d9u_1 = -1;
    $this.e9u_1 = Companion_getInstance_30().m2d_1;
    $this.f9u_1 = -1;
    $this.g9u_1 = new ColorTransformMul();
    $this.h9u_1 = new ColorTransformMul();
    $this.i9u_1 = -1;
    $this.j9u_1 = Companion_getInstance_13().r86_1;
    $this.k9u_1 = -1;
    $this.l9u_1 = true;
    $this.m9u_1 = 0;
    $this.n9u_1 = 0;
    $this.o9u_1 = false;
    $this.p9u_1 = false;
    $this.q9u_1 = null;
    $this.r9u_1 = false;
    $this.s9u_1 = null;
    $this.t9u_1 = 0;
    $this.u9u_1 = true;
    $this.v9u_1 = null;
    return $this;
  }
  gai() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b9t_1;
    bviewAll$factory();
    return this_0.s1();
  }
  static ob9() {
    return this.tb3(false);
  }
  hai() {
    return 0.0;
  }
  iai() {
    return 0.0;
  }
  nah() {
    return null;
  }
  lay(_set____db54di) {
    this.e9t_1 = _set____db54di;
  }
  jai() {
    return this.e9t_1;
  }
  kai() {
    return this.f9t_1;
  }
  lai(value) {
    this.g9t_1 = value;
  }
  u6l() {
    return this.g9t_1;
  }
  mai(value) {
    if (this.j9t_1 === value)
      return Unit_instance;
    this.j9t_1 = value;
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.nah();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.f1()) {
        // Inline function 'korlibs.korge.view.View.<set-_stage>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.e1(_unary__edvuaz).mai(value);
      }
      tmp = Unit_instance;
    }
    this.nai();
  }
  nai() {
  }
  oai(value) {
    if (this.k9t_1 === value)
      return Unit_instance;
    this.k9t_1 = value;
    var parent = this.lah();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.nah();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.f1()) {
        // Inline function 'korlibs.korge.view.View.<set-_invalidateNotifier>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.e1(_unary__edvuaz).oai(parent);
      }
      tmp = Unit_instance;
    }
  }
  lah() {
    return this.k9t_1;
  }
  pai() {
    var tmp0_safe_receiver = this.h9t_1;
    this.oai(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lah());
  }
  qai(value) {
    if (this.h9t_1 === value)
      return Unit_instance;
    this.h9t_1 = value;
    var tmp0_safe_receiver = this.h9t_1;
    this.mai(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j9t_1);
    this.pai();
    this.aak();
    this.w6e(value);
  }
  k28() {
    return this.h9t_1;
  }
  rai() {
    return !(this.k28() == null) ? ensureNotNull(this.k28()).rai() * this.i9t_1 : this.i9t_1;
  }
  sai(x, y) {
    this.paj();
    if (!(this.n9t_1 === x) || !(this.o9t_1 === y)) {
      this.n9t_1 = x;
      this.o9t_1 = y;
      this.yaj();
    }
  }
  w4s(value) {
    return this.sai(value.a2a_1, value.b2a_1);
  }
  tai(v) {
    this.sai(v, this.c6j());
  }
  b6j() {
    this.paj();
    return this.n9t_1;
  }
  uai(v) {
    this.sai(this.b6j(), v);
  }
  c6j() {
    this.paj();
    return this.o9t_1;
  }
  vai() {
    return this.u9t_1;
  }
  wai(v) {
    this.caj(Scale.v2h(v, v));
  }
  xai() {
    return this.daj().x2f();
  }
  yai(v) {
    this.paj();
    if (!(this.p9t_1 === v)) {
      this.p9t_1 = v;
      this.yaj();
    }
  }
  zai() {
    this.paj();
    return this.p9t_1;
  }
  aaj(v) {
    this.paj();
    if (!(this.q9t_1 === v)) {
      this.q9t_1 = v;
      this.yaj();
    }
  }
  baj() {
    this.paj();
    return this.q9t_1;
  }
  caj(value) {
    this.yai(value.t2h_1);
    this.aaj(value.u2h_1);
  }
  daj() {
    return Scale.v2h(this.zai(), this.baj());
  }
  eaj() {
    this.paj();
    return this.r9t_1;
  }
  faj() {
    this.paj();
    return this.s9t_1;
  }
  rbi(v) {
    this.paj();
    if (!equals(this.t9t_1, v)) {
      this.t9t_1 = v;
      this.yaj();
    }
  }
  gaj() {
    this.paj();
    return this.t9t_1;
  }
  haj() {
    var tmp0_safe_receiver = this.k28();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gak(Vector2D.k2c(this.b6j(), this.c6j()));
    return tmp1_elvis_lhs == null ? Vector2D.k2c(this.b6j(), this.c6j()) : tmp1_elvis_lhs;
  }
  iaj(value) {
    this.oae(value);
  }
  f1() {
    return this.pae();
  }
  oae(value) {
    var size = this.f1();
    this.caj(Scale.v2h((this.zai() === 0.0 ? 1.0 : this.zai()) * (value.f2b_1 / size.f2b_1), (this.baj() === 0.0 ? 1.0 : this.baj()) * (value.g2b_1 / size.g2b_1)));
  }
  pae() {
    return this.l9z().f1();
  }
  jaj(value) {
    this.oae(this.pae().k2k(value));
  }
  kaj() {
    return this.pae().f2b_1;
  }
  laj() {
    return this.pae().g2b_1;
  }
  tbi(value) {
    this.jaj(this.zai() === 0.0 ? value : value / this.zai());
  }
  ubi(value) {
    this.jaj(value);
  }
  d2m() {
    return this.kaj();
  }
  e2m() {
    return this.laj();
  }
  s4f(v) {
    if (!(v === this.g9u_1.u4f())) {
      this.g9u_1.s4f(v);
      this.pah();
    }
  }
  u4f() {
    return this.g9u_1.u4f();
  }
  maj(v) {
    this.naj(v);
  }
  naj(v) {
    if (!(this.g9u_1.r4f() === v)) {
      this.g9u_1.q4f(v);
      this.pah();
    }
  }
  oaj() {
    return this.g9u_1.r4f();
  }
  paj() {
    if (this.z9t_1)
      return Unit_instance;
    this.z9t_1 = true;
    var t = this.b9u_1.z2e();
    this.n9t_1 = t.l2f_1;
    this.o9t_1 = t.m2f_1;
    this.p9t_1 = t.n2f_1;
    this.q9t_1 = t.o2f_1;
    this.r9t_1 = t.p2f_1;
    this.s9t_1 = t.q2f_1;
    this.t9t_1 = t.r2f_1;
  }
  e28() {
    var tmp0_safe_receiver = this.k28();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e28();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  }
  ba5() {
    return this.j9t_1;
  }
  ma1(_set____db54di) {
    this.w9t_1 = _set____db54di;
  }
  ja1() {
    return this.w9t_1;
  }
  qaj(_set____db54di) {
    this.x9t_1 = _set____db54di;
  }
  raj() {
    return this.x9t_1;
  }
  i8q(value) {
    if (!(this.y9t_1 === value)) {
      this.y9t_1 = value;
      this.oah();
    }
  }
  saj() {
    return this.y9t_1;
  }
  taj() {
    if (!this.a9u_1) {
      this.a9u_1 = true;
      this.o9u_1 = true;
      this.b9u_1 = Companion_getInstance_30().y2d(this.b6j(), this.c6j(), this.gaj(), this.zai(), this.baj(), this.eaj(), this.faj(), 0.0, 0.0);
    }
    return this.b9u_1;
  }
  n9z() {
    if (!(this.d9u_1 === this.m9u_1)) {
      this.d9u_1 = this.m9u_1;
      this.o9u_1 = true;
      this.c9u_1 = !(this.k28() == null) ? this.taj().a2e(ensureNotNull(this.k28()).n9z()) : this.taj();
    }
    return this.c9u_1;
  }
  uaj() {
    if (!(this.f9u_1 === this.m9u_1)) {
      this.f9u_1 = this.m9u_1;
      this.o9u_1 = true;
      this.e9u_1 = this.n9z().y2e();
    }
    return this.e9u_1;
  }
  vaj() {
    updateRenderColorTransformIfRequired(this);
    return this.h9u_1;
  }
  waj() {
    updateRenderBlendModeIfRequired(this);
    return this.j9u_1;
  }
  xaj() {
    updateRenderColorTransformIfRequired(this);
    return this.h9u_1.u4f();
  }
  wb3(views) {
    return this.pa1(views.m9q_1.q8b());
  }
  yaj() {
    this.a9u_1 = false;
    this.oah();
  }
  oah() {
    this.m9u_1 = this.m9u_1 + 1 | 0;
    this.o9u_1 = false;
    this.l9u_1 = true;
    this.kah();
  }
  zaj() {
    if (!(this.q9u_1 == null)) {
      this.q9u_1 = null;
      var tmp0_safe_receiver = this.k28();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.zaj();
      }
    }
  }
  aak() {
    this.sae();
  }
  bak() {
    this.sae();
  }
  sae() {
  }
  kah() {
    var tmp0_safe_receiver = this.k9t_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.mah(this);
    }
    this.zaj();
  }
  pah() {
    this.n9u_1 = this.n9u_1 + 1 | 0;
    this.p9u_1 = false;
    this.l9u_1 = true;
    this.kah();
  }
  qae(ctx) {
    if (!this.saj())
      return Unit_instance;
    var tmp0_safe_receiver = this.s9u_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = tmp0_safe_receiver.o10_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].ubp(this, ctx);
      }
    }
    try {
      this.cak(ctx);
    }finally {
      var tmp1_safe_receiver = this.s9u_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp1_safe_receiver.o10_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array_0[(tmp1_safe_receiver.f1() - n_0 | 0) - 1 | 0].vbp(this, ctx);
          n_0 = n_0 + 1 | 0;
        }
      }
    }
  }
  cak(ctx) {
    var oldPhase = this.t9u_1;
    try {
      this.t9u_1 = 0;
      this.dak(ctx);
    }finally {
      this.t9u_1 = oldPhase;
    }
  }
  dak(ctx) {
    var stages = this.s9u_1;
    if (!(stages == null) && this.t9u_1 < stages.f1()) {
      var _unary__edvuaz = this.t9u_1;
      this.t9u_1 = _unary__edvuaz + 1 | 0;
      stages.e1(_unary__edvuaz).wbp(this, ctx);
    } else {
      var tmp = this.t9u_1;
      var tmp1_elvis_lhs = stages == null ? null : stages.f1();
      if (equals(tmp, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs)) {
        this.uae(ctx);
        this.t9u_1 = this.t9u_1 + 1 | 0;
      }
    }
  }
  zah(ctx) {
    if (this.r9u_1 || this === get_debugAnnotateView(ctx)) {
      this.eak(ctx);
    }
  }
  eak(ctx) {
    var local = this.l9z();
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_0 = get_debugLineRenderContext(ctx);
    var this_1 = this_0.k8h_1;
    if (!(this_1.n88_1 === this_0)) {
      this_1.n88_1 = this_0;
      this_1.x89();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_2 = get_debugLineRenderContext(ctx);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory_0(this_2);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(null == null))
          this_2.w8h_1 = null;
        // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_13().a87_1;
          var doUpdate = !(this_0.v8h_1 === blending);
          var old = this_0.v8h_1;
          try {
            if (doUpdate) {
              this_0.k8h_1.x89();
              this_0.v8h_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
            var color = Colors_getInstance().i40_1;
            var m = this_0.w8h_1;
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var oldColor = this_0.n8h_1;
            this_0.n8h_1 = color;
            try {
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
              // Inline function 'kotlin.apply' call
              var this_3 = new VectorPath();
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>.<anonymous>' call
              this_3.x3q(this.rak());
              this_0.c8i(this_3, m);
            }finally {
              this_0.n8h_1 = oldColor;
            }
            break $l$block;
          }finally {
            if (doUpdate) {
              this_0.k8h_1.x89();
            }
            this_0.v8h_1 = old;
          }
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_0 = Colors_getInstance().i40_1;
        var m_0 = this_0.w8h_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_0 = this_0.n8h_1;
        this_0.n8h_1 = color_0;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_4 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          this_4.t3h(this.gak(Vector2D.k2c(local.r2a(), local.t2a())));
          this_4.g3i(this.gak(Vector2D.k2c(local.s2a(), local.t2a())));
          this_4.g3i(this.gak(Vector2D.k2c(local.s2a(), local.u2a())));
          this_4.g3i(this.gak(Vector2D.k2c(local.r2a(), local.u2a())));
          this_4.n6();
          this_0.c8i(this_4, m_0);
        }finally {
          this_0.n8h_1 = oldColor_0;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_1 = Colors_getInstance().w45_1;
        var m_1 = this_0.w8h_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_1 = this_0.n8h_1;
        this_0.n8h_1 = color_1;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_5 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var anchorSize = 6.0 * ensureNotNull(get_views(ctx)).d8h();
          this_5.c3r(this.gak(local.j2b()), anchorSize);
          this_5.c3r(this.gak(local.k2i()), anchorSize);
          this_5.c3r(this.gak(local.l2b()), anchorSize);
          this_5.c3r(this.gak(local.l2i()), anchorSize);
          this_5.c3r(this.gak(interpolate(Companion_getInstance_34().oz_1, local.j2b(), local.k2i())), anchorSize);
          this_5.c3r(this.gak(interpolate(Companion_getInstance_34().oz_1, local.k2i(), local.l2b())), anchorSize);
          this_5.c3r(this.gak(interpolate(Companion_getInstance_34().oz_1, local.l2b(), local.l2i())), anchorSize);
          this_5.c3r(this.gak(interpolate(Companion_getInstance_34().oz_1, local.l2i(), local.j2b())), anchorSize);
          this_0.c8i(this_5, m_1);
        }finally {
          this_0.n8h_1 = oldColor_1;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_2 = Colors_getInstance().k40_1;
        var m_2 = this_0.w8h_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_2 = this_0.n8h_1;
        this_0.n8h_1 = color_2;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_6 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var center = this.haj();
          this_6.w3q(Vector2D.k2c(center.a2a_1, center.b2a_1 - 5), Vector2D.k2c(center.a2a_1, center.b2a_1 + 5));
          this_6.w3q(Vector2D.k2c(center.a2a_1 - 5, center.b2a_1), Vector2D.k2c(center.a2a_1 + 5, center.b2a_1));
          this_0.c8i(this_6, m_2);
        }finally {
          this_0.n8h_1 = oldColor_2;
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
  }
  toString() {
    var out = get_portableSimpleName(getKClassFromExpression(this));
    if (!(this.b6j() === 0.0) || !(this.c6j() === 0.0))
      out = out + (':pos=(' + this.fak(this.b6j()) + ',' + this.fak(this.c6j()) + ')');
    if (!(this.zai() === 1.0) || !(this.baj() === 1.0))
      out = out + (':scale=(' + this.fak(this.zai()) + ',' + this.fak(this.baj()) + ')');
    if (!equals(this.eaj(), Companion_getInstance_31().r29_1) || !equals(this.faj(), Companion_getInstance_31().r29_1))
      out = out + (':skew=(' + this.fak(_Angle___get_degrees__impl__qg56vw(this.eaj())) + ',' + this.fak(_Angle___get_degrees__impl__qg56vw(this.faj())) + ')');
    if (!equals(_Angle___get_absoluteValue__impl__4qoakv(this.gaj()), Companion_getInstance_31().r29_1))
      out = out + (':rotation=(' + this.fak(_Angle___get_degrees__impl__qg56vw(this.gaj())) + '\xBA)');
    if (!(this.l9t_1 == null))
      out = out + (':name=(' + this.l9t_1 + ')');
    if (!this.m9t_1.equals(Companion_getInstance_13().r86_1))
      out = out + (':blendMode=(' + this.m9t_1.toString() + ')');
    if (!this.saj())
      out = out + (':visible=' + this.saj());
    if (!(this.oaj() === 1.0))
      out = out + (':alpha=' + niceStr(this.oaj(), 2));
    if (!(_RGBA___get_rgb__impl__tijaqt(this.u4f()) === _RGBA___get_rgb__impl__tijaqt(Colors_getInstance().g40_1)))
      out = out + (':colorMul=' + _RGBA___get_hexString__impl__kocngm(this.u4f()));
    return out;
  }
  fak(_this__u8e3s4) {
    return toStringDecimal(_this__u8e3s4, 2, true);
  }
  pa1(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.uaj();
      if (this_0.p2a()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.k2c(this_0.e2e(p.a2a_1, p.b2a_1), this_0.h2e(p.a2a_1, p.b2a_1));
    }
    return tmp$ret$0;
  }
  gak(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.n9z();
      if (this_0.p2a()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.k2c(this_0.e2e(p.a2a_1, p.b2a_1), this_0.h2e(p.a2a_1, p.b2a_1));
    }
    return tmp$ret$0;
  }
  k9z(p) {
    if (!this.u9u_1)
      return null;
    if (!this.saj())
      return null;
    if (this.raj()) {
      var tmp0_safe_receiver = this.nah();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
        var n = 0;
        while (n < tmp0_safe_receiver.f1()) {
          // Inline function 'korlibs.korge.view.View.mouseHitTest.<anonymous>' call
          var tmp0_safe_receiver_0 = tmp0_safe_receiver.e1((tmp0_safe_receiver.f1() - n | 0) - 1 | 0).k9z(p);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            return tmp0_safe_receiver_0;
          }
          n = n + 1 | 0;
        }
      }
    }
    if (!this.ja1())
      return null;
    var tmp1_safe_receiver = this.jak(p);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var area = this.hak();
      if (!area.p2a() && !area.g2c(p))
        return null;
      return tmp1_safe_receiver;
    }
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      tmp = null;
    }
    return tmp;
  }
  hak() {
    var out = Companion_getInstance_28().x2a_1;
    var count = 0;
    // Inline function 'korlibs.korge.view.forEachAscendant' call
    var view = this;
    if (!true) {
      var tmp0_safe_receiver = view;
      view = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k28();
    }
    while (!(view == null)) {
      // Inline function 'korlibs.korge.view.View.getClippingAreaInternal.<anonymous>' call
      var it = view;
      var tmp;
      var tmp_0;
      if (!(it instanceof Stage)) {
        tmp_0 = it instanceof FixedSizeContainer;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = it.a5p();
      } else {
        tmp = false;
      }
      if (tmp) {
        var _localBounds = it.tak();
        if (count === 0) {
          out = _localBounds;
        } else {
          out = out.s2i(_localBounds);
        }
        count = count + 1 | 0;
      }
      view = view.k28();
    }
    return count === 0 ? Companion_getInstance_28().z2a() : out;
  }
  iak(p, direction) {
    if (!this.u9u_1)
      return null;
    var ll = this.pa1(p);
    var bounds = this.l9z();
    if (!bounds.g2c(ll)) {
      return null;
    }
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.v2e(this.hai(), this.iai());
    var l = Vector2D.k2c(ll.a2a_1 + that.a2a_1, ll.b2a_1 + that.b2a_1);
    if (this.v9u_1 === false)
      return this;
    var hitShape = this.jai();
    var hitShapes = this.kai();
    if (this.v9u_1 == null && (!(hitShape == null) || !(hitShapes == null))) {
      if (hitShapes == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < hitShapes.f1()) {
          // Inline function 'korlibs.korge.view.View.hitTestInternal.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          if (hitShapes.e1(_unary__edvuaz).j3r(l))
            return this;
        }
      }
      if (!(hitShape == null) && hitShape.j3r(l))
        return this;
      return null;
    } else {
      return this;
    }
  }
  jak(p, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.iak(p, direction) : $super.iak.call(this, p, direction);
  }
  kak() {
    var tmp0_safe_receiver = this.k28();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.fai(this);
  }
  lak(target, inclusive) {
    var tmp;
    if (target === this.k28()) {
      tmp = this.taj();
    } else if (target === this) {
      tmp = Companion_getInstance_30().m2d_1;
    } else {
      var commonAncestor = Companion_instance_23.tbp(this, target);
      var tmp_0;
      if (!(commonAncestor === null)) {
        if (target.k28() == null && inclusive) {
          return this.n9z();
        }
        tmp_0 = this.n9z().a2e(target.uaj());
      } else {
        tmp_0 = Companion_getInstance_30().m2d_1;
      }
      tmp = tmp_0;
    }
    var out = tmp;
    if (inclusive) {
      out = out.a2e(target.taj());
    }
    return out;
  }
  mak() {
    var tmp0_elvis_lhs = this.nak();
    return tmp0_elvis_lhs == null ? this.tak() : tmp0_elvis_lhs;
  }
  nak() {
    var stage = this.e28();
    if (!(stage instanceof Stage))
      return null;
    return this.oak(stage);
  }
  oak(bp) {
    return this.tak().a2j(bp.z8g());
  }
  pak(ctx) {
    return ctx.k8i() ? this.oak(ctx) : this.tak();
  }
  qak(ctx) {
    return this.pak(ctx);
  }
  rak() {
    return this.tak();
  }
  sak(includeFilters) {
    return this.wak(this.e28(), VOID, true, includeFilters);
  }
  tak(includeFilters, $super) {
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.sak(includeFilters) : $super.sak.call(this, includeFilters);
  }
  uak(concat, doAnchoring, includeFilters) {
    var out = this.xak(doAnchoring, includeFilters);
    if (concat.q2a() && !concat.b2e()) {
      var tmp = Companion_getInstance_29();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p = out.j2b();
        if (concat.p2a()) {
          tmp$ret$0 = p;
          break $l$block;
        }
        tmp$ret$0 = Vector2D.k2c(concat.e2e(p.a2a_1, p.b2a_1), concat.h2e(p.a2a_1, p.b2a_1));
      }
      var tmp_0 = tmp$ret$0;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_0 = out.k2i();
        if (concat.p2a()) {
          tmp$ret$1 = p_0;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.k2c(concat.e2e(p_0.a2a_1, p_0.b2a_1), concat.h2e(p_0.a2a_1, p_0.b2a_1));
      }
      var tmp_1 = tmp$ret$1;
      var tmp$ret$2;
      $l$block_1: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = out.l2b();
        if (concat.p2a()) {
          tmp$ret$2 = p_1;
          break $l$block_1;
        }
        tmp$ret$2 = Vector2D.k2c(concat.e2e(p_1.a2a_1, p_1.b2a_1), concat.h2e(p_1.a2a_1, p_1.b2a_1));
      }
      var tmp_2 = tmp$ret$2;
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_2 = out.l2i();
        if (concat.p2a()) {
          tmp$ret$3 = p_2;
          break $l$block_2;
        }
        tmp$ret$3 = Vector2D.k2c(concat.e2e(p_2.a2a_1, p_2.b2a_1), concat.h2e(p_2.a2a_1, p_2.b2a_1));
      }
      out = _BoundsBuilder___get_bounds__impl__s1l1gx(tmp.b2b(tmp_0, tmp_1, tmp_2, tmp$ret$3));
    }
    return out;
  }
  vak(target, doAnchoring, inclusive, includeFilters) {
    return this.uak(this.lak(target == null ? this : target, inclusive), doAnchoring, includeFilters);
  }
  wak(target, doAnchoring, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.vak(target, doAnchoring, inclusive, includeFilters) : $super.vak.call(this, target, doAnchoring, inclusive, includeFilters);
  }
  xak(doAnchoring, includeFilters) {
    var tmp0_elvis_lhs = this.q9u_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.rae();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getLocalBounds.<anonymous>' call
      this.q9u_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var out = tmp;
    if (!doAnchoring) {
      out = out.q2e(Vector2D.v2e(this.hai(), this.iai()));
    }
    if (includeFilters) {
      var tmp1_safe_receiver = get_filter(this);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        out = expandedBorderRectangle(tmp1_safe_receiver, out);
      }
    }
    return out;
  }
  l9z(doAnchoring, includeFilters, $super) {
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.xak(doAnchoring, includeFilters) : $super.xak.call(this, doAnchoring, includeFilters);
  }
  rae() {
    return Companion_getInstance_28().z2a();
  }
  e6f(type, event, result) {
    var tmp0_safe_receiver = this.k28();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.l6f(type, event, result);
  }
}
class Container extends View {
  static za4(cull) {
    cull = cull === VOID ? false : cull;
    var $this = this.tb3(true);
    $this.qa4_1 = cull;
    $this.ra4_1 = FastArrayList.q10();
    $this.sa4_1 = new ContainerCollection($this, $this.ra4_1);
    $this.ta4_1 = null;
    $this.ua4_1 = new MMatrix();
    $this.va4_1 = false;
    $this.wa4_1 = false;
    $this.xa4_1 = FastArrayList.q10();
    return $this;
  }
  nah() {
    return this.ra4_1;
  }
  oah() {
    super.oah();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.sa4_1;
    var n = 0;
    while (n < this_0.f1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidate.<anonymous>' call
      var child = this_0.e1(_unary__edvuaz);
      if (child.o9u_1) {
        child.oah();
      }
    }
  }
  pah() {
    super.pah();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.sa4_1;
    var n = 0;
    while (n < this_0.f1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidateColorTransform.<anonymous>' call
      var child = this_0.e1(_unary__edvuaz);
      if (child.p9u_1) {
        child.pah();
      }
    }
  }
  qah() {
    return this.ra4_1.f1();
  }
  rah(view) {
  }
  sah(view) {
  }
  sae() {
    super.sae();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.nah();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.f1()) {
        // Inline function 'korlibs.korge.view.Container.onAncestorChanged.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.e1(_unary__edvuaz).bak();
      }
      tmp = Unit_instance;
    }
  }
  tah(index) {
    return this.ra4_1.e1(index);
  }
  uah(index) {
    return this.vah(index, 1) === 1;
  }
  vah(index, count) {
    if (count <= 0 || index < 0)
      return 0;
    var from = index;
    // Inline function 'kotlin.comparisons.minOf' call
    var a = index + count | 0;
    var b = this.qah();
    var to = Math.min(a, b);
    var inductionVariable = from;
    if (inductionVariable < to)
      do {
        var removedIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var view = this.tah(removedIndex);
        view.qai(null);
        view.lai(-1);
      }
       while (inductionVariable < to);
    this.ra4_1.k7(from, to);
    var inductionVariable_0 = index;
    var last = this.qah();
    if (inductionVariable_0 < last)
      do {
        var i = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.ra4_1.e1(i).lai(i);
      }
       while (inductionVariable_0 < last);
    this.bai();
    this.cai();
    this.zaj();
    return to - from | 0;
  }
  wah() {
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.sa4_1;
    var n = 0;
    while (n < this_0.f1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.removeChildren.<anonymous>' call
      var child = this_0.e1(_unary__edvuaz);
      child.qai(null);
      child.lai(-1);
    }
    this.ra4_1.k3();
    this.bai();
  }
  xah(view) {
    return this.eai(view, this.qah());
  }
  ya4(view) {
    this.eai(view, this.qah());
  }
  e1(index) {
    return this.tah(index);
  }
  uae(ctx) {
    if (!this.saj())
      return Unit_instance;
    this.yah(ctx);
  }
  yah(ctx) {
    if (!this.qa4_1) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
      if (!this.va4_1) {
        this.va4_1 = true;
        this.xa4_1.k3();
        this.xa4_1.g1(this.sa4_1);
        if (this.aai())
          this.wa4_1 = false;
      }
      if (!this.wa4_1) {
        this.wa4_1 = true;
        sortWith(this.xa4_1, ZIndexComparator_instance);
      }
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.xa4_1.o10_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
        array[_unary__edvuaz].qae(ctx);
      }
      return Unit_instance;
    }
    var tmp = findFirstAscendant(this, Container$renderChildrenInternal$lambda);
    var clippingContainer = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
    var renderedCount = 0;
    var culledCount = 0;
    var tmp1_elvis_lhs = clippingContainer == null ? null : clippingContainer.tak();
    var bounds = tmp1_elvis_lhs == null ? Companion_getInstance_28().z2a() : tmp1_elvis_lhs;
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.va4_1) {
      this.va4_1 = true;
      this.xa4_1.k3();
      this.xa4_1.g1(this.sa4_1);
      if (this.aai())
        this.wa4_1 = false;
    }
    if (!this.wa4_1) {
      this.wa4_1 = true;
      sortWith(this.xa4_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.xa4_1.o10_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
      var child = array_0[_unary__edvuaz_0];
      if (bounds.p2a() || bounds.p2i(child.sak(true))) {
        child.qae(ctx);
        renderedCount = renderedCount + 1 | 0;
      } else {
        culledCount = culledCount + 1 | 0;
      }
    }
  }
  zah(ctx) {
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.va4_1) {
      this.va4_1 = true;
      this.xa4_1.k3();
      this.xa4_1.g1(this.sa4_1);
      if (this.aai())
        this.wa4_1 = false;
    }
    if (!this.wa4_1) {
      this.wa4_1 = true;
      sortWith(this.xa4_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.xa4_1.o10_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderDebug.<anonymous>' call
      array[_unary__edvuaz].zah(ctx);
    }
    super.zah(ctx);
  }
  rae() {
    var bb = Companion_getInstance_29().a2b();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.sa4_1;
    var n = 0;
    while (n < this_0.f1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.getLocalBoundsInternal.<anonymous>' call
      var child = this_0.e1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, child.wak(this));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  aai() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.ra4_1.o10_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.shouldSortChildren.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(array[_unary__edvuaz].vai() === 0.0)) {
        return true;
      }
    }
    return false;
  }
  bai() {
    this.va4_1 = false;
    this.cai();
  }
  cai() {
    var tmp0_safe_receiver = this.ba5();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ka1();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.mah(this);
    }
  }
  dai(child) {
    var parent = this;
    if (parent === child) {
      invalidOp("Can't addChild to itself");
    }
    if (hasAncestor(parent, child)) {
      invalidOp("Can't addChild to an ancestor");
    }
  }
  eai(view, index) {
    this.dai(view);
    var tmp0_safe_receiver = view.k28();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.bai();
    }
    view.kak();
    var aindex = clamp_1(index, 0, this.qah());
    var children = this.ra4_1;
    children.i7(aindex, view);
    var inductionVariable = aindex;
    var last = this.qah();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        children.e1(n).lai(n);
      }
       while (inductionVariable < last);
    view.qai(this);
    view.oah();
    this.rah(view);
    this.bai();
    this.cai();
    this.zaj();
  }
  fai(view) {
    if (!((view == null ? null : view.k28()) === this))
      return false;
    return this.uah(view.u6l());
  }
  b6f(type, event, result) {
    if (this.ta4_1 == null)
      this.ta4_1 = FastArrayList.p10(this.sa4_1.f1());
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
    var this_0 = this.ra4_1;
    var temp = ensureNotNull(this.ta4_1);
    toFastList(this_0, temp);
    try {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = temp.o10_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.dispatchChildren.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].k6f(type, event, result);
      }
    }finally {
      temp.k3();
    }
  }
}
class CachedContainer extends Container {
  static nay(cache, renderQuality) {
    cache = cache === VOID ? true : cache;
    renderQuality = renderQuality === VOID ? null : renderQuality;
    var $this = this.za4();
    $this.dah_1 = cache;
    $this.eah_1 = renderQuality;
    $this.fah_1 = null;
    $this.gah_1 = true;
    $this.hah_1 = -1.0;
    $this.iah_1 = Companion_getInstance_28().p2d();
    $this.jah_1 = Scale.s2j(1);
    return $this;
  }
  kah() {
    super.kah();
    this.gah_1 = true;
  }
  uae(ctx) {
    if (!this.saj())
      return Unit_instance;
    if (!this.dah_1) {
      return super.uae(ctx);
    }
    if (this.fah_1 == null) {
      this.fah_1 = new CacheTexture(this, ctx);
      this.gah_1 = true;
    }
    var cache = ensureNotNull(this.fah_1);
    ctx.o8i(cache);
    var renderScale = ctx.e8i().r3_1 === 0 ? 1.0 : ctx.w8i();
    var tmp1_elvis_lhs = this.eah_1;
    var doExpensiveScaling = !get_isLow(tmp1_elvis_lhs == null ? ctx.e8i() : tmp1_elvis_lhs);
    if (this.gah_1 || !(this.hah_1 === renderScale)) {
      this.hah_1 = renderScale;
      this.iah_1 = this.l9z(VOID, false);
      this.jah_1 = doExpensiveScaling ? this.mak().f1().u2j(this.iah_1.f1()) : Scale.s2j(1);
      this.gah_1 = false;
      var texWidth = coerceAtLeast(numberToInt(this.iah_1.m2a_1 * renderScale * this.jah_1.t2h_1), 1);
      var texHeight = coerceAtLeast(numberToInt(this.iah_1.n2a_1 * renderScale * this.jah_1.u2h_1), 1);
      cache.tay(texWidth, texHeight);
      ctx.x89();
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      var frameBuffer = cache.pay_1;
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.t8i(frameBuffer);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_0 = ctx.j88_1;
        var this_1 = this_0.s88_1;
        if (!(this_1.n88_1 === this_0)) {
          this_1.n88_1 = this_0;
          this_1.x89();
        }
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var scissor = AGScissor.o6y(0, 0, frameBuffer.r6n_1, frameBuffer.s6n_1);
          var temp = this_0.q89_1;
          this_0.z8f();
          this_0.q89_1 = scissor;
          try {
            if (true) {
              ctx.m8i(Colors_getInstance().l40_1);
            }
            // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>' call
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
            var matrix = this.uaj().s2e(-this.iah_1.k2a_1, -this.iah_1.l2a_1).m2e(renderScale * this.jah_1.t2h_1, renderScale * this.jah_1.u2h_1);
            ctx.x89();
            var temp4 = ctx.y87_1;
            var temp2d = ctx.z87_1;
            ctx.z87_1 = matrix;
            ctx.y87_1 = toMatrix4(matrix);
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var this_2 = ctx.a6v(ProjViewUB_getInstance());
              var _unary__edvuaz = this_2.p6w();
              this_2.g7j(_unary__edvuaz + 1 | 0);
              this_2.h7j(this_2.p6w() + 1 | 0);
              var blockSize = this_2.t6u_1;
              var index0 = imul(this_2.p6w() - 1 | 0, blockSize);
              var index1 = imul(this_2.p6w(), blockSize);
              var texBlockSize = this_2.q6u_1.p72().f1();
              var texIndex0 = imul(this_2.p6w() - 1 | 0, texBlockSize);
              var texIndex1 = imul(this_2.p6w(), texBlockSize);
              if (this_2.p6w() > 0) {
                arraycopy(this_2.v6u_1, index0, this_2.v6u_1, index1, blockSize);
              } else {
                arrayfill(this_2.v6u_1, 0, 0, blockSize);
              }
              // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
              var $this$push = this_2.q6u_1;
              this_2.w6u_1.q7j($this$push.o72(), ctx.y87_1);
              if (true && this_2.p6w() >= 1) {
                var equals = arrayequal(this_2.v6u_1, index0, this_2.v6u_1, index1, blockSize);
                if (equals) {
                  var _unary__edvuaz_0 = this_2.p6w();
                  this_2.g7j(_unary__edvuaz_0 - 1 | 0);
                  break $l$block;
                }
              }
            }
            try {
              // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>.<anonymous>' call
              super.uae(ctx);
            }finally {
              ctx.x89();
              ctx.y87_1 = temp4;
              ctx.z87_1 = temp2d;
              ctx.a6v(ProjViewUB_getInstance()).i7j();
            }
            break $l$block_0;
          }finally {
            this_0.z8f();
            this_0.q89_1 = temp;
          }
        }
      }finally {
        ctx.u8i();
      }
    }
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_3 = ctx.j88_1;
    var this_4 = this_3.s88_1;
    if (!(this_4.n88_1 === this_3)) {
      this_4.n88_1 = this_3;
      this_4.x89();
    }
    this_3.z89(cache.ray_1, VOID, VOID, VOID, VOID, this.n9z().w2e(this.iah_1.k2a_1, this.iah_1.l2a_1).o2e(1.0 / (renderScale * this.jah_1.t2h_1), 1.0 / (renderScale * this.jah_1.u2h_1)), VOID, this.xaj(), this.m9t_1);
  }
  lah() {
    return this;
  }
  mah(view) {
    this.gah_1 = true;
    var tmp0_safe_receiver = this.k28();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k9t_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.mah(view);
    }
  }
}
class FixedSizeCachedContainer extends CachedContainer {
  static xap(size, cache, clip) {
    size = size === VOID ? Size2D.h2b(100, 100) : size;
    cache = cache === VOID ? true : cache;
    clip = clip === VOID ? true : clip;
    var $this = this.nay(cache);
    $this.uap_1 = clip;
    $this.vap_1 = size;
    $this.wap_1 = Ref(false);
    return $this;
  }
  oae(_set____db54di) {
    this.vap_1 = _set____db54di;
  }
  pae() {
    return this.vap_1;
  }
  rae() {
    return new Rectangle(0.0, 0.0, this.d2m(), this.e2m());
  }
  uae(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.uap_1;
      var renderingInternalRef = this.wap_1;
      if (renderingInternalRef.s1()) {
        super.uae(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.n9z();
        var hasRotation = !(m.s2d_1 === 0.0) || !(m.t2d_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.s1();
          try {
            renderingInternalRef.f2v(true);
            renderFiltered(this, ctx, Companion_getInstance_49());
          }finally {
            renderingInternalRef.f2v(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.j88_1;
        if (!(ctx.n88_1 === batcher)) {
          ctx.n88_1 = batcher;
          ctx.x89();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.l88_1;
        var bounds = this.qak(ctx).a2j(ctx.z87_1).b2j();
        var rect = c2d.a8j_1.j8f().w6y();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.p2i(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_14().r6y(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.a8j_1;
            var scissor_0 = c2d.i8j(scissor);
            var temp = this_0.q89_1;
            this_0.z8f();
            this_0.q89_1 = scissor_0;
            try {
              super.uae(ctx);
              break $l$block_1;
            }finally {
              this_0.z8f();
              this_0.q89_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
          super.uae(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
        super.uae(ctx);
      }
    }
  }
}
class UIView extends FixedSizeCachedContainer {
  static jae(size, cache) {
    Companion_getInstance_40();
    size = size === VOID ? Companion_getInstance_40().ean_1 : size;
    cache = cache === VOID ? false : cache;
    var $this = this.xap(size, cache, false);
    $this.hae_1 = size;
    $this.iae_1 = false;
    return $this;
  }
  oae(value) {
    if (!this.hae_1.equals(value)) {
      this.hae_1 = value;
      this.lae();
    }
  }
  pae() {
    return this.hae_1;
  }
  rae() {
    return new Rectangle(0.0, 0.0, this.d2m(), this.e2m());
  }
  lae() {
    var tmp0_safe_receiver = this.k28();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.sah(this);
    }
  }
  sae() {
    super.sae();
    this.tae();
  }
  tae() {
    this.oah();
  }
  uae(ctx) {
    registerUISupportOnce(this);
    super.uae(ctx);
  }
}
class SceneContainer extends UIView {
  static w9x(views, defaultTransition, name, size) {
    Companion_getInstance_39();
    defaultTransition = defaultTransition === VOID ? withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_33())) : defaultTransition;
    name = name === VOID ? 'sceneContainer' : name;
    size = size === VOID ? views.v9r_1.f1() : size;
    var $this = this.jae(size);
    $this.q9x_1 = views;
    $this.r9x_1 = defaultTransition;
    $this.l9t_1 = name;
    var tmp = $this;
    // Inline function 'kotlin.also' call
    var this_0 = TransitionView.kae();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.transitionView.<anonymous>' call
    $this.ya4(this_0);
    tmp.s9x_1 = this_0;
    $this.t9x_1 = null;
    var tmp_0 = Companion_instance_8;
    $this.x6e(tmp_0, SceneContainer$lambda($this));
    $this.u9x_1 = arrayListOf([Companion_getInstance_39().sa8_1]);
    $this.v9x_1 = 0;
    return $this;
  }
  lae() {
    var tmp0_safe_receiver = this.t9x_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.wa7(Size2D.f2i(this.d2m(), this.e2m()));
    }
  }
  mae(clazz, injects, time, transition, $completion) {
    this.nae(new VisitEntry(clazz, toList(injects)));
    return _changeTo(this, clazz, injects.slice(), time, transition, $completion);
  }
  x9x(clazz, injects, time, transition, $completion, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    transition = transition === VOID ? this.r9x_1 : transition;
    return $super === VOID ? this.mae(clazz, injects, time, transition, $completion) : $super.mae.call(this, clazz, injects, new Duration(time), transition, $completion);
  }
  ta8(newScene, time, transition, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq_0.bind(VOID, this, newScene, time, transition), $completion);
  }
  nae(entry) {
    while (this.u9x_1.f1() <= this.v9x_1) {
      this.u9x_1.h(Companion_getInstance_39().sa8_1);
    }
    this.u9x_1.o3(this.v9x_1, entry);
  }
  b17() {
    return this.q9x_1.j9q_1;
  }
}
class TransitionProcess {}
function start(prev, next) {
  return Unit_instance;
}
function end(prev, next) {
  return Unit_instance;
}
function render(ctx, prev, next, ratio) {
  return Unit_instance;
}
class TransitionView extends Container {
  static kae() {
    var $this = this.za4();
    dummyView($this);
    dummyView($this);
    $this.iab_1 = Companion_getInstance_34().mz_1;
    $this.jab_1 = get_AlphaTransition();
    return $this;
  }
  n1k() {
    return this.e1(0);
  }
  k1k() {
    return this.e1(1);
  }
  lab(next, transition) {
    this.jab_1 = transition;
    this.iab_1 = Companion_getInstance_34().mz_1;
    this.kab_1 = transition.bal();
    this.cal(this.k1k(), next);
    _get_transitionProcess__5hlux5(this).yak(this.n1k(), this.k1k());
  }
  toString() {
    return super.toString() + (':ratio=' + Ratio__toString_impl_mfgt3e(this.iab_1) + ':transition=' + toString(this.jab_1));
  }
  mab() {
    this.iab_1 = Companion_getInstance_34().pz_1;
    _get_transitionProcess__5hlux5(this).zak(this.n1k(), this.k1k());
    this.cal(dummyView(this), this.k1k());
  }
  cal(prev, next) {
    this.wah();
    this.xah(prev);
    this.xah(next);
  }
  uae(ctx) {
    if (Ratio__compareTo_impl_z2ienc(this.iab_1, Companion_getInstance_34().mz_1) <= 0) {
      this.n1k().qae(ctx);
    } else if (Ratio__compareTo_impl_z2ienc(this.iab_1, Companion_getInstance_34().pz_1) >= 0) {
      this.k1k().qae(ctx);
    } else {
      _get_transitionProcess__5hlux5(this).aal(ctx, this.n1k(), this.k1k(), this.iab_1);
    }
  }
}
class Transition$1 {
  constructor($render, $name) {
    this.dal_1 = $render;
    this.eal_1 = $name;
  }
  bal() {
    return this;
  }
  aal(ctx, prev, next, ratio) {
    return this.dal_1(ctx, prev, next, new Ratio(ratio));
  }
  toString() {
    return this.eal_1;
  }
}
class withEasing$1$create$1 {
  constructor($process, $easing) {
    this.fal_1 = $process;
    this.gal_1 = $easing;
  }
  yak(prev, next) {
    return this.fal_1.yak(prev, next);
  }
  zak(prev, next) {
    return this.fal_1.zak(prev, next);
  }
  aal(ctx, prev, next, ratio) {
    return this.fal_1.aal(ctx, prev, next, this.gal_1.hz(ratio));
  }
}
class withEasing$1 {
  constructor($this_withEasing, $easing) {
    this.hal_1 = $this_withEasing;
    this.ial_1 = $easing;
  }
  toString() {
    return toString(this.hal_1) + '.withEasing';
  }
  bal() {
    var process = this.hal_1.bal();
    return new withEasing$1$create$1(process, this.ial_1);
  }
}
class MsdfRender {
  constructor() {
    MsdfRender_instance = this;
    this.jal_1 = this.nal(true, VOID, false);
    this.kal_1 = this.nal(true, VOID, true);
    this.lal_1 = this.oal(false, 'r', false);
    this.mal_1 = this.oal(false, 'a', false);
  }
  oal(msdf, sdf, inverted) {
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var name = 'PROGRAM_msdf=' + msdf + ',sdf=' + sdf + ',inverted=' + inverted;
    var tmp1_$this = Companion_getInstance_6().v8e_1;
    var tmp2_name = name == null ? Companion_getInstance_6().v8e_1.m6v_1 : name;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.t74();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.text.MsdfRender.createProgram.<anonymous>' call
    var tmp = this_0.k76();
    var tmp_0 = this_0.k76();
    var tmp_1 = this_0.k76();
    var tmp_2 = this_0.k76();
    var median$delegate = this_0.z75(tmp, tmp_0, tmp_1, VOID, tmp_2, MsdfRender$createProgram$lambda).b73(null, getLocalDelegateReference('median', KProperty0, false, function () {
      return THROW_ISE();
    }));
    var tmp_3 = Companion_getInstance_6().s8e_1;
    var tmp_4 = get_BB_MAX_TEXTURES() - 1 | 0;
    this_0.e76(tmp_3, 0, tmp_4, MsdfRender$createProgram$lambda_0(this_0));
    var d = this_0.s76(this_0.m75());
    var alpha = this_0.t76(this_0.m75());
    this_0.y74(this_0.b75(), this_0.x76(this_0.b75(), this_0.f75([this_0.e75(0.5)])));
    if (msdf) {
      this_0.y74(d, this_0.c76(createProgram$_anonymous_$lambda$0_hhid5m(median$delegate), this_0.h75(this_0.b75(), 'r'), this_0.h75(this_0.b75(), 'g'), this_0.h75(this_0.b75(), 'b')));
    } else {
      this_0.y74(d, this_0.h75(this_0.b75(), sdf));
    }
    this_0.y74(alpha, this_0.b76(SDFShaders_getInstance().k8k(), d));
    if (inverted) {
      this_0.y74(alpha, this_0.x76(this_0.e75(1.0), alpha));
    }
    this_0.y74(this_0.b75(), this_0.c75(this_0.z74(), alpha));
    var tmp3_fragment = FragmentShader(this_0.g75());
    return tmp1_$this.e7s(VOID, tmp3_fragment, tmp2_name);
  }
  nal(msdf, sdf, inverted, $super) {
    sdf = sdf === VOID ? 'a' : sdf;
    inverted = inverted === VOID ? false : inverted;
    return $super === VOID ? this.oal(msdf, sdf, inverted) : $super.oal.call(this, msdf, sdf, inverted);
  }
}
class TimerComponents {
  constructor(view) {
    this.pal_1 = view;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.qal_1 = ArrayList.j1();
    this.ral_1 = IntArrayList.m2o();
    this.sal_1 = IntArrayList.m2o();
    this.tal_1 = null;
  }
  val(time, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.s1b();
    // Inline function 'korlibs.korge.time.TimerComponents.wait.<anonymous>' call
    this.wal(time, TimerComponents$wait$lambda(cancellable));
    return cancellable.e19();
  }
  wal(time, callback) {
    return this.xal(get_fast(time), callback);
  }
  xal(time, callback) {
    return _interval(this, time, false, callback);
  }
}
class TimerRef {
  constructor(index) {
    this.ual_1 = index;
  }
  toString() {
    return TimerRef__toString_impl_8hh2j7(this.ual_1);
  }
  hashCode() {
    return TimerRef__hashCode_impl_d9ou9o(this.ual_1);
  }
  equals(other) {
    return TimerRef__equals_impl_2fvpr4(this.ual_1, other);
  }
}
class TweenComponent {
  constructor(view, vs, fastTime, easing, callback, c, fastWaitTime, autoInvalidate) {
    fastTime = fastTime === VOID ? Companion_instance_1.y1x() : fastTime;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    fastWaitTime = fastWaitTime === VOID ? Companion_instance_1.y1x() : fastWaitTime;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    this.yal_1 = view;
    this.zal_1 = vs;
    this.aam_1 = fastTime;
    this.bam_1 = easing;
    this.cam_1 = callback;
    this.dam_1 = c;
    this.eam_1 = fastWaitTime;
    this.fam_1 = autoInvalidate;
    this.gam_1 = Companion_instance_1.x1x();
    var tmp = this;
    var tmp_0;
    if (!equals(this.aam_1, Companion_instance_1.y1x())) {
      tmp_0 = this.aam_1;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.zal_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.b1();
      while (tmp0_iterator.c1()) {
        var item = tmp0_iterator.d1();
        // Inline function 'korlibs.korge.tween.TweenComponent.hrtime.<anonymous>' call
        var tmp$ret$0 = _FastDuration___get_nanoseconds__impl__pxizcb(item.t8l_1);
        destination.h(tmp$ret$0);
      }
      var tmp0_elvis_lhs = maxOrNull(destination);
      tmp_0 = get_fastNanoseconds(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
    }
    tmp.ham_1 = tmp_0;
    this.iam_1 = false;
    this.jam_1 = false;
    this.kam_1 = false;
    var tmp_1 = this;
    var tmp_2 = Companion_instance_9;
    tmp_1.lam_1 = this.yal_1.x6e(tmp_2, TweenComponent$updater$lambda(this));
    var tmp0_safe_receiver = this.dam_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a1a(TweenComponent$lambda(this));
    }
    _update(this, Companion_instance_1.x1x());
  }
  sam() {
    return get_slow(this.eam_1);
  }
  tam() {
    if (this.kam_1)
      return Unit_instance;
    this.kam_1 = true;
    var tmp0_safe_receiver = this.dam_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp0_safe_receiver.bd(tmp$ret$0);
    }
  }
  ram() {
    if (this.jam_1)
      return Unit_instance;
    this.jam_1 = true;
    var tmp0_safe_receiver = this.lam_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.n6();
    }
    this.lam_1 = null;
    this.tam();
  }
  mam(elapsed) {
    if (equals(elapsed, Companion_instance_1.x1x())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.zal_1;
      var n = 0;
      while (n < this_0.f1()) {
        // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.e1(_unary__edvuaz).c3a();
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.zal_1;
    var n_0 = 0;
    while (n_0 < this_1.f1()) {
      // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var v = this_1.e1(_unary__edvuaz_0);
      var durationInTween = equals(v.r8l_1, Companion_instance_1.y1x()) ? FastDuration__minus_impl_evs237(this.ham_1, v.q8l_1) : v.r8l_1;
      var elapsedInTween = get_fastMilliseconds_0(clamp_0(_FastDuration___get_fastMilliseconds__impl__pe68va(FastDuration__minus_impl_evs237(elapsed, v.q8l_1)), 0.0, _FastDuration___get_fastMilliseconds__impl__pe68va(durationInTween)));
      var ratioInTween = FastDuration__compareTo_impl_4fhnj7_0(durationInTween, Companion_getInstance().rj_1) <= 0 || FastDuration__compareTo_impl_4fhnj7(elapsedInTween, durationInTween) >= 0 ? 1.0 : FastDuration__div_impl_rlslck(elapsedInTween, durationInTween);
      var easedRatioInTween = this.bam_1.gz(ratioInTween);
      v.w8l(toRatio(easedRatioInTween));
    }
  }
  toString() {
    return 'TweenComponent(' + toString(this.yal_1) + ')';
  }
}
class tween$slambda {
  constructor($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
    this.uam_1 = $this_tween;
    this.vam_1 = $tc;
    this.wam_1 = $vs;
    this.xam_1 = $time;
    this.yam_1 = $easing;
    this.zam_1 = $callback;
    this.aan_1 = $waitTime;
    this.ban_1 = $autoInvalidate;
  }
  k1q($this$withTimeoutNullable, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this, $this$withTimeoutNullable), $completion);
  }
  de(p1, $completion) {
    return this.k1q((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_18 = this;
    this.can_1 = 90.0;
    this.dan_1 = 32.0;
    this.ean_1 = Size2D.b2i(90.0, 32.0);
  }
}
class InternalViewAutoscaling {
  constructor() {
    this.gav_1 = 1.0;
    this.hav_1 = 1.0;
    this.iav_1 = 1.0;
    this.jav_1 = 1.0;
    this.kav_1 = 1.0;
    this.lav_1 = MatrixTransform.v2f();
  }
  mav(autoScaling, autoScalingPrecise, globalMatrix) {
    if (autoScaling) {
      this.lav_1 = globalMatrix.z2e();
      // Inline function 'kotlin.math.abs' call
      var x = this.lav_1.n2f_1;
      var sx = Math.abs(x);
      // Inline function 'kotlin.math.abs' call
      var x_0 = this.lav_1.o2f_1;
      var sy = Math.abs(x_0);
      // Inline function 'kotlin.math.max' call
      var sxy = Math.max(sx, sy);
      // Inline function 'kotlin.math.abs' call
      var x_1 = sx / this.iav_1 - 1.0;
      var diffX = Math.abs(x_1);
      // Inline function 'kotlin.math.abs' call
      var x_2 = sy / this.jav_1 - 1.0;
      var diffY = Math.abs(x_2);
      var tmp;
      switch (autoScalingPrecise) {
        case true:
          tmp = diffX > 0.0 || diffY > 0.0;
          break;
        case false:
          tmp = diffX >= 0.1 || diffY >= 0.1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var shouldUpdate = tmp;
      if (shouldUpdate) {
        this.iav_1 = sx;
        this.jav_1 = sy;
        this.kav_1 = sxy;
        this.gav_1 = 1.0 / sx;
        this.hav_1 = 1.0 / sy;
        return true;
      }
    } else {
      this.iav_1 = 1.0;
      this.jav_1 = 1.0;
      this.kav_1 = 1.0;
      this.gav_1 = 1.0;
      this.hav_1 = 1.0;
    }
    return false;
  }
}
class RectBase extends View {
  static sbi(anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().b29_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.ob9();
    $this.wax_1 = smoothing;
    $this.lay(hitShape);
    var tmp = $this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    tmp.xax_1 = get_Bitmaps_white();
    $this.yax_1 = anchor;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_15();
    var tmp$ret$1 = get_TEXTURED_ARRAY_QUAD_INDICES();
    tmp_0.zax_1 = new TexturedVertexArray(4, tmp$ret$1);
    $this.aay_1 = null;
    $this.bay_1 = null;
    return $this;
  }
  iay(v) {
    if (!(this.xax_1 === v)) {
      this.xax_1 = v;
      this.l9u_1 = true;
      this.kah();
    }
  }
  yap(v) {
    if (!this.yax_1.equals(v)) {
      this.yax_1 = v;
      this.l9u_1 = true;
      this.kah();
    }
  }
  cay() {
    return this.yax_1;
  }
  uav() {
    return 0.0;
  }
  vav() {
    return 0.0;
  }
  hai() {
    return this.cay().k29_1 * this.uav();
  }
  iai() {
    return this.cay().l29_1 * this.vav();
  }
  day() {
    return -this.hai();
  }
  eay() {
    return -this.iai();
  }
  uae(ctx) {
    if (!this.saj())
      return Unit_instance;
    var tmp = this.xax_1;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    if (tmp === get_Bitmaps_transparent())
      return Unit_instance;
    if (this.l9u_1) {
      this.l9u_1 = false;
      this.kay();
    }
    this.jay(ctx);
  }
  jay(ctx) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.j88_1;
    var this_1 = this_0.s88_1;
    if (!(this_1.n88_1 === this_0)) {
      this_1.n88_1 = this_0;
      this_1.x89();
    }
    var tmp0_safe_receiver = this.bay_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(ctx);
    var array = this.zax_1;
    var tex = ctx.n8i(this.xax_1).a3l();
    var smoothing = this.wax_1;
    var blendMode = this.waj();
    var program = this.aay_1;
    var vcount = array.t8f_1;
    var icount = array.u8f_1;
    var matrix = Companion_getInstance_30().n2d_1;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.t8c_1;
      this_0.m8f(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_6().v8e_1 : program;
      if (this_0.b8g(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this_0.d8f();
      if (!contains(this_0.i89_1, tex_0)) {
        this_0.h89_1 = 0;
        this_0.i89_1[0] = tex_0;
      }
      this_0.j89_1 = smoothing;
      this_0.k89_1 = blendMode;
      this_0.l89_1 = pprogram;
    }
    this_0.y8f(array, matrix, vcount, icount);
  }
  kay() {
    this.zax_1.v8k(0, this.day(), this.eay(), this.uav(), this.vav(), this.n9z(), this.xax_1, this.xaj());
  }
  rae() {
    return Companion_getInstance_28().a2i(this.day(), this.eay(), this.uav(), this.vav());
  }
  toString() {
    var out = super.toString();
    if (!this.cay().equals(Companion_getInstance_25().b29_1))
      out = out + (':anchor=(' + this.fak(this.cay().k29_1) + ', ' + this.fak(this.cay().l29_1) + ')');
    return out;
  }
}
class BaseImage extends RectBase {
  static ibi(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().b29_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.sbi(anchor, hitShape, smoothing);
    $this.dav_1 = false;
    $this.eav_1 = bitmap;
    $this.fay();
    return $this;
  }
  static oav(bmpCoords, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().b29_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.ibi(Resourceable(bmpCoords), anchor, hitShape, smoothing);
  }
  tav(value) {
    if (equals(this.xax_1, value))
      return Unit_instance;
    this.dav_1 = true;
    this.iay(value);
  }
  x5a() {
    return this.xax_1;
  }
  fay() {
    if (this.dav_1)
      return Unit_instance;
    trySetSourceActually(this);
  }
  uae(ctx) {
    this.fay();
    super.uae(ctx);
  }
  uav() {
    return this.xax_1.d2m();
  }
  vav() {
    return this.xax_1.e2m();
  }
  t3l() {
    return this.xax_1.t3l();
  }
  u3l() {
    return this.xax_1.u3l();
  }
  d3l() {
    return this.xax_1.d3l();
  }
  e3l() {
    return this.xax_1.e3l();
  }
  gay() {
    return this.cay().k29_1 * this.d3l();
  }
  hay() {
    return this.cay().l29_1 * this.e3l();
  }
  hai() {
    return this.gay() - this.t3l();
  }
  iai() {
    return this.hay() - this.u3l();
  }
  rae() {
    return Companion_getInstance_28().a2i(-this.gay(), -this.hay(), this.d3l(), this.e3l());
  }
  toString() {
    return super.toString() + (':bitmap=' + toString(this.x5a()));
  }
}
class BaseGraphics extends BaseImage {
  static nav(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    var $this = this.oav(tmp$ret$0);
    $this.has_1 = autoScaling;
    $this.ias_1 = true;
    $this.jas_1 = false;
    $this.kas_1 = false;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.las_1 = ArrayList.j1();
    $this.mas_1 = new InternalViewAutoscaling();
    $this.nas_1 = 1;
    $this.oas_1 = true;
    $this.pas_1 = true;
    $this.qas_1 = null;
    $this.ras_1 = 1.0;
    $this.sas_1 = 1.0;
    $this.tas_1 = true;
    $this.uas_1 = true;
    $this.vas_1 = Companion_getInstance_28().p2d();
    $this.was_1 = Companion_getInstance_28().p2d();
    return $this;
  }
  pav(value) {
    this.ias_1 = value;
    this.qav();
  }
  qav() {
    this.oas_1 = true;
    this.pas_1 = true;
    this.zaj();
  }
  sae() {
    super.sae();
    if (this.k28() == null || this.ba5() == null) {
      var tmp = this.x5a().a3l();
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      if (!equals(tmp, get_bmp(tmp$ret$0))) {
        this.las_1.h(this.x5a().a3l());
      }
      clearBitmaps(this, true);
    }
  }
  uae(ctx) {
    this.qas_1 = ctx;
    clearBitmaps(this, false);
    this.rav();
    super.uae(ctx);
  }
  rav() {
    if (this.mas_1.mav(this.has_1, this.jas_1, this.n9z())) {
      this.oas_1 = true;
    }
    if (!this.oas_1)
      return false;
    this.oas_1 = false;
    var boundsWithShapes = boundsUnsafe(this, true);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>' call
    this.las_1.h(this.x5a().a3l());
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var imageWidth = coerceAtLeast(toIntCeil(boundsWithShapes.m2a_1 * this.mas_1.iav_1), 1);
    var imageHeight = coerceAtLeast(toIntCeil(boundsWithShapes.n2a_1 * this.mas_1.jav_1), 1);
    var image = NativeImageOrBitmap32(imageWidth + this.nas_1 | 0, imageHeight + this.nas_1 | 0, this.ias_1, true);
    this.ras_1 = this.mas_1.iav_1;
    this.sas_1 = this.mas_1.jav_1;
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = image.d3z_1;
    if (true) {
      image.m3z();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = image.v46(true);
      try {
        // Inline function 'korlibs.korge.view.BaseGraphics.redrawIfRequired.<anonymous>.<anonymous>' call
        ctx.m59(this.ras_1, this.sas_1);
        ctx.q4s(-boundsWithShapes.k2a_1, -boundsWithShapes.l2a_1);
        this.sav(ctx);
      }finally {
        ctx.m1a();
      }
    }finally {
      result = true ? image.o3z(rect) : 0;
    }
    this.tav(slice(image));
    return true;
  }
  uav() {
    return _get_bitmapWidth__ndy7bu(this) / this.ras_1;
  }
  vav() {
    return _get_bitmapHeight__5t1vx1(this) / this.sas_1;
  }
  d3l() {
    return this.uav();
  }
  e3l() {
    return this.vav();
  }
  hai() {
    return this.cay().k29_1 * this.uav();
  }
  iai() {
    return this.cay().l29_1 * this.vav();
  }
  day() {
    return _getLocalBoundsInternal(this, this.tas_1).k2a_1;
  }
  eay() {
    return _getLocalBoundsInternal(this, this.tas_1).l2a_1;
  }
  rae() {
    return _getLocalBoundsInternal$default(this);
  }
}
class CacheTexture {
  constructor($outer, ctx) {
    this.say_1 = $outer;
    this.oay_1 = ctx;
    this.pay_1 = this.oay_1.r8i(16, 16, VOID, VOID, VOID, false);
    this.qay_1 = TextureBase.w8c(this.pay_1.p6s(), 16, 16);
    this.ray_1 = Texture(this.qay_1);
  }
  tay(width, height) {
    this.pay_1.r6s(0, 0, width, height);
    this.qay_1.x8c(width);
    this.qay_1.y8c(height);
    this.ray_1 = Texture(this.qay_1);
  }
  n6() {
    this.say_1.fah_1 = null;
    this.oay_1.s8i(this.pay_1);
  }
}
class FixedSizeContainer extends Container {
  static rb3(size, clip) {
    size = size === VOID ? Size2D.h2b(100, 100) : size;
    clip = clip === VOID ? false : clip;
    var $this = this.za4();
    $this.ob3_1 = clip;
    $this.pb3_1 = size;
    $this.qb3_1 = Ref(false);
    return $this;
  }
  a5p() {
    return this.ob3_1;
  }
  oae(_set____db54di) {
    this.pb3_1 = _set____db54di;
  }
  pae() {
    return this.pb3_1;
  }
  rae() {
    return new Rectangle(0.0, 0.0, this.d2m(), this.e2m());
  }
  toString() {
    var out = super.toString();
    out = out + (':size=(' + get_niceStr(this.d2m()) + 'x' + get_niceStr(this.e2m()) + ')');
    return out;
  }
  uae(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.a5p();
      var renderingInternalRef = this.qb3_1;
      if (renderingInternalRef.s1()) {
        super.uae(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.n9z();
        var hasRotation = !(m.s2d_1 === 0.0) || !(m.t2d_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.s1();
          try {
            renderingInternalRef.f2v(true);
            renderFiltered(this, ctx, Companion_getInstance_49());
          }finally {
            renderingInternalRef.f2v(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.j88_1;
        if (!(ctx.n88_1 === batcher)) {
          ctx.n88_1 = batcher;
          ctx.x89();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.l88_1;
        var bounds = this.qak(ctx).a2j(ctx.z87_1).b2j();
        var rect = c2d.a8j_1.j8f().w6y();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.p2i(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_14().r6y(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.a8j_1;
            var scissor_0 = c2d.i8j(scissor);
            var temp = this_0.q89_1;
            this_0.z8f();
            this_0.q89_1 = scissor_0;
            try {
              super.uae(ctx);
              break $l$block_1;
            }finally {
              this_0.z8f();
              this_0.q89_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
          super.uae(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
        super.uae(ctx);
      }
    }
  }
}
class ClipContainer extends FixedSizeContainer {
  static fb1(size) {
    size = size === VOID ? Size2D.h2b(100, 100) : size;
    return this.rb3(size, true);
  }
}
class ZIndexComparator {
  sb3(a, b) {
    return compareTo(a.vai(), b.vai());
  }
  compare(a, b) {
    var tmp = a instanceof View ? a : THROW_CCE();
    return this.sb3(tmp, b instanceof View ? b : THROW_CCE());
  }
}
class ContainerCollection$iterator$1 {
  constructor(this$0) {
    this.yb3_1 = this$0;
    this.xb3_1 = 0;
  }
  c1() {
    return this.xb3_1 < this.yb3_1.vb3_1.qah();
  }
  d1() {
    var _unary__edvuaz = this.xb3_1;
    this.xb3_1 = _unary__edvuaz + 1 | 0;
    return this.yb3_1.vb3_1.tah(_unary__edvuaz);
  }
  r6() {
    this.xb3_1 = this.xb3_1 - 1 | 0;
    this.yb3_1.vb3_1.uah(this.xb3_1);
  }
}
class ContainerCollection {
  constructor(container, children) {
    this.ub3_1 = children;
    this.vb3_1 = container;
  }
  f1() {
    return this.vb3_1.qah();
  }
  zb3(element) {
    return element.k28() === this.vb3_1;
  }
  x2(element) {
    if (!(element instanceof View))
      return false;
    return this.zb3(element instanceof View ? element : THROW_CCE());
  }
  ab4(elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.h1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.korge.view.ContainerCollection.containsAll.<anonymous>' call
        if (!(element.k28() === this.vb3_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  y2(elements) {
    return this.ab4(elements);
  }
  h1() {
    return this.vb3_1.qah() === 0;
  }
  bb4(element) {
    this.vb3_1.xah(element);
    return true;
  }
  h(element) {
    return this.bb4(element instanceof View ? element : THROW_CCE());
  }
  cb4(elements) {
    if (elements.h1())
      return false;
    var _iterator__ex2g4s = elements.b1();
    while (_iterator__ex2g4s.c1()) {
      var element = _iterator__ex2g4s.d1();
      this.vb3_1.xah(element);
    }
    return true;
  }
  g1(elements) {
    return this.cb4(elements);
  }
  b1() {
    return new ContainerCollection$iterator$1(this);
  }
  db4(element) {
    return this.vb3_1.fai(element);
  }
  m3(element) {
    if (!(element instanceof View))
      return false;
    return this.db4(element instanceof View ? element : THROW_CCE());
  }
  e1(index) {
    return this.ub3_1.e1(index);
  }
  eb4(element) {
    return this.ub3_1.z2(element);
  }
  z2(element) {
    if (!(element instanceof View))
      return -1;
    return this.eb4(element instanceof View ? element : THROW_CCE());
  }
  a3() {
    return this.ub3_1.a3();
  }
  b3(index) {
    return this.ub3_1.b3(index);
  }
  c3(fromIndex, toIndex) {
    return this.ub3_1.c3(fromIndex, toIndex);
  }
}
class CpuGraphics extends BaseGraphics {
  static lb7(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    var $this = this.nav(autoScaling);
    $this.db7_1 = 0;
    $this.eb7_1 = null;
    $this.fb7_1 = true;
    $this.gb7_1 = -1;
    $this.hb7_1 = -1;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.ib7_1 = ArrayList.j1();
    $this.jb7_1 = null;
    $this.kb7_1 = null;
    $this.v9u_1 = true;
    return $this;
  }
  mb7(value) {
    this.eb7_1 = value;
    this.db7_1 = this.db7_1 + 1 | 0;
    this.qav();
  }
  lay(value) {
    var tmp = this;
    var tmp_0;
    if (value == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.<set-hitShape>.<anonymous>' call
      tmp_0 = listOf(value);
    }
    tmp.kb7_1 = tmp_0;
  }
  jai() {
    var tmp0_safe_receiver = this.kai();
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  }
  kai() {
    if (!(this.kb7_1 == null))
      return this.kb7_1;
    if (!(this.gb7_1 === this.db7_1)) {
      this.gb7_1 = this.db7_1;
      this.ib7_1.k3();
      var tmp = this.ib7_1;
      var tmp0_safe_receiver = this.eb7_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c4u();
      tmp.h(tmp1_elvis_lhs == null ? new VectorPath() : tmp1_elvis_lhs);
    }
    return this.ib7_1;
  }
  sav(ctx) {
    var tmp0_safe_receiver = this.eb7_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.j4t(ctx);
    }
  }
  fav(includeStrokes) {
    var tmp0_safe_receiver = this.eb7_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s5o(includeStrokes);
    return tmp1_elvis_lhs == null ? Companion_getInstance_28().w2a_1 : tmp1_elvis_lhs;
  }
}
class DummyView extends View {
  static nb9() {
    return this.ob9();
  }
  uae(ctx) {
    return Unit_instance;
  }
}
class Companion_4 {}
class SContainer extends FixedSizeContainer {
  static oa7(size, clip) {
    size = size === VOID ? Size2D.h2b(100, 100) : size;
    clip = clip === VOID ? false : clip;
    return this.rb3(size, clip);
  }
}
class TimeSlidingWindow {
  constructor(capacity) {
    this.qb9_1 = capacity;
    this.rb9_1 = IntDeque.z2q(this.qb9_1);
    this.sb9_1 = 0;
  }
  f1() {
    return this.rb9_1.f1();
  }
  tb9() {
    return this.rb9_1.f1() === 0 ? get_fastSeconds(0) : get_fastMicroseconds(this.sb9_1 / this.rb9_1.f1());
  }
  ub9() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(1, DurationUnit_SECONDS_getInstance());
    return div(tmp$ret$1, this.tb9());
  }
  vb9(index) {
    return get_fastMicroseconds_0(this.rb9_1.e1(index));
  }
  wb9(value) {
    var intValue = numberToInt(_FastDuration___get_fastMicroseconds__impl__e641g1(value));
    this.rb9_1.e2r(intValue);
    this.sb9_1 = this.sb9_1 + intValue | 0;
    if (this.rb9_1.f1() > this.qb9_1) {
      this.sb9_1 = this.sb9_1 - this.rb9_1.uk() | 0;
    }
  }
}
class GraphicsRenderer extends Enum {}
class Graphics extends Container {
  static pbf(shape, renderer) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.za4();
    $this.fbc_1 = null;
    $this.gbc_1 = null;
    $this.hbc_1 = true;
    $this.ibc_1 = false;
    $this.jbc_1 = true;
    $this.kbc_1 = true;
    $this.lbc_1 = EmptyShape_instance;
    $this.mbc_1 = renderer;
    $this.nbf(shape);
    return $this;
  }
  qbf() {
    var tmp0_elvis_lhs = this.fbc_1;
    return ensureNotNull(tmp0_elvis_lhs == null ? this.gbc_1 : tmp0_elvis_lhs);
  }
  yap(value) {
    _get_anchorable__ebfoik(this).yap(value);
    this.kah();
  }
  hai() {
    return this.qbf().hai();
  }
  iai() {
    return this.qbf().iai();
  }
  rbf(value) {
    if (this.jbc_1 === value)
      return Unit_instance;
    this.jbc_1 = value;
    var tmp0_safe_receiver = this.fbc_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.wax_1 = value;
    }
    var tmp1_safe_receiver = this.gbc_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.pbe_1 = value;
    }
    this.kah();
  }
  sbf(value) {
    if (this.kbc_1 === value)
      return Unit_instance;
    this.kbc_1 = value;
    var tmp0_safe_receiver = this.fbc_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.has_1 = value;
    }
    var tmp1_safe_receiver = this.gbc_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.nbe_1 = value;
    }
    this.kah();
  }
  nbf(value) {
    if (this.lbc_1 === value)
      return Unit_instance;
    this.lbc_1 = value;
    ensure(this);
    var tmp0_safe_receiver = this.fbc_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.mb7(value);
    }
    var tmp1_safe_receiver = this.gbc_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.nbf(value);
    }
    this.kah();
  }
  tbf() {
    ensure(this);
    var tmp0_safe_receiver = this.fbc_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.qav();
    }
    var tmp1_safe_receiver = this.fbc_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.rav();
  }
}
class ViewFileRef {}
function forceLoadSourceFile$default(views, currentVfs, sourceFile, $completion, $super) {
  currentVfs = currentVfs === VOID ? views.g9r_1 : currentVfs;
  sourceFile = sourceFile === VOID ? null : sourceFile;
  return $super === VOID ? this.mbi(views, currentVfs, sourceFile, $completion) : $super.mbi.call(this, views, currentVfs, sourceFile, $completion);
}
class Image extends BaseImage {
  static hbi(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().b29_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.ibi(bitmap, anchor, hitShape, smoothing);
    $this.cbi_1 = new Mixin_0();
    $this.dbi_1 = sourceFile$factory($this);
    return $this;
  }
  static jbi(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().b29_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.hbi(Resourceable(bitmap), anchor, hitShape, smoothing);
  }
  static kbi(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_25().b29_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.jbi(slice(bitmap), anchor, hitShape, smoothing);
  }
  uae(ctx) {
    this.lbi(ctx, this);
    super.uae(ctx);
  }
  mbi(views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadSourceFile__yy5vos.bind(VOID, this, views, currentVfs, sourceFile), $completion);
  }
  obi(_set____db54di) {
    this.cbi_1.fbi_1 = _set____db54di;
  }
  pbi(_set____db54di) {
    this.cbi_1.pbi(_set____db54di);
  }
  qbi() {
    return this.cbi_1.gbi_1;
  }
  ebi(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_baseForceLoadSourceFile__natc6b.bind(VOID, _this__u8e3s4, this, views, currentVfs, sourceFile), $completion);
  }
  lbi(ctx, view) {
    this.cbi_1.lbi(ctx, view);
  }
}
class Companion_5 {}
class Companion_6 {}
class SolidRect extends RectBase {
  static cbl(size, color) {
    color = color === VOID ? Colors_getInstance().g40_1 : color;
    var $this = this.sbi();
    $this.bbl_1 = size;
    $this.s4f(color);
    return $this;
  }
  oae(value) {
    if (this.bbl_1.equals(value))
      return Unit_instance;
    this.bbl_1 = value;
    this.l9u_1 = true;
    this.kah();
  }
  pae() {
    return this.bbl_1;
  }
  uav() {
    return this.d2m();
  }
  vav() {
    return this.e2m();
  }
  dbl(value) {
    this.s4f(value);
  }
}
class Stage extends FixedSizeContainer {
  static u9p(views) {
    var $this = this.rb3();
    $this.q9p_1 = views.t9q_1;
    $this.r9p_1 = views;
    $this.s9p_1 = clipBorders$factory($this.ka1());
    $this.t9p_1 = virtualSizeDouble$factory($this.ka1());
    $this.mai($this);
    $this.oai($this);
    return $this;
  }
  ka1() {
    return this.r9p_1;
  }
  ebl(_set____db54di) {
    var this_0 = this.s9p_1;
    clip$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  a5p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s9p_1;
    clip$factory_0();
    return this_0.get();
  }
  oae(_set____db54di) {
    var this_0 = this.t9p_1;
    unscaledSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  pae() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t9p_1;
    unscaledSize$factory_0();
    return this_0.get();
  }
  ba5() {
    return this;
  }
  lah() {
    return this;
  }
  q8b() {
    return this.wb3(this.ka1());
  }
  mah(view) {
    this.ka1().mah(view);
  }
  toString() {
    return 'Stage';
  }
  b17() {
    return this.r9p_1.j9q_1;
  }
  f8h(pos) {
    return this.q9p_1.f8h(pos);
  }
  u8g(value) {
    this.q9p_1.u8g(value);
  }
  v8g() {
    return this.q9p_1.v8g();
  }
  w8g(value) {
    this.q9p_1.w8g(value);
  }
  x8g() {
    return this.q9p_1.x8g();
  }
  y8g(value) {
    this.q9p_1.y8g(value);
  }
  z8g() {
    return this.q9p_1.z8g();
  }
  a8h(value) {
    this.q9p_1.a8h(value);
  }
  b8h() {
    return this.q9p_1.b8h();
  }
  c8h(value) {
    this.q9p_1.c8h(value);
  }
  d8h() {
    return this.q9p_1.d8h();
  }
  e8h() {
    return this.q9p_1.e8h();
  }
}
class Companion_7 {
  constructor() {
    this.gbp_1 = 16.0;
    this.hbp_1 = true;
  }
}
class Text$_renderInternal$slambda {
  constructor(this$0, $ctx, $fontSource) {
    this.hbl_1 = this$0;
    this.ibl_1 = $ctx;
    this.jbl_1 = $fontSource;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this), $completion);
  }
}
class Text extends Container {
  static lbp(text, textSize, color, font, alignment, renderer, autoScaling, fill, stroke) {
    textSize = textSize === VOID ? Companion_instance_22.gbp_1 : textSize;
    color = color === VOID ? Colors_getInstance().g40_1 : color;
    font = font === VOID ? get_DefaultTtfFontAsBitmap() : font;
    alignment = alignment === VOID ? Companion_getInstance_3().l4o_1 : alignment;
    renderer = renderer === VOID ? get_DefaultStringTextRenderer() : renderer;
    autoScaling = autoScaling === VOID ? Companion_instance_22.hbp_1 : autoScaling;
    fill = fill === VOID ? null : fill;
    stroke = stroke === VOID ? null : stroke;
    var $this = this.za4();
    $this.sbn_1 = true;
    $this.tbn_1 = -1;
    $this.ubn_1 = -1;
    $this.vbn_1 = 0;
    $this.wbn_1 = 0;
    $this.xbn_1 = text;
    updateLineCount($this);
    var tmp = $this;
    tmp.ybn_1 = fill == null ? new RGBA(color) : fill;
    $this.zbn_1 = stroke;
    $this.abo_1 = font;
    $this.bbo_1 = numberToDouble(textSize);
    $this.cbo_1 = textSize$factory($this);
    $this.dbo_1 = 0;
    $this.ebo_1 = 2147483647;
    $this.fbo_1 = renderer;
    $this.gbo_1 = alignment;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.za4(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp_0.hbo_1 = addTo(this_0, $this);
    $this.ibo_1 = new Text2TextRendererActions();
    $this.jbo_1 = false;
    $this.kbo_1 = autoScaling;
    $this.lbo_1 = false;
    $this.mbo_1 = null;
    $this.nbo_1 = Companion_getInstance_28().z2h(0, 0, 2048, 2048);
    $this.obo_1 = true;
    $this.pbo_1 = -1;
    $this.qbo_1 = new MMatrix();
    $this.rbo_1 = -1;
    $this.sbo_1 = null;
    $this.tbo_1 = new Entry();
    $this.ubo_1 = new FontMetrics();
    $this.vbo_1 = new TextMetrics();
    $this.wbo_1 = null;
    $this.xbo_1 = null;
    $this.ybo_1 = null;
    $this.zbo_1 = null;
    $this.abp_1 = new MMatrix();
    $this.bbp_1 = GraphicsRenderer_SYSTEM_getInstance();
    $this.cbp_1 = true;
    $this.dbp_1 = null;
    $this.ebp_1 = fontSource$factory($this);
    return $this;
  }
  mbp(value) {
    if (!(this.xbn_1 === value)) {
      this.xbn_1 = value;
      updateLineCount(this);
      this.oah();
      this.kah();
    }
  }
  ibp() {
    return this.xbn_1;
  }
  nbp(value) {
    if (!equals(this.ybn_1, value)) {
      this.ybn_1 = value;
      this.oah();
    }
  }
  dbl(value) {
    this.nbp(new RGBA(value));
  }
  h56() {
    var tmp = this.ybn_1;
    var tmp_0;
    if (tmp == null ? true : tmp instanceof RGBA) {
      var tmp_1 = tmp;
      tmp_0 = tmp_1 == null ? null : tmp_1.a4g_1;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_2;
    var tmp_3 = tmp0_elvis_lhs;
    if ((tmp_3 == null ? null : new RGBA(tmp_3)) == null) {
      tmp_2 = Colors_getInstance().g40_1;
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    return tmp_2;
  }
  kbp(value) {
    if (!equals(this.abo_1, value)) {
      this.abo_1 = value;
      this.oah();
    }
  }
  obp(value) {
    if (!(this.bbo_1 === value)) {
      this.bbo_1 = value;
      this.oah();
    }
  }
  pbp(_set____db54di) {
    var this_0 = this.cbo_1;
    fontSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  l4h() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.cbo_1;
    fontSize$factory_0();
    return this_0.get();
  }
  oah() {
    this.vbn_1 = this.vbn_1 + 1 | 0;
    super.oah();
  }
  qbp(value) {
    if (!this.gbo_1.equals(value)) {
      this.gbo_1 = value;
      this.oah();
    }
  }
  j5n() {
    return this.gbo_1.d4q_1;
  }
  d5k() {
    return this.gbo_1.e4q_1;
  }
  jbp(value) {
    this.mbo_1 = value;
    this.jbo_1 = false;
    this.oah();
  }
  fbp(currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadFontSource__wlrz09.bind(VOID, this, currentVfs, sourceFile), $completion);
  }
  rbp() {
    this.nbo_1 = this.l9z();
    return this.nbo_1;
  }
  rae() {
    this.sbp(null);
    if (!(get_filter(this) == null) || !(get_backdropFilter(this) == null)) {
      return super.rae();
    } else {
      return this.nbo_1;
    }
  }
  uae(ctx) {
    this.sbp(ctx);
    var tva = this.zbo_1;
    if (!(tva == null)) {
      this.qbo_1.p3s(this.n9z());
      this.qbo_1.q3s(this.hbo_1.b6j(), this.hbo_1.c6j());
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.j88_1;
      var this_1 = this_0.s88_1;
      if (!(this_1.n88_1 === this_0)) {
        this_1.n88_1 = this_0;
        this_1.x89();
      }
      var tmp = this.abo_1;
      var bmpfont = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
      var tex = bmpfont.q4h();
      this_0.d8g(tex, this.sbn_1, this.waj(), get_agProgram(bmpfont), tva.u8f_1, tva.t8f_1);
      this_0.y8f(tva, this.qbo_1.n3s());
    } else {
      super.uae(ctx);
    }
  }
  sbp(ctx) {
    if (!(ctx == null)) {
      var fontSource = this.mbo_1;
      if (!this.jbo_1 && !(fontSource == null)) {
        this.jbo_1 = true;
        launchImmediately_0(ctx.p87_1, Text$_renderInternal$slambda_0(this, ctx, fontSource));
      }
    }
    var font = this.abo_1.b11();
    var tmp;
    var tmp_0;
    if (this.obo_1) {
      tmp_0 = !(font == null) ? isInterface(font, Font) : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(this.pbo_1 === this.vbn_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.pbo_1 = this.vbn_1;
      var metrics = getTextBounds(font, this.bbo_1, this.ibp(), this.vbo_1, this.fbo_1, this.gbo_1);
      this.nbo_1 = new Rectangle(metrics.r2a(), VerticalAlign__getOffsetY_impl_iso0y6(this.gbo_1.e4q_1, metrics.e2m(), -metrics.l4q()), metrics.d2m(), font.u4h(this.bbo_1, this.ubo_1).m4h() * this.wbn_1);
    }
    if (font != null) {
      if (!(font == null) ? isInterface(font, BitmapFont) : false) {
        var rversion = this.fbo_1.w5i();
        if (!(this.xbo_1 === this.sbn_1) || !(this.tbn_1 === this.vbn_1) || !(this.ubn_1 === rversion)) {
          this.xbo_1 = this.sbn_1;
          this.ubn_1 = rversion;
          this.tbn_1 = this.vbn_1;
          if (!(this.dbp_1 == null)) {
            this.dbp_1 = null;
            this.hbo_1.wah();
          }
          this.ibo_1.h5k();
          this.ibo_1.u5j_1 = Companion_getInstance_3().p4o_1;
          invoke(this.fbo_1, this.ibo_1, this.ibp(), this.bbo_1, font);
          while (this.hbo_1.qah() < this.ibo_1.f1()) {
            // Inline function 'korlibs.korge.view.image' call
            var this_0 = this.hbo_1;
            // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
            var texture = get_Bitmaps_transparent();
            var anchor_0 = Companion_getInstance_25().b29_1;
            // Inline function 'korlibs.korge.view.addTo' call
            var this_1 = Image.jbi(texture, anchor_0);
            // Inline function 'kotlin.apply' call
            addTo(this_1, this_0);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.image.<anonymous>' call
          }
          while (this.hbo_1.qah() > this.ibo_1.f1()) {
            this.hbo_1.e1(this.hbo_1.qah() - 1 | 0).kak();
          }
          var bounds = this.ibo_1.k3e();
          var firstBounds = this.ibo_1.f5k(0);
          var lineInfos = this.ibo_1.e5k();
          var tmp1_elvis_lhs = firstOrNull(lineInfos);
          var firstLineInfos = tmp1_elvis_lhs == null ? new LineInfo() : tmp1_elvis_lhs;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0;
          var tmp0_iterator = lineInfos.b1();
          while (tmp0_iterator.c1()) {
            var element = tmp0_iterator.d1();
            var tmp_1 = sum;
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            sum = tmp_1 + element.d5j_1;
          }
          var totalHeight = sum;
          var textWidth = bounds.m2a_1;
          var textHeight = bounds.n2a_1;
          var dx = this.obo_1 ? this.nbo_1.k2a_1 : this.nbo_1.k2a_1 + 1 + (this.nbo_1.m2a_1 - textWidth) * _HorizontalAlign___get_ratio__impl__x9wlea(this.j5n());
          var tmp_2;
          if (this.obo_1) {
            tmp_2 = this.nbo_1.l2a_1 + firstLineInfos.b5j_1;
          } else {
            var tmp2_subject = this.d5k();
            tmp_2 = equals(tmp2_subject, Companion_getInstance_4().k5i_1) ? this.nbo_1.l2a_1 : this.nbo_1.l2a_1 + firstLineInfos.b5j_1 + (this.nbo_1.n2a_1 - totalHeight) * _VerticalAlign___get_ratioFake__impl__1h2fwv(this.d5k());
          }
          var dy = tmp_2;
          var program = get_agProgram(font);
          var inductionVariable = 0;
          var last = this.ibo_1.f1();
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var entry = this.ibo_1.g5k(n, this.tbo_1);
              var tmp_3 = this.hbo_1.e1(n);
              var it = tmp_3 instanceof Image ? tmp_3 : THROW_CCE();
              it.aay_1 = program;
              it.s4f(this.h56());
              // Inline function 'korlibs.korge.view.anchor' call
              anchor(it, Anchor2D.o29(numberToDouble(0), numberToDouble(0)));
              it.wax_1 = this.sbn_1;
              it.tav(entry.e5j_1);
              it.w4s(Vector2D.k2c(entry.f5j_1 + dx, entry.g5j_1 + dy));
              it.caj(Scale.v2h(entry.h5j_1, entry.i5j_1));
              it.rbi(entry.j5j_1);
              var containsLower = this.dbo_1;
              it.i8q(n < this.ebo_1 ? containsLower <= n : false);
            }
             while (inductionVariable < last);
        }
      } else {
        if (!(this.xbo_1 === this.sbn_1) || !(this.ybo_1 === this.cbp_1)) {
          this.vbn_1 = this.vbn_1 + 1 | 0;
          this.ybo_1 = this.cbp_1;
          this.wbo_1 = this.kbo_1;
          this.xbo_1 = this.sbn_1;
        }
        if (!(this.tbn_1 === this.vbn_1)) {
          this.tbn_1 = this.vbn_1;
          var realTextSize = this.bbo_1;
          if (this.dbp_1 == null) {
            this.hbo_1.wah();
            var tmp_4 = this;
            // Inline function 'korlibs.korge.view.graphics' call
            var this_2 = this.hbo_1;
            var renderer = this.bbp_1;
            // Inline function 'kotlin.also' call
            var this_3 = addTo(Graphics.pbf(EmptyShape_instance, renderer), this_2);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.graphics.<anonymous>' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape' call
            var result;
            // Inline function 'korlibs.image.vector.buildShape' call
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
            // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
            result = Unit_instance;
            var tmp$ret$10 = (new ShapeBuilder(null, null)).n4n();
            this_3.nbf(tmp$ret$10);
            this_3.tbf();
            tmp_4.dbp_1 = this_3;
            var tmp3_safe_receiver = this.dbp_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.sbf(true);
            }
          }
          // Inline function 'korlibs.korge.view.Graphics.updateShape' call
          var this_4 = ensureNotNull(this.dbp_1);
          var result_0;
          // Inline function 'korlibs.image.vector.buildShape' call
          // Inline function 'kotlin.apply' call
          var this_5 = new ShapeBuilder(null, null);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.Graphics.updateShape.<anonymous>' call
          // Inline function 'korlibs.korge.view.Text._renderInternal.<anonymous>' call
          var tmp0_text = this.ibp();
          var tmp1_pos = Companion_getInstance_27().c2a_1;
          var tmp2_paint = this.h56();
          var tmp3_renderer = this.fbo_1;
          var tmp4_align = this.gbo_1;
          var tmp5_outMetrics = new TextMetricsResult();
          var tmp6_fillStyle = this.ybn_1;
          var tmp7_stroke = this.zbn_1;
          var tmp8_textRangeStart = this.dbo_1;
          var tmp9_textRangeEnd = this.ebo_1;
          result_0 = this_5.t5n(tmp0_text, tmp1_pos, VOID, new RGBA(tmp2_paint), font, realTextSize, tmp3_renderer, tmp4_align, tmp5_outMetrics, tmp6_fillStyle, tmp7_stroke, tmp8_textRangeStart, tmp9_textRangeEnd);
          var tmp$ret$16 = this_5.n4n();
          this_4.nbf(tmp$ret$16);
          var metrics_0 = result_0;
          this.rbo_1 = this.vbn_1;
          this.sbo_1 = metrics_0;
          setContainerPosition(this, Companion_getInstance_27().c2a_1, font.u4h(this.l4h(), this.ubo_1).y4h_1);
        }
        var tmp4_safe_receiver = this.dbp_1;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.rbf(this.sbn_1);
        }
      }
    }
  }
}
class ColorReference {}
class Companion_8 {
  tbp(left, right) {
    var l = left;
    var r = right;
    var lCount = get_ancestorCount(l);
    var rCount = get_ancestorCount(r);
    while (lCount >= 0 || rCount >= 0) {
      if (equals(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        lCount = lCount - 1 | 0;
        var tmp0_safe_receiver = l;
        l = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k28();
      }
      if (rdec) {
        rCount = rCount - 1 | 0;
        var tmp1_safe_receiver = r;
        r = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k28();
      }
    }
    return null;
  }
}
class ViewRenderPhase {}
function render_0(view, ctx) {
  return view.dak(ctx);
}
function beforeRender(view, ctx) {
  return Unit_instance;
}
function afterRender(view, ctx) {
  return Unit_instance;
}
class ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda {
  constructor($view, $ctx, this$0) {
    this.cbq_1 = $view;
    this.dbq_1 = $ctx;
    this.ebq_1 = this$0;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this), $completion);
  }
}
class Mixin_0 {
  constructor() {
    this.fbi_1 = true;
    this.gbi_1 = null;
  }
  obi(_set____db54di) {
    this.fbi_1 = _set____db54di;
  }
  pbi(value) {
    this.fbi_1 = false;
    this.gbi_1 = value;
  }
  ebi(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    _this__u8e3s4.pbi(sourceFile);
    _this__u8e3s4.obi(true);
  }
  mbi(views, currentVfs, sourceFile, $completion) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Must override this';
    throw NotImplementedError.be('An operation is not implemented: ' + reason);
  }
  lbi(ctx, view) {
    if (this.fbi_1)
      return Unit_instance;
    this.fbq(ctx, view);
  }
  fbq(ctx, view) {
    if (!this.fbi_1 && !(this.gbi_1 == null)) {
      this.fbi_1 = true;
      launchImmediately_0(ctx.p87_1, ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0(view, ctx, this));
    }
  }
}
class Views$close$slambda {
  constructor(this$0) {
    this.gbq_1 = this$0;
  }
  ce($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_17.bind(VOID, this), $completion);
  }
}
class Views extends BaseEventListener {
  static i9y(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder) {
    injector = injector === VOID ? new Injector() : injector;
    input = input === VOID ? new Input() : input;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    stats = stats === VOID ? new Stats() : stats;
    gameId = gameId === VOID ? 'korgegame' : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().o8e_1 : batchMaxQuads;
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (stageBuilder === VOID) {
      tmp = Views$_init_$lambda_jivasj;
    } else {
      tmp = stageBuilder;
    }
    stageBuilder = tmp;
    var $this = this.v6e();
    $this.i9q_1 = new Mixin();
    $this.j9q_1 = coroutineContext;
    $this.k9q_1 = ag;
    $this.l9q_1 = injector;
    $this.m9q_1 = input;
    $this.n9q_1 = timeProvider;
    $this.o9q_1 = stats;
    $this.p9q_1 = gameWindow;
    $this.q9q_1 = gameId;
    $this.r9q_1 = settingsFolder;
    $this.s9q_1 = batchMaxQuads;
    $this.t9q_1 = bp;
    $this.u9q_1 = stageBuilder;
    $this.v9q_1 = quality$factory($this.p9q_1);
    $this.w9q_1 = $this;
    $this.x9q_1 = false;
    $this.y9q_1 = continuousRenderMode$factory($this.p9q_1);
    $this.z9q_1 = new ReshapeEvent(0, 0);
    $this.a9r_1 = new UpdateEvent();
    $this.b9r_1 = new ViewsUpdateEvent($this);
    $this.c9r_1 = new ViewsResizedEvent($this);
    var tmp_0 = $this;
    tmp_0.d9r_1 = lazy(Views$realSettingsFolder$delegate$lambda($this));
    $this.f9r_1 = null;
    $this.g9r_1 = get_resourcesVfs();
    $this.h9r_1 = get_RegisteredImageFormats();
    $this.i9r_1 = new RenderContext($this.k9q_1, $this, $this.p9q_1, $this.o9q_1, $this.j9q_1, $this.s9q_1, $this.p9q_1);
    $this.j9r_1 = true;
    $this.k9r_1 = Colors_getInstance().h40_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.l9r_1 = HashMap.t8();
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp_2.m9r_1 = toDuration(100.0, DurationUnit_MILLISECONDS_getInstance());
    $this.n9r_1 = new Resources($this.j9q_1, $this.g9r_1);
    $this.o9r_1 = false;
    $this.p9r_1 = 1280;
    $this.q9r_1 = 720;
    var tmp_3 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_3.r9r_1 = ArrayList.j1();
    $this.s9r_1 = Companion_getInstance_24().y2j_1;
    $this.t9r_1 = Companion_getInstance_25().f29_1;
    $this.u9r_1 = true;
    $this.v9r_1 = $this.u9q_1($this);
    $this.w9r_1 = $this.v9r_1;
    $this.x9r_1 = true;
    $this.y9r_1 = false;
    $this.z9r_1 = debugExtraFontScale$factory($this.i9r_1);
    $this.a9s_1 = debugExtraFontColor$factory($this.i9r_1);
    $this.b9s_1 = FastArrayList.q10();
    $this.c9s_1 = $this.n9q_1.s1x();
    var tmp_4 = $this;
    tmp_4.d9s_1 = Pool.x2t(VOID, Views$tempViewsPool$lambda);
    $this.e9s_1 = SizeInt.o2k();
    $this.f9s_1 = SizeInt.o2k();
    $this.g9s_1 = SizeInt.o2k();
    $this.h9s_1 = new Signal();
    $this.i9s_1 = new Signal();
    $this.j9s_1 = -1.0;
    $this.l9q_1.c6c(getKClass(CoroutineContext), $this.j9q_1);
    $this.l9q_1.c6c(getKClass(AG), $this.k9q_1);
    $this.l9q_1.c6c(getKClass(Views), $this);
    $this.i9s_1.w20(Views$lambda($this));
    $this.h9s_1.w20(Views$lambda_0($this));
    installFpsDebugOverlay($this);
    $this.k9s_1 = Companion_instance_11.hi('SHOW_FRAME_UPDATE_AND_RENDER') === 'true';
    $this.l9s_1 = new EventResult();
    $this.m9s_1 = new Signal();
    $this.n9s_1 = Companion_getInstance_0().ey('debugHightlightView');
    $this.o9s_1 = new Signal();
    $this.p9s_1 = new Signal();
    $this.q9s_1 = ArrayList.j1();
    $this.r9s_1 = updatedSinceFrame$factory($this.p9q_1);
    return $this;
  }
  b17() {
    return this.j9q_1;
  }
  ka1() {
    return this.w9q_1;
  }
  t9y(_set____db54di) {
    var this_0 = this.y9q_1;
    forceRenderEveryFrame$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  n9y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y9q_1;
    forceRenderEveryFrame$factory_0();
    return this_0.get();
  }
  ibq() {
    return replace(replace(replace(this.q9q_1, '\\', ''), '/', ''), '..', '');
  }
  o9z() {
    var tmp = this.e9r_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('debugBmpFont');
    }
  }
  t27($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_init__qn9atk.bind(VOID, this), $completion);
  }
  s9y() {
    return this.n9r_1;
  }
  u9y() {
    return this.k9q_1.y6n().r6n_1;
  }
  v9y() {
    return this.k9q_1.y6n().s6n_1;
  }
  jbq(value) {
    this.p9r_1 = numberToInt(value);
  }
  kbq() {
    return this.p9r_1;
  }
  lbq(value) {
    this.q9r_1 = numberToInt(value);
  }
  mbq() {
    return this.q9r_1;
  }
  gbl(value) {
    this.jbq(value.f2b_1);
    this.lbq(value.g2b_1);
  }
  fbl() {
    return Size2D.f2i(this.kbq(), this.mbq());
  }
  n6() {
    launchImmediately(this, Views$close$slambda_0(this));
  }
  hbq($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_closeSuspend__agjafw.bind(VOID, this), $completion);
  }
  j9z() {
    return this.v9r_1.q8b();
  }
  j9y(_set____db54di) {
    var this_0 = this.z9r_1;
    debugFontExtraScale$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  nbq() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z9r_1;
    debugFontExtraScale$factory_0();
    return this_0.get();
  }
  k9y(_set____db54di) {
    var this_0 = this.a9s_1;
    debugFontColor$factory();
    var value = new RGBA(_set____db54di);
    this_0.set(value);
    return Unit_instance;
  }
  obq() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a9s_1;
    debugFontColor$factory_0();
    return this_0.get().a4g_1;
  }
  pb9(block) {
    this.b9s_1.h(block);
  }
  z6e(type, event, result, up, down) {
    event.u6f(false);
    var result_0 = super.z6e(type, event, result, up, down);
    var e = event;
    e.r6f(this.w9q_1);
    if (e instanceof KeyEvent) {
      this.m9q_1.x8b(e);
      this.m9q_1.e8b_1.o8a(e);
      if (e.p6g_1.equals(Type_UP_getInstance_0()) && this.x9r_1 && (e.r6g_1.equals(Key_F12_getInstance()) || e.r6g_1.equals(Key_F7_getInstance()))) {
        this.y9r_1 = !this.y9r_1;
        this.p9q_1.m8q(this.y9r_1);
        this.mah(this.v9r_1);
      }
    }
    try {
      return this.v9r_1.i6f(e);
    } catch ($p) {
      if ($p instanceof StopPropagatingException) {
        var e_0 = $p;
      } else {
        throw $p;
      }
    }
    return result_0;
  }
  pbq(frameBuffer) {
    this.i9r_1.o88_1 = frameBuffer;
    if (this.j9r_1) {
      var tmp0_$this = this.i9r_1;
      var tmp1_color = this.k9r_1;
      tmp0_$this.m8i(tmp1_color, 1.0, 0, true, true, true);
    }
    this.h9s_1.x20(this.i9r_1);
    this.i9r_1.x89();
    this.v9r_1.qae(this.i9r_1);
    this.i9r_1.x89();
    this.v9r_1.zah(this.i9r_1);
    if (this.y9r_1) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.b9s_1.o10_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Views.renderNew.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz](this, this.i9r_1);
      }
    }
    this.i9s_1.x20(this.i9r_1);
    this.i9r_1.x89();
  }
  qbq(frameBuffer, $super) {
    frameBuffer = frameBuffer === VOID ? this.k9q_1.y6n() : frameBuffer;
    var tmp;
    if ($super === VOID) {
      this.pbq(frameBuffer);
      tmp = Unit_instance;
    } else {
      tmp = $super.pbq.call(this, frameBuffer);
    }
    return tmp;
  }
  rbq() {
    this.k9q_1.c6o();
    this.qbq();
  }
  o9y(fixedSizeStep, forceRender, doUpdate, doRender) {
    var currentTime = this.n9q_1.s1x();
    this.w9q_1.o9q_1.c6o();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().c9n_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.korge.view.Views.frameUpdateAndRender.<anonymous>' call
      var tmp$ret$0 = 'ag.onRender';
      this_0.y2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var delta = DateTime__minus_impl_10njw8(currentTime, this.c9s_1);
    var adelta = Duration__compareTo_impl_pchp0f(delta, this.w9q_1.m9r_1) > 0 ? this.w9q_1.m9r_1 : delta;
    this.c9s_1 = currentTime;
    if (doUpdate) {
      if (!equals(fixedSizeStep, Companion_instance_1.y1x())) {
        this.tbq(fixedSizeStep);
      } else {
        this.sbq(adelta);
      }
    }
    var doRender2 = doRender && (forceRender || this.ubq() > 0);
    if (doRender2) {
      if (this.k9s_1) {
        println('Views.frameUpdateAndRender[' + Companion_getInstance_5().u1x().toString() + ']: doRender=' + doRender2 + ' -> [forceRender=' + forceRender + ', updatedSinceFrame=' + this.ubq() + ']');
      }
      this.rbq();
      this.c6o();
    }
  }
  sbq(elapsed) {
    return this.tbq(get_fast(elapsed));
  }
  tbq(elapsed) {
    this.m9q_1.v8b(elapsed);
    this.l9s_1.p2u();
    updateSingleViewWithViewsAll(this.v9r_1, this, elapsed);
    this.m9q_1.w8b(elapsed);
  }
  m9y() {
  }
  r9y(width, height) {
    var actualWidth = width;
    var actualHeight = height;
    this.f9s_1 = SizeInt.n2k(actualWidth, actualHeight);
    this.vbq();
  }
  vbq() {
    setBoundsInfo(this.t9q_1, Size2D.h2b(this.p9r_1, this.q9r_1), toFloat(this.f9s_1), this.s9r_1, this.t9r_1, toRef(virtualSize$factory(this)), toRef(targetSize$factory(this)));
    this.i9r_1.v87_1 = this.t9q_1.z8g();
    this.i9r_1.w87_1 = this.t9q_1.v8g();
    // Inline function 'kotlin.also' call
    var this_0 = this.z9q_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_0.j6g_1 = this.f9s_1.l2k_1;
    this_0.k6g_1 = this.f9s_1.m2k_1;
    this.i6f(this_0);
    // Inline function 'kotlin.also' call
    var this_1 = this.c9r_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_1.zbq_1 = this.e9s_1;
    this.i6f(this_1);
    this.v9r_1.oah();
  }
  abr(viewToHightlight, onlyIfDebuggerOpened) {
    if (onlyIfDebuggerOpened && !this.p9q_1.n8q())
      return Unit_instance;
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = this.n9s_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.korge.view.Views.debugHightlightView.<anonymous>' call
      var tmp$ret$0 = 'debugHightlightView: ' + toString_0(viewToHightlight);
      this_0.y2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.m9s_1.x20(viewToHightlight);
  }
  m9z(viewToHightlight, onlyIfDebuggerOpened, $super) {
    onlyIfDebuggerOpened = onlyIfDebuggerOpened === VOID ? false : onlyIfDebuggerOpened;
    var tmp;
    if ($super === VOID) {
      this.abr(viewToHightlight, onlyIfDebuggerOpened);
      tmp = Unit_instance;
    } else {
      tmp = $super.abr.call(this, viewToHightlight, onlyIfDebuggerOpened);
    }
    return tmp;
  }
  bbr(_set____db54di) {
    var this_0 = this.r9s_1;
    updatedSinceFrame$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  ubq() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r9s_1;
    updatedSinceFrame$factory_1();
    return this_0.get();
  }
  c6o() {
    this.p9q_1.c6o();
  }
  mah(view) {
    this.p9q_1.b8r();
  }
  yz(value) {
    this.i9q_1.yz(value);
  }
  zz() {
    return this.i9q_1.zz();
  }
  f8h(pos) {
    return this.t9q_1.f8h(pos);
  }
  u8g(value) {
    this.t9q_1.u8g(value);
  }
  v8g() {
    return this.t9q_1.v8g();
  }
  w8g(value) {
    this.t9q_1.w8g(value);
  }
  x8g() {
    return this.t9q_1.x8g();
  }
  y8g(value) {
    this.t9q_1.y8g(value);
  }
  z8g() {
    return this.t9q_1.z8g();
  }
  a8h(value) {
    this.t9q_1.a8h(value);
  }
  b8h() {
    return this.t9q_1.b8h();
  }
  c8h(value) {
    this.t9q_1.c8h(value);
  }
  d8h() {
    return this.t9q_1.d8h();
  }
  e8h() {
    return this.t9q_1.e8h();
  }
  w8i() {
    return this.p9q_1.w8i();
  }
  x8i() {
    return this.p9q_1.x8i();
  }
  y8i() {
    return this.p9q_1.y8i();
  }
  h8i() {
    return this.p9q_1.h8i();
  }
}
class Companion_9 {}
class ViewsUpdateEvent extends Event {
  constructor(views, fastDelta) {
    fastDelta = fastDelta === VOID ? Companion_instance_1.x1x() : fastDelta;
    super();
    this.zbp_1 = views;
    this.abq_1 = fastDelta;
  }
  bbq() {
    return toDuration_0(this.abq_1);
  }
  c2e() {
    return Companion_instance_24;
  }
  toString() {
    return 'ViewsUpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.abq_1) + ')';
  }
}
class Companion_10 {}
class ViewsResizedEvent extends Event {
  constructor(views, size) {
    size = size === VOID ? SizeInt.n2k(0, 0) : size;
    super();
    this.ybq_1 = views;
    this.zbq_1 = size;
  }
  c2e() {
    return Companion_instance_25;
  }
  toString() {
    return 'ViewsResizedEvent(size=' + this.zbq_1.toString() + ')';
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_26 = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.cbr_1 = new Float64Array([0.03125, 0.0625, 0.125, 0.25, 0.5, 0.75, 1.0]);
  }
  dbr(scale) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var this_0 = this.cbr_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var minElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block_0;
      }
      // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_1 = scale - minElem;
      var minValue = Math.abs(this_1);
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
          // Inline function 'kotlin.math.absoluteValue' call
          var this_2 = scale - e;
          var v = Math.abs(this_2);
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    return ensureNotNull(tmp$ret$1);
  }
}
class Filter {}
function get_recommendedFilterScale() {
  return 1.0;
}
function computeBorder(texWidth, texHeight) {
  return Companion_getInstance_32().c2d_1;
}
class RenderToTextureResult {
  constructor() {
    this.hbr_1 = null;
    this.ibr_1 = 0;
    this.jbr_1 = 0;
    this.kbr_1 = 0;
    this.lbr_1 = 0;
    this.mbr_1 = 1.0;
    this.nbr_1 = Companion_getInstance_30().m2d_1;
    this.obr_1 = null;
    this.pbr_1 = null;
    this.qbr_1 = null;
    this.rbr_1 = null;
  }
  m1a() {
    if (this.pbr_1 == null || this.rbr_1 == null)
      return Unit_instance;
    var tmp0_safe_receiver = this.pbr_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.filter.RenderToTextureResult.dispose.<anonymous>' call
      var tmp0_safe_receiver_0 = this.rbr_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver_0.s8i(tmp0_safe_receiver);
        tmp = Unit_instance;
      }
    }
    this.hbr_1 = null;
    this.obr_1 = null;
    this.pbr_1 = null;
    this.rbr_1 = null;
    this.qbr_1 = null;
  }
}
class IdentityFilter {
  constructor(smoothing) {
    Companion_getInstance_49();
    this.sbr_1 = smoothing;
  }
  gbr(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.j88_1;
    var this_1 = this_0.s88_1;
    if (!(this_1.n88_1 === this_0)) {
      this_1.n88_1 = this_0;
      this_1.x89();
    }
    this_0.z89(texture, VOID, VOID, VOID, VOID, matrix, this.sbr_1, renderColorMul, blendMode, Companion_getInstance_6().v8e_1);
  }
}
class Companion_12 extends IdentityFilter {
  constructor() {
    Companion_instance_27 = null;
    super(true);
    Companion_instance_27 = this;
  }
}
class ViewRenderPhaseBackdropFilter {}
class ViewRenderPhaseFilter {}
class PointsResult {
  constructor(bounds, vertexCount, vertexStart, vertexEnd) {
    this.fbt_1 = bounds;
    this.gbt_1 = vertexCount;
    this.hbt_1 = vertexStart;
    this.ibt_1 = vertexEnd;
  }
}
class GpuShapeView extends View {
  static mbf(shape, antialiased, autoScaling) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    antialiased = antialiased === VOID ? true : antialiased;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    var $this = this.ob9();
    $this.nbe_1 = autoScaling;
    $this.obe_1 = true;
    $this.pbe_1 = true;
    $this.qbe_1 = true;
    $this.rbe_1 = new GpuShapeViewCommands();
    $this.sbe_1 = 1000;
    $this.tbe_1 = 1000;
    $this.ube_1 = Companion_getInstance_25().b29_1;
    $this.vbe_1 = true;
    $this.wbe_1 = false;
    $this.xbe_1 = antialiased;
    $this.ybe_1 = shape;
    $this.zbe_1 = false;
    $this.abf_1 = false;
    $this.bbf_1 = false;
    $this.cbf_1 = 0;
    $this.dbf_1 = Companion_getInstance_28().p2d();
    $this.ebf_1 = Companion_getInstance_28().p2d();
    $this.fbf_1 = false;
    $this.gbf_1 = 1.0;
    $this.hbf_1 = NaN;
    $this.ibf_1 = Companion_getInstance_30().p2d();
    $this.jbf_1 = 100000;
    $this.kbf_1 = false;
    $this.lbf_1 = 10000.0;
    invalidateShape($this);
    return $this;
  }
  yap(value) {
    this.ube_1 = value;
    this.oah();
  }
  cay() {
    return this.ube_1;
  }
  obf(value) {
    this.xbe_1 = value;
    invalidateShape(this);
  }
  nbf(value) {
    this.ybe_1 = value;
    invalidateShape(this);
  }
  hai() {
    return _get_shapeBounds__actvvf(this).m2a_1 * this.cay().k29_1;
  }
  iai() {
    return _get_shapeBounds__actvvf(this).n2a_1 * this.cay().l29_1;
  }
  oah() {
    super.oah();
    invalidateShape(this);
  }
  rae() {
    return new Rectangle(_get_shapeBounds__actvvf(this).k2a_1 - this.hai(), _get_shapeBounds__actvvf(this).l2a_1 - this.iai(), _get_shapeBounds__actvvf(this).m2a_1, _get_shapeBounds__actvvf(this).n2a_1);
  }
  kbt(_this__u8e3s4) {
    var tmp;
    if (equals(_this__u8e3s4, EmptyShape_instance)) {
      tmp = false;
    } else {
      if (_this__u8e3s4 instanceof CompoundShape) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var this_0 = _this__u8e3s4.f5p_1;
          var tmp_0;
          if (isInterface(this_0, Collection)) {
            tmp_0 = this_0.h1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator = this_0.b1();
          while (tmp0_iterator.c1()) {
            var element = tmp0_iterator.d1();
            // Inline function 'korlibs.korge.view.vector.GpuShapeView.<get-requireStencil>.<anonymous>' call
            if (this.kbt(element)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      } else {
        if (_this__u8e3s4 instanceof TextShape) {
          tmp = this.kbt(_this__u8e3s4.y5p());
        } else {
          if (_this__u8e3s4 instanceof FillShape) {
            tmp = !_this__u8e3s4.d5p();
          } else {
            if (_this__u8e3s4 instanceof PolylineShape) {
              tmp = false;
            } else {
              tmp = true;
            }
          }
        }
      }
    }
    return tmp;
  }
  uae(ctx) {
    this.gbf_1 = this.n9z().z2e().x2f() * ctx.m87_1.e8h();
    if (!(this.hbf_1 === this.gbf_1)) {
      invalidateShape(this);
    }
    ctx.x89();
    var doRequireTexture = this.kbt(this.ybe_1);
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.kj();
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>' call
    if (doRequireTexture) {
      var currentFrameBuffer = ctx.l87_1.y6n();
      this.sbe_1 = currentFrameBuffer.r6n_1;
      this.tbe_1 = currentFrameBuffer.s6n_1;
      // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
      var width = this.sbe_1;
      var height = this.tbe_1;
      ctx.x89();
      // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
      var rb = ctx.r8i(width, height, false, true, 1);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
        // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
        ctx.t8i(rb);
        try {
          // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
          // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
          // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
          var this_0 = ctx.j88_1;
          var this_1 = this_0.s88_1;
          if (!(this_1.n88_1 === this_0)) {
            this_1.n88_1 = this_0;
            this_1.x89();
          }
          $l$block: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var scissor = AGScissor.o6y(0, 0, rb.r6n_1, rb.s6n_1);
            var temp = this_0.q89_1;
            this_0.z8f();
            this_0.q89_1 = scissor;
            try {
              if (true) {
                ctx.m8i(Colors_getInstance().l40_1);
              }
              renderCommands(this, ctx, doRequireTexture);
              break $l$block;
            }finally {
              this_0.z8f();
              this_0.q89_1 = temp;
            }
          }
        }finally {
          ctx.u8i();
        }
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderInternal.<anonymous>.<anonymous>' call
        var texture = Texture_0(rb).i3l(0, 0, width, height);
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_2 = ctx.j88_1;
        var this_3 = this_2.s88_1;
        if (!(this_3.n88_1 === this_2)) {
          this_3.n88_1 = this_2;
          this_3.x89();
        }
        this_2.z89(texture, VOID, VOID, VOID, VOID, get_immutable(ctx.m87_1.v8g()));
        ctx.x89();
      }finally {
        ctx.s8i(rb);
      }
    } else {
      renderCommands(this, ctx, doRequireTexture);
    }
    var time = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
  }
}
class ScissorCommand {
  constructor(scissor) {
    this.lbt_1 = scissor;
  }
  toString() {
    return 'ScissorCommand(scissor=' + this.lbt_1.toString() + ')';
  }
  hashCode() {
    return this.lbt_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScissorCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ScissorCommand ? other : THROW_CCE();
    if (!this.lbt_1.equals(tmp0_other_with_cast.lbt_1))
      return false;
    return true;
  }
}
class ClearCommand {
  constructor(i) {
    this.mbt_1 = i;
  }
  toString() {
    return 'ClearCommand(i=' + this.mbt_1 + ')';
  }
  hashCode() {
    return this.mbt_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClearCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ClearCommand ? other : THROW_CCE();
    if (!(this.mbt_1 === tmp0_other_with_cast.mbt_1))
      return false;
    return true;
  }
}
class ShapeCommand {
  constructor(drawType, vertexIndex, vertexEnd, paintShader, program, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace) {
    drawType = drawType === VOID ? Companion_getInstance_16().i6x_1 : drawType;
    vertexIndex = vertexIndex === VOID ? 0 : vertexIndex;
    vertexEnd = vertexEnd === VOID ? 0 : vertexEnd;
    program = program === VOID ? null : program;
    colorMask = colorMask === VOID ? Companion_getInstance_22().b6p_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_17().y6o_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_18().w6o_1 : stencilRef;
    blendMode = blendMode === VOID ? null : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_21().m6p_1 : cullFace;
    this.nbt_1 = drawType;
    this.obt_1 = vertexIndex;
    this.pbt_1 = vertexEnd;
    this.qbt_1 = paintShader;
    this.rbt_1 = program;
    this.sbt_1 = colorMask;
    this.tbt_1 = stencilOpFunc;
    this.ubt_1 = stencilRef;
    this.vbt_1 = blendMode;
    this.wbt_1 = cullFace;
  }
  h8f() {
    return this.pbt_1 - this.obt_1 | 0;
  }
  toString() {
    return 'ShapeCommand(drawType=' + AGDrawType__toString_impl_eonaeb(this.nbt_1) + ', vertexIndex=' + this.obt_1 + ', vertexEnd=' + this.pbt_1 + ', paintShader=' + toString_0(this.qbt_1) + ', program=' + toString_0(this.rbt_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.sbt_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.tbt_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.ubt_1) + ', blendMode=' + toString_0(this.vbt_1) + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.wbt_1) + ')';
  }
  hashCode() {
    var result = AGDrawType__hashCode_impl_ylaury(this.nbt_1);
    result = imul(result, 31) + this.obt_1 | 0;
    result = imul(result, 31) + this.pbt_1 | 0;
    result = imul(result, 31) + (this.qbt_1 == null ? 0 : this.qbt_1.hashCode()) | 0;
    result = imul(result, 31) + (this.rbt_1 == null ? 0 : this.rbt_1.hashCode()) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.sbt_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.tbt_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.ubt_1) | 0;
    result = imul(result, 31) + (this.vbt_1 == null ? 0 : this.vbt_1.hashCode()) | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.wbt_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShapeCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ShapeCommand ? other : THROW_CCE();
    if (!(this.nbt_1 === tmp0_other_with_cast.nbt_1))
      return false;
    if (!(this.obt_1 === tmp0_other_with_cast.obt_1))
      return false;
    if (!(this.pbt_1 === tmp0_other_with_cast.pbt_1))
      return false;
    if (!equals(this.qbt_1, tmp0_other_with_cast.qbt_1))
      return false;
    if (!equals(this.rbt_1, tmp0_other_with_cast.rbt_1))
      return false;
    if (!(this.sbt_1 === tmp0_other_with_cast.sbt_1))
      return false;
    if (!(this.tbt_1 === tmp0_other_with_cast.tbt_1))
      return false;
    if (!equals(this.ubt_1, tmp0_other_with_cast.ubt_1))
      return false;
    if (!equals(this.vbt_1, tmp0_other_with_cast.vbt_1))
      return false;
    if (!(this.wbt_1 === tmp0_other_with_cast.wbt_1))
      return false;
    return true;
  }
}
class GpuShapeViewCommands {
  constructor() {
    this.vbr_1 = 0;
    this.wbr_1 = floatArrayListOf(new Float32Array([]));
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.xbr_1 = ArrayList.j1();
    this.ybr_1 = null;
    this.zbr_1 = FastArrayList.q10();
    this.abs_1 = 0;
    this.bbs_1 = 0;
    this.cbs_1 = MatrixTransform.v2f();
    this.dbs_1 = FastArrayList.q10();
    this.ebs_1 = AGTextureUnits.j6r();
  }
  k3() {
    this.vbr_1 = 0;
    this.wbr_1.k3();
    this.xbr_1.k3();
  }
  jbs(x, y, len, maxLen) {
    var tmp;
    if (maxLen <= 0.0) {
      var _unary__edvuaz = this.abs_1;
      this.abs_1 = _unary__edvuaz + 1 | 0;
      tmp = _unary__edvuaz <= 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      println('Invalid maxLen=' + maxLen);
    }
    this.wbr_1.e2o(x, y, len, maxLen);
    var _unary__edvuaz_0 = this.vbr_1;
    this.vbr_1 = _unary__edvuaz_0 + 1 | 0;
    return _unary__edvuaz_0;
  }
  ibs() {
    this.bbs_1 = this.vbr_1;
    return this.bbs_1;
  }
  kbs() {
    return this.vbr_1;
  }
  jbt(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.xbr_1;
    var element = new ShapeCommand(drawType, startIndex, endIndex, paintShader, VOID, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace);
    this_0.h(element);
  }
  ebt(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex, $super) {
    colorMask = colorMask === VOID ? Companion_getInstance_22().b6p_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_17().y6o_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_18().w6o_1 : stencilRef;
    blendMode = blendMode === VOID ? Companion_getInstance_13().q86_1 : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_21().m6p_1 : cullFace;
    startIndex = startIndex === VOID ? this.bbs_1 : startIndex;
    endIndex = endIndex === VOID ? this.vbr_1 : endIndex;
    var tmp;
    if ($super === VOID) {
      this.jbt(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.jbt.call(this, new AGDrawType(drawType), paintShader, new AGColorMask(colorMask), new AGStencilOpFunc(stencilOpFunc), new AGStencilReference(stencilRef), blendMode, new AGCullFace(cullFace), startIndex, endIndex);
    }
    return tmp;
  }
  u7d(i) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.xbr_1;
    var element = new ClearCommand(i);
    this_0.h(element);
  }
  fbs(i, $super) {
    i = i === VOID ? 0 : i;
    var tmp;
    if ($super === VOID) {
      this.u7d(i);
      tmp = Unit_instance;
    } else {
      tmp = $super.u7d.call(this, i);
    }
    return tmp;
  }
  gbs(scissor) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.xbr_1;
    var element = new ScissorCommand(scissor);
    this_0.h(element);
  }
  a6o() {
    var tmp0_safe_receiver = this.ybr_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.zbr_1.h(tmp0_safe_receiver);
    }
    this.ybr_1 = new AgCachedBuffer(_Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(this.wbr_1.j2o())));
  }
  hbs(ctx, globalMatrix, localMatrix, applyScissor, colorMul, doRequireTexture) {
    var tmp0_elvis_lhs = this.ybr_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var vertices = tmp;
    ctx.f88_1.l8e(this.zbr_1);
    this.zbr_1.k3();
    ctx.x89();
    var ag = ctx.l87_1;
    var vao = AGVertexArrayObject.t6w(fastArrayListOf([new AGVertexData(GpuShapeViewPrograms_getInstance().ubs_1, ctx.i8e(vertices))]), true);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.j88_1;
    var this_1 = this_0.s88_1;
    if (!(this_1.n88_1 === this_0)) {
      this_1.n88_1 = this_0;
      this_1.x89();
    }
    this_0.i8g();
    var tempMat = (doRequireTexture ? Companion_getInstance_30().m2d_1 : this_0.f8f()).x2e(globalMatrix);
    // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
    var this_2 = this_0.s88_1;
    this_2.x89();
    var temp4 = this_2.y87_1;
    var temp2d = this_2.z87_1;
    this_2.z87_1 = tempMat;
    this_2.y87_1 = toMatrix4(tempMat);
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_3 = this_2.a6v(ProjViewUB_getInstance());
      var _unary__edvuaz = this_3.p6w();
      this_3.g7j(_unary__edvuaz + 1 | 0);
      this_3.h7j(this_3.p6w() + 1 | 0);
      var blockSize = this_3.t6u_1;
      var index0 = imul(this_3.p6w() - 1 | 0, blockSize);
      var index1 = imul(this_3.p6w(), blockSize);
      var texBlockSize = this_3.q6u_1.p72().f1();
      var texIndex0 = imul(this_3.p6w() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_3.p6w(), texBlockSize);
      if (this_3.p6w() > 0) {
        arraycopy(this_3.v6u_1, index0, this_3.v6u_1, index1, blockSize);
      } else {
        arrayfill(this_3.v6u_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
      var $this$push = this_3.q6u_1;
      this_3.w6u_1.q7j($this$push.o72(), this_2.y87_1);
      if (true && this_3.p6w() >= 1) {
        var equals = arrayequal(this_3.v6u_1, index0, this_3.v6u_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_3.p6w();
          this_3.g7j(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    var tmp_0;
    try {
      this.cbs_1 = globalMatrix.z2e();
      var program = GpuShapeViewPrograms_getInstance().bbt_1;
      var scissor = Companion_getInstance_14().k6p_1;
      var this_4 = this.xbr_1;
      var n = 0;
      while (n < this_4.f1()) {
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var cmd = this_4.e1(_unary__edvuaz_1);
        if (cmd instanceof ScissorCommand) {
          scissor = cmd.lbt_1;
        } else {
          if (cmd instanceof ClearCommand) {
            var tmp1_stencil = cmd.mbt_1;
            ctx.m8i(VOID, VOID, tmp1_stencil, false, false, true);
          } else {
            if (cmd instanceof ShapeCommand) {
              var paintShader = cmd.qbt_1;
              this_0.o8g(cmd.h8f());
              var pixelScale = this.cbs_1.x2f() / ctx.m87_1.e8h();
              if (!(paintShader == null)) {
                $l$block_0: {
                  // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
                  var this_5 = this_0.s88_1.a6v(ShapeViewUB_getInstance());
                  var _unary__edvuaz_2 = this_5.p6w();
                  this_5.g7j(_unary__edvuaz_2 + 1 | 0);
                  this_5.h7j(this_5.p6w() + 1 | 0);
                  var blockSize_0 = this_5.t6u_1;
                  var index0_0 = imul(this_5.p6w() - 1 | 0, blockSize_0);
                  var index1_0 = imul(this_5.p6w(), blockSize_0);
                  var texBlockSize_0 = this_5.q6u_1.p72().f1();
                  var texIndex0_0 = imul(this_5.p6w() - 1 | 0, texBlockSize_0);
                  var texIndex1_0 = imul(this_5.p6w(), texBlockSize_0);
                  if (this_5.p6w() > 0) {
                    arraycopy(this_5.v6u_1, index0_0, this_5.v6u_1, index1_0, blockSize_0);
                  } else {
                    arrayfill(this_5.v6u_1, 0, 0, blockSize_0);
                  }
                  // Inline function 'korlibs.korge.view.vector.GpuShapeViewCommands.render.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var $this$push_0 = this_5.q6u_1;
                  var it = this_5.w6u_1;
                  it.k7j(paintShader.xbt_1);
                  it.l7j($this$push_0.mbu(), pixelScale);
                  it.n7j($this$push_0.nbu(), _RGBA___get_premultiplied__impl__3bulqc(colorMul));
                  if (true && this_5.p6w() >= 1) {
                    var equals_0 = arrayequal(this_5.v6u_1, index0_0, this_5.v6u_1, index1_0, blockSize_0);
                    if (equals_0) {
                      var _unary__edvuaz_3 = this_5.p6w();
                      this_5.g7j(_unary__edvuaz_3 - 1 | 0);
                      break $l$block_0;
                    }
                  }
                }
                if (!(paintShader.ybt_1 == null)) {
                  var tex = ctx.b88_1.z2t();
                  tex.h6t(paintShader.ybt_1);
                  this.ebs_1.a6s(DefaultShaders_getInstance().i75(), tex);
                  this.dbs_1.h(tex);
                }
              }
              var tmp2_elvis_lhs = cmd.rbt_1;
              var _program = tmp2_elvis_lhs == null ? program : tmp2_elvis_lhs;
              var tmp4_frameBuffer = ctx.o88_1.k6n_1;
              var tmp5_frameBufferInfo = ctx.o88_1.q6p();
              var tmp6_scissor = applyMatrixBounds(scissor, tempMat);
              var tmp7_uniformBlocks = ctx.d8i(_program);
              var tmp8_textureUnits = this.ebs_1.uz();
              var tmp9_stencilOpFunc = cmd.tbt_1;
              var tmp10_stencilRef = cmd.ubt_1;
              var tmp11_colorMask = cmd.sbt_1;
              var tmp3_elvis_lhs = cmd.vbt_1;
              var tmp12_blending = (tmp3_elvis_lhs == null ? Companion_getInstance_13().q86_1 : tmp3_elvis_lhs).a8a_1;
              var tmp13_cullFace = cmd.wbt_1;
              var tmp14_drawType = cmd.nbt_1;
              var tmp15_drawOffset = cmd.obt_1;
              var tmp16_vertexCount = cmd.h8f();
              draw(ag, new AGBatch(tmp4_frameBuffer, tmp5_frameBufferInfo, vao, VOID, VOID, _program, tmp7_uniformBlocks, tmp8_textureUnits, tmp12_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp6_scissor, tmp13_cullFace, tmp14_drawType, tmp15_drawOffset, tmp16_vertexCount));
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
      tmp_0 = Unit_instance;
    }finally {
      this_2.x89();
      this_2.y87_1 = temp4;
      this_2.z87_1 = temp2d;
      this_2.a6v(ProjViewUB_getInstance()).i7j();
    }
    var _iterator__ex2g4s = this.dbs_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var tex_0 = _iterator__ex2g4s.d1();
      ctx.b88_1.a2u(tex_0);
    }
    this.dbs_1.k3();
  }
}
class ShapeViewUB extends UniformBlock {
  constructor() {
    ShapeViewUB_instance = null;
    super(5);
    ShapeViewUB_instance = this;
    this.ebu_1 = this.u72().m72(this, u_ProgramType$factory());
    this.fbu_1 = this.w72().m72(this, u_Color$factory());
    this.gbu_1 = this.w72().m72(this, u_ColorMul$factory());
    this.hbu_1 = this.u72().m72(this, u_GlobalAlpha$factory());
    this.ibu_1 = this.u72().m72(this, u_GlobalPixelScale$factory());
    this.jbu_1 = this.c72().m72(this, u_Transform$factory());
    this.kbu_1 = this.w72().m72(this, u_Gradientp0$factory());
    this.lbu_1 = this.w72().m72(this, u_Gradientp1$factory());
  }
  obu() {
    return this.ebu_1.mo(this, u_ProgramType$factory_0());
  }
  pbu() {
    return this.fbu_1.mo(this, u_Color$factory_0());
  }
  nbu() {
    return this.gbu_1.mo(this, u_ColorMul$factory_0());
  }
  qbu() {
    return this.hbu_1.mo(this, u_GlobalAlpha$factory_0());
  }
  mbu() {
    return this.ibu_1.mo(this, u_GlobalPixelScale$factory_0());
  }
  rbu() {
    return this.jbu_1.mo(this, u_Transform$factory_0());
  }
  sbu() {
    return this.kbu_1.mo(this, u_Gradientp0$factory_0());
  }
  tbu() {
    return this.lbu_1.mo(this, u_Gradientp1$factory_0());
  }
}
class PaintShader {
  constructor(uniforms, texture, program) {
    uniforms = uniforms === VOID ? new UniformBlockBuffer(ShapeViewUB_getInstance()) : uniforms;
    program = program === VOID ? GpuShapeViewPrograms_getInstance().bbt_1 : program;
    this.xbt_1 = uniforms;
    this.ybt_1 = texture;
    this.zbt_1 = program;
  }
  toString() {
    return 'PaintShader(uniforms=' + this.xbt_1.toString() + ', texture=' + toString_0(this.ybt_1) + ', program=' + this.zbt_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.xbt_1);
    result = imul(result, 31) + (this.ybt_1 == null ? 0 : hashCode(this.ybt_1)) | 0;
    result = imul(result, 31) + this.zbt_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PaintShader))
      return false;
    var tmp0_other_with_cast = other instanceof PaintShader ? other : THROW_CCE();
    if (!equals(this.xbt_1, tmp0_other_with_cast.xbt_1))
      return false;
    if (!equals(this.ybt_1, tmp0_other_with_cast.ybt_1))
      return false;
    if (!this.zbt_1.equals(tmp0_other_with_cast.zbt_1))
      return false;
    return true;
  }
}
class GpuShapeViewPrograms {
  constructor() {
    GpuShapeViewPrograms_instance = this;
    this.lbs_1 = Attribute.s73('a_MaxDist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 4);
    this.mbs_1 = Attribute.s73('a_Dist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 5);
    this.nbs_1 = Varying.e74('v_MaxDist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.obs_1 = Varying.e74('v_Dist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.pbs_1 = ProgramLayout.d6x([DefaultShaders_getInstance().n70_1]);
    this.qbs_1 = ProgramLayout.d6x([DefaultShaders_getInstance().o70_1]);
    this.rbs_1 = ProgramLayout.d6x([this.mbs_1]);
    this.sbs_1 = ProgramLayout.d6x([DefaultShaders_getInstance().n70_1, DefaultShaders_getInstance().o70_1]);
    this.tbs_1 = ProgramLayout.d6x([DefaultShaders_getInstance().n70_1, this.mbs_1]);
    this.ubs_1 = ProgramLayout.d6x([DefaultShaders_getInstance().n70_1, this.mbs_1, this.lbs_1]);
    this.vbs_1 = 0;
    this.wbs_1 = 1;
    this.xbs_1 = 2;
    this.ybs_1 = 3;
    this.zbs_1 = 4;
    this.abt_1 = 5;
    var tmp = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.t74();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    this_0.y74(this_0.b75(), this_0.c75(this_0.c75(this_0.n72(), this_0.o72()), this_0.f75([this_0.d75(), this_0.e75(0.0), this_0.e75(1.0)])));
    this_0.y74(this_0.u74(), DefaultShaders_getInstance().n70_1);
    this_0.y74(GpuShapeViewPrograms_getInstance().obs_1, GpuShapeViewPrograms_getInstance().mbs_1);
    this_0.y74(GpuShapeViewPrograms_getInstance().nbs_1, GpuShapeViewPrograms_getInstance().lbs_1);
    var tmp0_vertex = VertexShader(this_0.g75());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_1 = ProgramBuilderDefault.t74();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_1.z76(GpuShapeViewPrograms_getInstance().obu(), this_1.e75(5));
    var body = this_1.p75();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body.y74(body.b75(), body.f75([body.e75(1.0), body.e75(0.0), body.e75(0.0), body.e75(1.0)]));
    body.i76();
    var stmIf = new If(cond, body.r75());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.x74_1.h(stmIf);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_0 = this_1.c77(this_1.o76(GpuShapeViewPrograms_getInstance().obs_1), GpuShapeViewPrograms_getInstance().nbs_1);
    var body_0 = this_1.p75();
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>' call
    body_0.g76();
    var stmIf_0 = new If(cond_0, body_0.r75());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.x74_1.h(stmIf_0);
    var tmp_0 = GpuShapeViewPrograms_getInstance().obu();
    this_1.f76(tmp_0, 0, 4, GpuShapeViewPrograms$PROGRAM_COMBINED$lambda(this_1));
    var aaAlpha = this_1.x76(this_1.e75(1.0), this_1.q76(this_1.x76(this_1.c75(GpuShapeViewPrograms_getInstance().nbs_1, GpuShapeViewPrograms_getInstance().mbu()), this_1.e75(1.5)), this_1.c75(GpuShapeViewPrograms_getInstance().nbs_1, GpuShapeViewPrograms_getInstance().mbu()), this_1.o76(this_1.c75(GpuShapeViewPrograms_getInstance().obs_1, GpuShapeViewPrograms_getInstance().mbu()))));
    this_1.y74(this_1.b75(), this_1.c75(this_1.c75(this_1.c75(this_1.b75(), GpuShapeViewPrograms_getInstance().nbu()), GpuShapeViewPrograms_getInstance().qbu()), aaAlpha));
    var tmp1_fragment = FragmentShader(this_1.g75());
    tmp.bbt_1 = new Program(tmp0_vertex, tmp1_fragment, 'GpuShapeViewPrograms.Combined');
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.Companion.single' call
    var block = ShapeViewUB_getInstance();
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var this_2 = new UniformBlockBuffer(block);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    this_2.p2u();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var _unary__edvuaz = this_2.p6w();
      this_2.g7j(_unary__edvuaz + 1 | 0);
      this_2.h7j(this_2.p6w() + 1 | 0);
      var blockSize = this_2.t6u_1;
      var index0 = imul(this_2.p6w() - 1 | 0, blockSize);
      var index1 = imul(this_2.p6w(), blockSize);
      var texBlockSize = this_2.q6u_1.p72().f1();
      var texIndex0 = imul(this_2.p6w() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_2.p6w(), texBlockSize);
      if (this_2.p6w() > 0) {
        arraycopy(this_2.v6u_1, index0, this_2.v6u_1, index1, blockSize);
      } else {
        arrayfill(this_2.v6u_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
      this_2.q6u_1;
      // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.stencilPaintShader.<anonymous>' call
      this_2.w6u_1.m7j(ShapeViewUB_getInstance().obu(), 5);
      if (true && this_2.p6w() >= 1) {
        var equals = arrayequal(this_2.v6u_1, index0, this_2.v6u_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_2.p6w();
          this_2.g7j(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    tmp_1.cbt_1 = new PaintShader(this_2, null);
  }
  obu() {
    return ShapeViewUB_getInstance().obu().j6w_1;
  }
  pbu() {
    return ShapeViewUB_getInstance().pbu().j6w_1;
  }
  nbu() {
    return ShapeViewUB_getInstance().nbu().j6w_1;
  }
  qbu() {
    return ShapeViewUB_getInstance().qbu().j6w_1;
  }
  mbu() {
    return ShapeViewUB_getInstance().mbu().j6w_1;
  }
  rbu() {
    return ShapeViewUB_getInstance().rbu().j6w_1;
  }
  sbu() {
    return ShapeViewUB_getInstance().sbu().j6w_1;
  }
  tbu() {
    return ShapeViewUB_getInstance().tbu().j6w_1;
  }
  ubu(_this__u8e3s4) {
    // Inline function 'korlibs.graphics.shader.Companion.invoke' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.<get-pow2>.<anonymous>' call
    var $this$ExpressionBuilder = Companion_getInstance_23().t7p_1;
    return $this$ExpressionBuilder.m76(_this__u8e3s4, $this$ExpressionBuilder.e75(2.0));
  }
  dbt(stateTransform, paint, globalAlpha, lineWidth) {
    var tmp;
    if (paint instanceof NonePaint) {
      tmp = null;
    } else {
      if (paint instanceof RGBA) {
        // Inline function 'korlibs.graphics.shader.Companion.single' call
        var block = ShapeViewUB_getInstance();
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.also' call
        var this_0 = new UniformBlockBuffer(block);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        this_0.p2u();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
          var _unary__edvuaz = this_0.p6w();
          this_0.g7j(_unary__edvuaz + 1 | 0);
          this_0.h7j(this_0.p6w() + 1 | 0);
          var blockSize = this_0.t6u_1;
          var index0 = imul(this_0.p6w() - 1 | 0, blockSize);
          var index1 = imul(this_0.p6w(), blockSize);
          var texBlockSize = this_0.q6u_1.p72().f1();
          var texIndex0 = imul(this_0.p6w() - 1 | 0, texBlockSize);
          var texIndex1 = imul(this_0.p6w(), texBlockSize);
          if (this_0.p6w() > 0) {
            arraycopy(this_0.v6u_1, index0, this_0.v6u_1, index1, blockSize);
          } else {
            arrayfill(this_0.v6u_1, 0, 0, blockSize);
          }
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
          var $this$push = this_0.q6u_1;
          // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
          var it = this_0.w6u_1;
          it.m7j($this$push.obu(), 0);
          it.n7j($this$push.pbu(), _RGBA___get_premultiplied__impl__3bulqc(paint.a4g_1));
          it.m7j($this$push.qbu(), globalAlpha);
          if (true && this_0.p6w() >= 1) {
            var equals = arrayequal(this_0.v6u_1, index0, this_0.v6u_1, index1, blockSize);
            if (equals) {
              var _unary__edvuaz_0 = this_0.p6w();
              this_0.g7j(_unary__edvuaz_0 - 1 | 0);
              break $l$block;
            }
          }
        }
        tmp = new PaintShader(this_0, null);
      } else {
        if (paint instanceof BitmapPaint) {
          var mat = Companion_getInstance_30().m2d_1.e2f(paint.o5h_1).e2f(stateTransform).y2e().m2e(1.0 / paint.n5h_1.z3y_1, 1.0 / paint.n5h_1.a3z_1);
          // Inline function 'korlibs.graphics.shader.Companion.single' call
          var block_0 = ShapeViewUB_getInstance();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.also' call
          var this_1 = new UniformBlockBuffer(block_0);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          this_1.p2u();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
          $l$block_0: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var _unary__edvuaz_1 = this_1.p6w();
            this_1.g7j(_unary__edvuaz_1 + 1 | 0);
            this_1.h7j(this_1.p6w() + 1 | 0);
            var blockSize_0 = this_1.t6u_1;
            var index0_0 = imul(this_1.p6w() - 1 | 0, blockSize_0);
            var index1_0 = imul(this_1.p6w(), blockSize_0);
            var texBlockSize_0 = this_1.q6u_1.p72().f1();
            var texIndex0_0 = imul(this_1.p6w() - 1 | 0, texBlockSize_0);
            var texIndex1_0 = imul(this_1.p6w(), texBlockSize_0);
            if (this_1.p6w() > 0) {
              arraycopy(this_1.v6u_1, index0_0, this_1.v6u_1, index1_0, blockSize_0);
            } else {
              arrayfill(this_1.v6u_1, 0, 0, blockSize_0);
            }
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
            var $this$push_0 = this_1.q6u_1;
            // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
            var it_0 = this_1.w6u_1;
            it_0.m7j($this$push_0.obu(), 1);
            it_0.q7j($this$push_0.rbu(), toMatrix4(mat));
            it_0.m7j($this$push_0.qbu(), globalAlpha);
            if (true && this_1.p6w() >= 1) {
              var equals_0 = arrayequal(this_1.v6u_1, index0_0, this_1.v6u_1, index1_0, blockSize_0);
              if (equals_0) {
                var _unary__edvuaz_2 = this_1.p6w();
                this_1.g7j(_unary__edvuaz_2 - 1 | 0);
                break $l$block_0;
              }
            }
          }
          tmp = new PaintShader(this_1, paint.n5h_1);
        } else {
          if (paint instanceof GradientPaint) {
            var gradientBitmap = Bitmap32.s3y(256, 1, VOID, true);
            // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
            var rect = gradientBitmap.d3z_1;
            if (true) {
              gradientBitmap.m3z();
            }
            var result;
            try {
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              paint.z5g(_RgbaPremultipliedArray___init__impl__lx83hy(gradientBitmap.p3y_1));
            }finally {
              result = true ? gradientBitmap.o3z(rect) : 0;
            }
            var npaint = paint.a5h(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_30().m2d_1.e2f(paint.v54_1).e2f(stateTransform));
            var mat_0 = paint.l54_1.r3_1 === 0 ? npaint.b55_1 : npaint.v54_1.y2e();
            // Inline function 'korlibs.graphics.shader.Companion.single' call
            var block_1 = ShapeViewUB_getInstance();
            // Inline function 'kotlin.also' call
            // Inline function 'kotlin.also' call
            var this_2 = new UniformBlockBuffer(block_1);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            this_2.p2u();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>' call
            $l$block_1: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var _unary__edvuaz_3 = this_2.p6w();
              this_2.g7j(_unary__edvuaz_3 + 1 | 0);
              this_2.h7j(this_2.p6w() + 1 | 0);
              var blockSize_1 = this_2.t6u_1;
              var index0_1 = imul(this_2.p6w() - 1 | 0, blockSize_1);
              var index1_1 = imul(this_2.p6w(), blockSize_1);
              var texBlockSize_1 = this_2.q6u_1.p72().f1();
              var texIndex0_1 = imul(this_2.p6w() - 1 | 0, texBlockSize_1);
              var texIndex1_1 = imul(this_2.p6w(), texBlockSize_1);
              if (this_2.p6w() > 0) {
                arraycopy(this_2.v6u_1, index0_1, this_2.v6u_1, index1_1, blockSize_1);
              } else {
                arrayfill(this_2.v6u_1, 0, 0, blockSize_1);
              }
              // Inline function 'korlibs.graphics.shader.Companion.single.<anonymous>.<anonymous>' call
              var $this$push_1 = this_2.q6u_1;
              // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.paintToShaderInfo.<anonymous>' call
              var it_1 = this_2.w6u_1;
              var tmp_0 = $this$push_1.obu();
              var tmp0 = paint.l54_1.r3_1;
              it_1.m7j(tmp_0, tmp0 === 1 ? 3 : tmp0 === 2 ? 4 : 2);
              it_1.q7j($this$push_1.rbu(), toMatrix4(mat_0));
              it_1.p7j($this$push_1.sbu(), new Vector4F(paint.m54_1, paint.n54_1, paint.o54_1, 1.0));
              it_1.p7j($this$push_1.tbu(), new Vector4F(paint.p54_1, paint.q54_1, paint.r54_1, 1.0));
              it_1.m7j($this$push_1.qbu(), globalAlpha);
              if (true && this_2.p6w() >= 1) {
                var equals_1 = arrayequal(this_2.v6u_1, index0_1, this_2.v6u_1, index1_1, blockSize_1);
                if (equals_1) {
                  var _unary__edvuaz_4 = this_2.p6w();
                  this_2.g7j(_unary__edvuaz_4 - 1 | 0);
                  break $l$block_1;
                }
              }
            }
            tmp = new PaintShader(this_2, gradientBitmap);
          } else {
            // Inline function 'kotlin.TODO' call
            var reason = 'paint=' + toString(paint);
            throw NotImplementedError.be('An operation is not implemented: ' + reason);
          }
        }
      }
    }
    return tmp;
  }
}
//endregion
function *_generator_invoke__zhh2q8($this, $this$withContext, $completion) {
  var tmp = KorgeRunner_instance.b9n($this.q9l_1.a9n(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $this.r9l_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_14;
function Companion_getInstance_36() {
  if (Companion_instance_14 === VOID)
    new Companion();
  return Companion_instance_14;
}
function *_generator_start__v5y7pu($this, entry, $completion) {
  var tmp = Companion_getInstance_1().k20($this.x9m_1);
  var tmp_0 = withContext(tmp, Korge$start$slambda_0($this, entry), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function Korge$_init_$lambda_95dffl(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$_init_$slambda_ys8r4w_0() {
  var i = new Korge$_init_$slambda_ys8r4w();
  var l = function (_this__u8e3s4, $completion) {
    return i.e9n(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$_init_$lambda_95dffl_0(it) {
  return Stage.u9p(it);
}
function Korge$start$slambda_0(this$0, $entry) {
  var i = new Korge$start$slambda(this$0, $entry);
  var l = function ($this$withContext, $completion) {
    return i.k1q($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_15;
function Companion_getInstance_37() {
  if (Companion_instance_15 === VOID)
    new Companion_0();
  return Companion_instance_15;
}
function *_generator_invoke__zhh2q8_0($this, $this$coroutineScope, $completion) {
  if (!($this.s9s_1.v9l_1 == null)) {
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var this_0 = $this.t9s_1.v9r_1;
    var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_33()));
    var name = 'sceneContainer';
    var size = Companion_getInstance_26().f2k_1;
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var tmp = views($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var views_0 = tmp;
    var width = size.nl();
    var height = size.ol();
    var rwidth = width;
    var rheight = height;
    if (width === 0.0 && height === 0.0) {
      var tmp_0 = findFirstAscendant(this_0, KorgeRunner$invoke$slambda$slambda$slambda$lambda);
      var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
      var tmp1_elvis_lhs = base == null ? null : base.d2m();
      rwidth = tmp1_elvis_lhs == null ? views_0.v9r_1.d2m() : tmp1_elvis_lhs;
      var tmp3_elvis_lhs = base == null ? null : base.e2m();
      rheight = tmp3_elvis_lhs == null ? views_0.v9r_1.e2m() : tmp3_elvis_lhs;
    }
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SceneContainer.w9x(views_0, defaultTransition, name, Size2D.f2i(rwidth, rheight));
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
    var tmp_1 = addTo(this_1, this_0).x9x($this.s9s_1.v9l_1, [], VOID, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  var tmp_2 = $this.u9s_1($this.t9s_1.v9r_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  if ($this.s9s_1.d9m_1) {
    var tmp_3 = $this.v9s_1.s8q($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = coroutineScope(KorgeRunner$invoke$slambda$slambda$slambda_0($this.y9x_1, $this.z9x_1, $this.a9y_1, $this.b9y_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($this$coroutineScope, $completion) {
    return i.k1q($this$coroutineScope, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$loop, $completion) {
  var gameWindow = $this$loop;
  if (Companion_getInstance_35().xv()) {
    println('Korui[0]');
  }
  $l$block: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name = 'configureGameWindow';
    var start = PerformanceCounter_getInstance().w6c();
    try {
      var tmp0_elvis_lhs = $this.e9y_1.l9m_1;
      var tmp;
      var tmp_0 = tmp0_elvis_lhs;
      if ((tmp_0 == null ? null : new RGBA(tmp_0)) == null) {
        tmp = Colors_getInstance().h40_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      configure($this.c9y_1, $this.d9y_1, $this.e9y_1.k9m_1, null, $this.e9y_1.c9m_1, tmp);
      break $l$block;
    }finally {
      var end = PerformanceCounter_getInstance().w6c();
      // Inline function 'korlibs.time.microseconds' call
      var this_0 = end - start;
      var tmp$ret$1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.e8q(name, tmp$ret$1);
    }
  }
  $l$block_0: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var start_0 = PerformanceCounter_getInstance().w6c();
    try {
      try {
        if (!($this.f9y_1 == null)) {
          var tmp_1 = readBitmap(get_resourcesVfs().hi($this.f9y_1), $this.g9y_1, $completion);
          if (tmp_1 === get_COROUTINE_SUSPENDED())
            tmp_1 = yield tmp_1;
          $this$loop.g8q(tmp_1);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.error' call
          var this_1 = Companion_getInstance_36().c9n_1;
          var level = Level_ERROR_getInstance();
          var tmp_2;
          if (this_1.x2x(level)) {
            // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var tmp$ret$2 = "Couldn't get the application icon";
            this_1.y2x(level, tmp$ret$2);
            tmp_2 = Unit_instance;
          }
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      break $l$block_0;
    }finally {
      var end_0 = PerformanceCounter_getInstance().w6c();
      // Inline function 'korlibs.time.microseconds' call
      var this_2 = end_0 - start_0;
      var tmp$ret$5 = toDuration(this_2, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.e8q('setIcon', tmp$ret$5);
    }
  }
  $this$loop.l8q($this$loop.e8i());
  if (Companion_getInstance_35().xv()) {
    println('CanvasApplicationEx.IN[0]');
  }
  var input = new Input();
  var stats = new Stats();
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$6 = $completion.zc();
  var this_3 = Views.i9y(tmp$ret$6.cn(gameWindow.z8p()).cn(new InjectorContext($this.e9y_1.x9l_1)).cn(SupervisorJob()).cn(CoroutineName.x1d('Views')), $this.e9y_1.s9m_1 ? AGPrint.m7h() : $this$loop.y8p(), $this.e9y_1.x9l_1, input, $this.e9y_1.w9l_1, stats, gameWindow, $this.e9y_1.e9m_1, $this.e9y_1.f9m_1, $this.e9y_1.g9m_1, VOID, $this.e9y_1.v9m_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>' call
  var tmp_3 = this_3.t27($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  if (Companion_getInstance_35().cw()) {
    Dyn__set_impl_2ozvx8(Companion_instance_13.o31(), 'views', this_3);
  }
  var views = this_3;
  $this.e9y_1.x9l_1.c6c(getKClass(GameWindow), gameWindow);
  $this.e9y_1.x9l_1.c6c(getKClass(Korge), $this.e9y_1);
  views.y9r_1 = $this$loop.n8q();
  views.j9y($this.e9y_1.t9m_1);
  views.k9y($this.e9y_1.u9m_1);
  views.p9r_1 = numberToInt($this.e9y_1.i9m_1.f2b_1);
  views.q9r_1 = numberToInt($this.e9y_1.i9m_1.g2b_1);
  views.t9r_1 = $this.e9y_1.j9m_1.c9q_1;
  views.s9r_1 = $this.e9y_1.j9m_1.b9q_1;
  views.u9r_1 = $this.e9y_1.j9m_1.d9q_1;
  views.j9s_1 = $this.e9y_1.w9m_1;
  $l$block_1: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_0 = 'prepareViews';
    var start_1 = PerformanceCounter_getInstance().w6c();
    try {
      KorgeReload_getInstance().o86(gameWindow);
      var tmp_4 = KorgeRunner_instance.l9y(views, gameWindow, true, $this$loop.k8q(), Companion_instance_1.y1x(), $this.e9y_1.p9m_1, $this.e9y_1.y9l_1).t19($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      break $l$block_1;
    }finally {
      var end_1 = PerformanceCounter_getInstance().w6c();
      // Inline function 'korlibs.time.microseconds' call
      var this_4 = end_1 - start_1;
      var tmp$ret$9 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.e8q(name_0, tmp$ret$9);
    }
  }
  $l$block_2: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_1 = 'completeViews';
    var start_2 = PerformanceCounter_getInstance().w6c();
    try {
      completeViews(views);
      break $l$block_2;
    }finally {
      var end_2 = PerformanceCounter_getInstance().w6c();
      // Inline function 'korlibs.time.microseconds' call
      var this_5 = end_2 - start_2;
      var tmp$ret$11 = toDuration(this_5, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.e8q(name_1, tmp$ret$11);
    }
  }
  launchImmediately(views, KorgeRunner$invoke$slambda$slambda_0($this.e9y_1, views, $this.h9y_1, gameWindow));
  if ($this.e9y_1.d9m_1) {
    var tmp_5 = gameWindow.s8q($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    gameWindow.q8q();
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, config, $completion) {
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
  beforeStartingKorge(config);
  if (null == null) {
    $l$block: {
      // Inline function 'korlibs.io.worker.Companion.init' call
      get_workerImpl().c3a();
      if (get_workerImpl().d3a()) {
        if (get_DEBUG_WORKER()) {
          println('INSIDE WORKER');
        }
        break $l$block;
      } else {
        if (get_DEBUG_WORKER()) {
          println('**NOT** INSIDE WORKER');
        }
      }
      // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
      get_nativeSoundProvider();
      get_RegisteredImageFormats().o5d([config.t9l_1]);
      var iconPath = config.n9m_1;
      var imageFormats = config.t9l_1;
      var entry = config.r9m_1;
      var windowSize = config.h9m_1;
      if (!Companion_getInstance_35().cw()) {
        var tmp = configureLoggerFromProperties(get_localCurrentDirVfs().hi('klogger.properties'), $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
      }
      var tmp0_elvis_lhs = config.u9l_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.js.getCoroutineContext' call
        tmp_0 = $completion.zc().md(CoroutineKey_getInstance());
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp1_elvis_lhs = tmp_0;
      var realGameWindow = tmp1_elvis_lhs == null ? CreateDefaultGameWindow(config.q9m_1.u8r(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, config.k9m_1)) : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = config.l9m_1;
      var tmp_1;
      var tmp_2 = tmp2_elvis_lhs;
      if ((tmp_2 == null ? null : new RGBA(tmp_2)) == null) {
        tmp_1 = Colors_getInstance().h40_1;
      } else {
        tmp_1 = tmp2_elvis_lhs;
      }
      realGameWindow.j8q(tmp_1);
      var tmp_3 = realGameWindow.t8q(KorgeRunner$invoke$slambda_0(realGameWindow, windowSize, config, iconPath, imageFormats, entry), $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
    }
  }
  return Unit_instance;
}
function prepareViewsBase$getRealXY($views, x, y, scaleCoords) {
  return $views.f8h(Vector2D.k2c(x, y));
}
function prepareViewsBase$mouseDown(input, $views, downPos, downTime, type, p, button) {
  input.s8b(button, true);
  input.r8b(p, false);
  input.r8b(p, true);
  $views.m9y();
  downPos._v = input.q8b();
  downTime._v = new DateTime(Companion_getInstance_5().s1x());
  input.c8b_1 = true;
}
function prepareViewsBase$mouseUp(input, $views, upPos, type, p, button) {
  input.s8b(button, false);
  input.r8b(p, false);
  $views.m9y();
  upPos._v = $views.m9q_1.q8b();
}
function prepareViewsBase$mouseMove($views, moveMouseOutsideInNextFrame, moveTime, type, p, inside) {
  $views.m9q_1.r8b(p, false);
  $views.m9q_1.c8b_1 = inside;
  if (!inside) {
    moveMouseOutsideInNextFrame._v = true;
  }
  $views.m9y();
  moveTime._v = new DateTime(Companion_getInstance_5().s1x());
}
function prepareViewsBase$mouseDrag($views, moveTime, type, p) {
  $views.m9q_1.r8b(p, false);
  $views.m9y();
  moveTime._v = new DateTime(Companion_getInstance_5().s1x());
}
function prepareViewsBase$dispatchSimulatedTouchEvent(mouseTouchEvent, $views, p, button, type, status) {
  mouseTouchEvent.j6j_1 = 0;
  mouseTouchEvent.m6j_1 = true;
  mouseTouchEvent.k6j_1 = Companion_getInstance_5().s1x();
  mouseTouchEvent.l6j_1 = false;
  mouseTouchEvent.u6j(type);
  mouseTouchEvent.z6j(button.a6n_1, p, status, VOID, Kind_MOUSE_getInstance(), button);
  mouseTouchEvent.v6j();
  $views.i6f(mouseTouchEvent);
}
function prepareViewsBase$gamepadUpdated(input, e) {
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = e.u6k_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.gamepadUpdated.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var gamepad = this_0[_unary__edvuaz];
    input.m8b_1[gamepad.v6k_1].d6l(gamepad);
  }
  input.t8b();
}
function prepareViewsBase$renderBlock($views, $fixedSizeStep, moveMouseOutsideInNextFrame, event) {
  try {
    $views.o9y($fixedSizeStep, $views.n9y(), event.y6f_1, event.z6f_1);
    $views.m9q_1.b8b_1 = false;
    if (moveMouseOutsideInNextFrame._v) {
      moveMouseOutsideInNextFrame._v = false;
      $views.m9q_1.b8b_1 = true;
      $views.m9q_1.c8b_1 = false;
      $views.m9y();
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = Companion_getInstance_36().c9n_1;
      var level = Level_ERROR_getInstance();
      var tmp;
      if (this_0.x2x(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.renderBlock.<anonymous>' call
        var tmp$ret$0 = 'views.gameWindow.onRenderEvent:';
        this_0.y2x(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      printStackTrace(e);
      if ($views.x9q_1)
        throw e;
    } else {
      throw $p;
    }
  }
}
function KorgeRunner$invoke$slambda_0($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
  var i = new KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry);
  var l = function ($this$loop, $completion) {
    return i.p9y($this$loop, $completion);
  };
  l.$arity = 1;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda($this$mapSingleton) {
  return new ResourcesRoot();
}
function KorgeRunner$prepareViewsBase$lambda_0($this$mapPrototype) {
  return new EmptyScene();
}
function KorgeRunner$prepareViewsBase$lambda_1($views, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().c9n_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<MouseEvent>:' + e.toString();
      this_0.y2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var p = prepareViewsBase$getRealXY($views, e.j6h_1, e.k6h_1, e.u6h_1);
    var tmp_0;
    switch (e.h6h_1.r3_1) {
      case 3:
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'mouseDown', p, e.l6h_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.l6h_1, Type_START_getInstance(), Status_ADD_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 2:
        prepareViewsBase$mouseUp($input, $views, $upPos, 'mouseUp', p, e.l6h_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.l6h_1, Type_END_getInstance(), Status_REMOVE_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 1:
        prepareViewsBase$mouseDrag($views, $moveTime, 'onMouseDrag', p);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.l6h_1, Type_MOVE_getInstance(), Status_KEEP_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 0:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseMove', p, true);
        tmp_0 = Unit_instance;
        break;
      case 4:
        tmp_0 = Unit_instance;
        break;
      case 5:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseEnter', p, true);
        tmp_0 = Unit_instance;
        break;
      case 6:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseExit', p, false);
        tmp_0 = Unit_instance;
        break;
      case 7:
        tmp_0 = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $views.i6f(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_2($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().c9n_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<KeyEvent>:' + e.toString();
      this_0.y2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.i6f(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_3($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().c9n_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GestureEvent>:' + e.toString();
      this_0.y2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.i6f(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_4($views) {
  return function (e) {
    $views.i6f(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_5($views) {
  return function (e) {
    $views.i6f(e);
    get_nativeSoundProvider().m2v(false);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_6($views) {
  return function (e) {
    $views.i6f(e);
    get_nativeSoundProvider().m2v(true);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_7($views) {
  return function (e) {
    $views.i6f(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda$slambda_0($views) {
  var i = new KorgeRunner$prepareViewsBase$lambda$slambda($views);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda_8($views) {
  return function (e) {
    try {
      $views.i6f(e);
    }finally {
      launchImmediately($views, KorgeRunner$prepareViewsBase$lambda$slambda_0($views));
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_9($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $moveTime) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().c9n_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<TouchEvent>:' + e.toString();
      this_0.y2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $input.p8b(e);
    var ee = $input.u8a_1;
    var _iterator__ex2g4s = ee.r6j().b1();
    while (_iterator__ex2g4s.c1()) {
      var t = _iterator__ex2g4s.d1();
      t.w6i_1 = prepareViewsBase$getRealXY($views, t.b6j(), t.c6j(), e.l6j_1);
    }
    $views.i6f(ee);
    var tmp_0;
    if (ee.s6j() === 1) {
      var start = ee.c6k();
      var end = ee.d6k();
      var t_0 = first(ee.r6j());
      var p = t_0.w6i_1;
      var x = t_0.b6j();
      var y = t_0.c6j();
      var button = MouseButton_LEFT_getInstance();
      if (start) {
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'onTouchStart', p, button);
      } else if (end) {
        prepareViewsBase$mouseUp($input, $views, $upPos, 'onTouchEnd', p, button);
      } else {
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'onTouchMove', p, true);
      }
      // Inline function 'kotlin.also' call
      var this_1 = $touchMouseEvent;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      this_1.i6h_1 = 0;
      this_1.l6h_1 = button;
      this_1.m6h_1 = end ? 0 : 1 << button.a6n_1;
      this_1.j6h_1 = numberToInt(x);
      this_1.k6h_1 = numberToInt(y);
      this_1.u6h_1 = false;
      this_1.v6h_1 = true;
      this_1.h6h_1 = start ? Type_DOWN_getInstance() : end ? Type_UP_getInstance() : Type_DRAG_getInstance();
      $views.i6f(this_1);
      var tmp_1;
      if (end) {
        $moveMouseOutsideInNextFrame._v = true;
        tmp_1 = Unit_instance;
      }
      tmp_0 = tmp_1;
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_10($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_36().c9n_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.x2x(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e.toString();
      this_0.y2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.i6f(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_11($views, $input) {
  return function (e) {
    prepareViewsBase$gamepadUpdated($input, e);
    $views.i6f(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_12($views, $ag) {
  return function (e) {
    $views.r9y($ag.y6n().r6n_1, $ag.y6n().s6n_1);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_13($views) {
  return function (it) {
    $views.i6f(it);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_14($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
  return function (event) {
    var tmp;
    if (!event.z6f_1) {
      prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
      tmp = Unit_instance;
    } else {
      var this_0 = $views.i9r_1;
      var frameBuffer = this_0.y6n();
      this_0.s87_1.p2u();
      this_0.l87_1.c6o();
      var tmp_0;
      try {
        this_0.t8i(frameBuffer);
        var tmp_1;
        try {
          if (!$renderShown._v) {
            $renderShown._v = true;
            $firstRenderDeferred.k1d(Unit_instance);
          }
          prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
          tmp_1 = Unit_instance;
        }finally {
          this_0.u8i();
        }
        tmp_0 = tmp_1;
      }finally {
        this_0.l87_1.v6j();
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
var KorgeRunner_instance;
function KorgeRunner_getInstance() {
  return KorgeRunner_instance;
}
function Korge_0(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowWidth, windowHeight, windowSize, virtualWidth, virtualHeight, virtualSize, scaleMode, scaleAnchor, clipBorders, displayMode, title, bgcolor, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, entry, $completion) {
  var tmp;
  if (args === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = args;
  }
  args = tmp;
  imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
  gameWindow = gameWindow === VOID ? null : gameWindow;
  mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  injector = injector === VOID ? new Injector() : injector;
  var tmp_0;
  if (configInjector === VOID) {
    tmp_0 = Korge$lambda;
  } else {
    tmp_0 = configInjector;
  }
  configInjector = tmp_0;
  debug = debug === VOID ? false : debug;
  trace = trace === VOID ? false : trace;
  context = context === VOID ? null : context;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  blocking = blocking === VOID ? true : blocking;
  gameId = gameId === VOID ? Companion_getInstance_36().d9n_1 : gameId;
  settingsFolder = settingsFolder === VOID ? null : settingsFolder;
  batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().o8e_1 : batchMaxQuads;
  windowWidth = windowWidth === VOID ? numberToInt(DefaultViewport_getInstance().a8c_1.f2b_1) : windowWidth;
  windowHeight = windowHeight === VOID ? numberToInt(DefaultViewport_getInstance().a8c_1.g2b_1) : windowHeight;
  windowSize = windowSize === VOID ? Size2D.h2b(windowWidth, windowHeight) : windowSize;
  virtualWidth = virtualWidth === VOID ? numberToInt(windowSize.f2b_1) : virtualWidth;
  virtualHeight = virtualHeight === VOID ? numberToInt(windowSize.g2b_1) : virtualHeight;
  virtualSize = virtualSize === VOID ? Size2D.h2b(virtualWidth, virtualHeight) : virtualSize;
  scaleMode = scaleMode === VOID ? Companion_getInstance_24().y2j_1 : scaleMode;
  scaleAnchor = scaleAnchor === VOID ? Companion_getInstance_25().n29() : scaleAnchor;
  clipBorders = clipBorders === VOID ? true : clipBorders;
  displayMode = displayMode === VOID ? new KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) : displayMode;
  title = title === VOID ? 'Game' : title;
  bgcolor = bgcolor === VOID ? Colors_getInstance().h40_1 : bgcolor;
  backgroundColor = backgroundColor === VOID ? bgcolor : backgroundColor;
  quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
  icon = icon === VOID ? null : icon;
  multithreaded = multithreaded === VOID ? null : multithreaded;
  forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
  var tmp_1;
  if (main === VOID) {
    tmp_1 = Korge$slambda_1();
  } else {
    tmp_1 = main;
  }
  main = tmp_1;
  debugAg = debugAg === VOID ? false : debugAg;
  debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
  debugFontColor = debugFontColor === VOID ? Colors_getInstance().g40_1 : debugFontColor;
  var tmp_2;
  if (stageBuilder === VOID) {
    tmp_2 = Korge$lambda_0;
  } else {
    tmp_2 = stageBuilder;
  }
  stageBuilder = tmp_2;
  targetFps = targetFps === VOID ? 0.0 : targetFps;
  preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
  debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
  var tmp_3;
  if (entry === VOID) {
    tmp_3 = Korge$slambda_2();
  } else {
    tmp_3 = entry;
  }
  entry = tmp_3;
  return (new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, VOID, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance)).z9p(entry, $completion);
}
function Korge$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$slambda_1() {
  var i = new Korge$slambda();
  var l = function (_this__u8e3s4, $completion) {
    return i.e9n(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$lambda_0(it) {
  return Stage.u9p(it);
}
function Korge$slambda_2() {
  var i = new Korge$slambda_0();
  var l = function (_this__u8e3s4, $completion) {
    return i.e9n(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function get_keys(_this__u8e3s4) {
  _init_properties_KeysEvents_kt__ekyd0z();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = keys$delegate;
    var property = keys$factory();
    var tmp0_elvis_lhs = this_0.c10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var keys$delegate;
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = $this.c9z_1.a9z_1.h21($this.d9z_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = $this.e9z_1.y9y_1.h21($this.f9z_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = $this.g9z_1.z9y_1.h21($this.h9z_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KeysEvents$lambda$slambda_2(this$0, $event) {
  var i = new KeysEvents$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.p6f_1;
    tmp.x9y_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.i9z().j9q_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_2(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_3(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_0(this$0, $event);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_0(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.p6f_1;
    tmp.x9y_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.i9z().j9q_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_3(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_4(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_1(this$0, $event);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_1(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.p6f_1;
    tmp.x9y_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.i9z().j9q_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_4(this$0, event));
    return Unit_instance;
  };
}
function keys$delegate$lambda($this$PropertyThis) {
  _init_properties_KeysEvents_kt__ekyd0z();
  return new KeysEvents($this$PropertyThis);
}
function keys$factory() {
  return getPropertyCallableRef('keys', 1, KProperty1, function (receiver) {
    return get_keys(receiver);
  }, null);
}
var properties_initialized_KeysEvents_kt_1mffin;
function _init_properties_KeysEvents_kt__ekyd0z() {
  if (!properties_initialized_KeysEvents_kt_1mffin) {
    properties_initialized_KeysEvents_kt_1mffin = true;
    keys$delegate = new PropertyThis(VOID, keys$delegate$lambda);
  }
}
function set_mouseHitSearch(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitSearch$delegate;
  var property = mouseHitSearch$factory();
  var tmp0_elvis_lhs = this_0.a10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitSearch(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitSearch$delegate;
    var property = mouseHitSearch$factory_0();
    var tmp = _this__u8e3s4.zz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a10_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitSearch$delegate;
function set_mouseHitResult(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResult$delegate;
  var property = mouseHitResult$factory();
  var tmp0_elvis_lhs = this_0.a10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResult(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResult$delegate;
    var property = mouseHitResult$factory_0();
    var tmp = _this__u8e3s4.zz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a10_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResult$delegate;
function set_mouseHitResultUsed(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResultUsed$delegate;
  var property = mouseHitResultUsed$factory();
  var tmp0_elvis_lhs = this_0.a10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResultUsed(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResultUsed$delegate;
    var property = mouseHitResultUsed$factory_0();
    var tmp = _this__u8e3s4.zz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a10_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResultUsed$delegate;
function set_mouseDebugHandlerOnce(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugHandlerOnce$delegate;
  var property = mouseDebugHandlerOnce$factory();
  var tmp0_elvis_lhs = this_0.a10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugHandlerOnce(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugHandlerOnce$delegate;
    var property = mouseDebugHandlerOnce$factory_0();
    var tmp = _this__u8e3s4.zz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a10_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugHandlerOnce$delegate;
function set_mouseDebugLastFrameClicked(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugLastFrameClicked$delegate;
  var property = mouseDebugLastFrameClicked$factory();
  var tmp0_elvis_lhs = this_0.a10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugLastFrameClicked(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugLastFrameClicked$delegate;
    var property = mouseDebugLastFrameClicked$factory_0();
    var tmp = _this__u8e3s4.zz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a10_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugLastFrameClicked$delegate;
function get_mouse(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = mouse$delegate;
    var property = mouse$factory();
    var tmp0_elvis_lhs = this_0.c10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouse$delegate;
function set_cursor(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = cursor$delegate;
  var property = cursor$factory();
  var tmp0_elvis_lhs = this_0.a10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_cursor(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = cursor$delegate;
    var property = cursor$factory_0();
    var tmp = _this__u8e3s4.zz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a10_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var cursor$delegate;
function mouseHitTest($this, views) {
  if (!get_mouseHitSearch(views.m9q_1)) {
    set_mouseHitSearch(views.m9q_1, true);
    set_mouseHitResult(views.m9q_1, views.v9r_1.k9z(views.j9z()));
    var view = get_mouseHitResult(views.m9q_1);
    $l$loop: while (!(view == null) && get_cursor(view) == null) {
      view = view.k28();
    }
    var tmp0_safe_receiver = view;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_cursor(tmp0_safe_receiver);
    var newCursor = tmp1_elvis_lhs == null ? Cursor_DEFAULT_getInstance() : tmp1_elvis_lhs;
    if (!equals(views.p9q_1.x8p(), newCursor)) {
      views.p9q_1.w8p(newCursor);
    }
  }
  return get_mouseHitResult(views.m9q_1);
}
function MouseEvents$Companion$installDebugExtensionOnce$lambda($views) {
  return function (_this__u8e3s4, ctx) {
    var scale = ctx.g8i();
    // Inline function 'kotlin.math.max' call
    var a = 1 * scale;
    var space = Math.max(a, 2.0);
    var matrix = $views.v8g();
    var yy = 60 * scale;
    var lineHeight = 8 * scale;
    var mouseHit = mouseHitTest(Companion_instance_16, $views);
    var tmp;
    if (!(mouseHit == null)) {
      var bounds = mouseHit.l9z();
      if (get_mouseDebugLastFrameClicked(_this__u8e3s4)) {
        $views.m9z(mouseHit);
      }
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = _this__u8e3s4.i9r_1.j88_1;
      var this_1 = this_0.s88_1;
      if (!(this_1.n88_1 === this_0)) {
        this_1.n88_1 = this_0;
        this_1.x89();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$1 = get_Bitmaps_white();
      var tmp0_tex = ctx.y89(tmp$ret$1);
      var tmp1_x = bounds.k2a_1;
      var tmp2_y = bounds.l2a_1;
      var tmp3_width = bounds.m2a_1;
      var tmp4_height = bounds.n2a_1;
      var tmp5_colorMul = RGBA__withAd_impl_cralao(Colors_getInstance().i40_1, 0.3);
      var tmp6_m = mouseHit.n9z();
      this_0.z89(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp6_m, VOID, tmp5_colorMul);
      var tmp7_$receiver = _this__u8e3s4.i9r_1;
      var tmp8_font = _this__u8e3s4.o9z();
      var tmp9_str = toString_0(mouseHit) + ' : ' + $views.j9z().a2a_1 + ',' + $views.j9z().b2a_1;
      var tmp10_y = numberToInt(yy);
      var tmp11_colMul = ctx.i88_1;
      var tmp12_blendMode = Companion_getInstance_13().a87_1;
      var tmp13_m = get_immutable(matrix);
      drawText(tmp7_$receiver, tmp8_font, lineHeight, tmp9_str, 0, tmp10_y, tmp13_m, tmp11_colMul, tmp12_blendMode, false);
      yy = yy + lineHeight;
      yy = yy + space;
      tmp = Unit_instance;
    }
    var mouseHitResultUsed = get_mouseHitResultUsed(_this__u8e3s4.m9q_1);
    var tmp_0;
    if (!(mouseHitResultUsed == null)) {
      var bounds_0 = mouseHitResultUsed.l9z();
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_2 = _this__u8e3s4.i9r_1.j88_1;
      var this_3 = this_2.s88_1;
      if (!(this_3.n88_1 === this_2)) {
        this_3.n88_1 = this_2;
        this_3.x89();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$4 = get_Bitmaps_white();
      var tmp0_tex_0 = ctx.y89(tmp$ret$4);
      var tmp1_x_0 = bounds_0.k2a_1;
      var tmp2_y_0 = bounds_0.l2a_1;
      var tmp3_width_0 = bounds_0.m2a_1;
      var tmp4_height_0 = bounds_0.n2a_1;
      var tmp5_colorMul_0 = Companion_getInstance_2().q4e(0, 0, 255, 63);
      var tmp6_m_0 = mouseHitResultUsed.n9z();
      this_2.z89(tmp0_tex_0, tmp1_x_0, tmp2_y_0, tmp3_width_0, tmp4_height_0, tmp6_m_0, VOID, tmp5_colorMul_0);
      var vview = mouseHitResultUsed;
      while (!(vview == null)) {
        var tmp7_$receiver_0 = _this__u8e3s4.i9r_1;
        var tmp8_font_0 = _this__u8e3s4.o9z();
        var tmp9_str_0 = vview.toString();
        var tmp10_y_0 = numberToInt(yy);
        var tmp11_colMul_0 = ctx.i88_1;
        var tmp12_blendMode_0 = Companion_getInstance_13().a87_1;
        var tmp13_m_0 = get_immutable(matrix);
        drawText(tmp7_$receiver_0, tmp8_font_0, lineHeight, tmp9_str_0, 0, tmp10_y_0, tmp13_m_0, tmp11_colMul_0, tmp12_blendMode_0, false);
        vview = vview.k28();
        yy = yy + lineHeight;
        yy = yy + space;
      }
      tmp_0 = Unit_instance;
    }
    set_mouseDebugLastFrameClicked(_this__u8e3s4, false);
    return Unit_instance;
  };
}
function MouseEvents$MouseEventsUpdate$lambda(this$0) {
  return function ($this$addUpdaterWithViews, views, dt) {
    this$0.ea1(views, dt.qj_1);
    return Unit_instance;
  };
}
var Companion_instance_16;
function Companion_getInstance_38() {
  return Companion_instance_16;
}
function temporalLastEvent($this, lastEventNew, block) {
  var old = $this.za0_1;
  var tmp = $this;
  tmp.za0_1 = lastEventNew == null ? $this.za0_1 : lastEventNew;
  try {
    return block();
  }finally {
    $this.za0_1 = old;
  }
}
function MouseEvents$closeable$lambda(this$0) {
  return function (event) {
    var tmp;
    if (!this$0.q9z_1.ja1()) {
      return Unit_instance;
    }
    var tmp_0 = this$0;
    var tmp_1 = event.p6f_1;
    tmp_0.r9z_1 = tmp_1 instanceof Views ? tmp_1 : THROW_CCE();
    this$0.ya0_1 = event;
    this$0.za0_1.z6h(event);
    this$0.aa1_1 = event.v6h_1;
    this$0.xa0_1 = true;
    var tmp_2;
    switch (event.h6h_1.r3_1) {
      case 2:
        this$0.ba1_1.z6h(event);
        this$0.sa0_1 = this$0.ka1().m9q_1.q8b();
        this$0.pa0_1 = PerformanceCounter_getInstance().x6c();
        var elapsedTime = Duration__minus_impl_q5cfm7(this$0.pa0_1, this$0.qa0_1);
        var tmp_3;
        if (this$0.sa0_1.y2k(this$0.ra0_1) < this$0.ka1().m9q_1.x8a_1 && Duration__compareTo_impl_pchp0f(elapsedTime, this$0.ka1().m9q_1.w8a_1) < 0) {
          var _unary__edvuaz = this$0.wa0_1;
          this$0.wa0_1 = _unary__edvuaz + 1 | 0;
          var tmp_4;
          if (this$0.la1()) {
            this$0.t9z_1.x20(this$0);
            var tmp_5;
            if (this$0.t9z_1.b21() > 0) {
              event.s6f(this$0.q9z_1);
              tmp_5 = Unit_instance;
            }
            tmp_4 = tmp_5;
          }
          tmp_3 = tmp_4;
        }

        tmp_2 = tmp_3;
        break;
      case 3:
        if (!event.s6h_1) {
          set_mouseDebugLastFrameClicked(this$0.ka1(), true);
        }

        this$0.qa0_1 = PerformanceCounter_getInstance().x6c();
        this$0.ra0_1 = this$0.ka1().m9q_1.q8b();
        var tmp_6;
        if (this$0.s9z_1.c21()) {
          var tmp_7;
          if (this$0.la1()) {
            this$0.s9z_1.x20(this$0);
            tmp_7 = Unit_instance;
          }
          tmp_6 = tmp_7;
        }

        tmp_2 = tmp_6;
        break;
      case 7:
        if (this$0.la1()) {
          this$0.ia0_1.x20(this$0);
        } else {
          this$0.ka0_1.x20(this$0);
        }

        this$0.ja0_1.x20(this$0);
        tmp_2 = Unit_instance;
        break;
      default:
        tmp_2 = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
function MouseEvents$update$lambda($over, this$0) {
  return function () {
    var tmp;
    if ($over) {
      this$0.z9z_1.x20(this$0);
      tmp = Unit_instance;
    } else {
      this$0.aa0_1.x20(this$0);
      this$0.ca0_1.x20(this$0);
      tmp = Unit_instance;
    }
    this$0.da0_1.x20(this$0);
    return Unit_instance;
  };
}
function mouseHitSearch$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouseHitResult$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseHitResultUsed$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseDebugHandlerOnce$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return new Once();
}
function mouseDebugLastFrameClicked$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouse$delegate$lambda($this$PropertyThis) {
  _init_properties_MouseEvents_kt__io5soc();
  return new MouseEvents($this$PropertyThis);
}
function cursor$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseHitSearch$factory() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitSearch$factory_0() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitResult$factory() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResult$factory_0() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResultUsed$factory() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseHitResultUsed$factory_0() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory_0() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory_0() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouse$factory() {
  return getPropertyCallableRef('mouse', 1, KProperty1, function (receiver) {
    return get_mouse(receiver);
  }, null);
}
function cursor$factory() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
function cursor$factory_0() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
var properties_initialized_MouseEvents_kt_t0zz8y;
function _init_properties_MouseEvents_kt__io5soc() {
  if (!properties_initialized_MouseEvents_kt_t0zz8y) {
    properties_initialized_MouseEvents_kt_t0zz8y = true;
    mouseHitSearch$delegate = new Property(VOID, mouseHitSearch$delegate$lambda);
    mouseHitResult$delegate = new Property(VOID, mouseHitResult$delegate$lambda);
    mouseHitResultUsed$delegate = new Property(VOID, mouseHitResultUsed$delegate$lambda);
    mouseDebugHandlerOnce$delegate = new Property(VOID, mouseDebugHandlerOnce$delegate$lambda);
    mouseDebugLastFrameClicked$delegate = new Property(VOID, mouseDebugLastFrameClicked$delegate$lambda);
    mouse$delegate = new PropertyThis(VOID, mouse$delegate$lambda);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = cursor$delegate$lambda;
    cursor$delegate = new Property(null, default_0);
  }
}
function set__debugAnnotateView(_this__u8e3s4, _set____db54di) {
  _init_properties_RenderContextExt_kt__49d41k();
  var this_0 = _debugAnnotateView$delegate;
  var property = _debugAnnotateView$factory();
  var tmp0_elvis_lhs = this_0.a10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _debugAnnotateView$delegate;
    var property = _debugAnnotateView$factory_0();
    var tmp = _this__u8e3s4.zz();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a10_1;
      tmp_0 = tmp0_safe_receiver.f3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _debugAnnotateView$delegate;
function get_debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  return get__debugAnnotateView(_this__u8e3s4);
}
function get_views(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp = _this__u8e3s4.m87_1;
  return tmp instanceof Views ? tmp : null;
}
function _debugAnnotateView$delegate$lambda() {
  _init_properties_RenderContextExt_kt__49d41k();
  return null;
}
function _debugAnnotateView$factory() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
function _debugAnnotateView$factory_0() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
var properties_initialized_RenderContextExt_kt_9hx4ly;
function _init_properties_RenderContextExt_kt__49d41k() {
  if (!properties_initialized_RenderContextExt_kt_9hx4ly) {
    properties_initialized_RenderContextExt_kt_9hx4ly = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _debugAnnotateView$delegate$lambda;
    _debugAnnotateView$delegate = new Property(null, default_0);
  }
}
function *_generator_sceneAfterDestroyInternal__rup219($this, $completion) {
  var tmp = $this.ma2($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    cancel($this.b17(), SceneCancellationException.ba2($this));
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function Scene$coroutineContext$delegate$lambda(this$0) {
  return function () {
    return this$0.ka1().j9q_1.cn(new InjectorContext(this$0.na2())).cn(SupervisorJob(this$0.ka1().j9q_1.md(Key_instance))).cn(CoroutineName.x1d('Scene:' + toString(this$0)));
  };
}
function Scene$sceneView$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.apply' call
    var this_0 = this$0.pa2(this$0.oa2().f1());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.Scene.sceneView$delegate.<anonymous>.<anonymous>' call
    this$0.ha2_1.ya4(this_0);
    return this_0;
  };
}
function Scene$resources$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.inject.Injector.getSync' call
    return this$0.na2().l6c(getKClass(Resources));
  };
}
function delay(_this__u8e3s4, time, $completion) {
  return delay_0(_this__u8e3s4.ca5(), time, $completion);
}
function coroutineContext$factory() {
  return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
    return receiver.b17();
  }, null);
}
function sceneView$factory() {
  return getPropertyCallableRef('sceneView', 1, KProperty1, function (receiver) {
    return receiver.ca5();
  }, null);
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var scene = $this.ha8_1.t9x_1;
  if (!(scene == null)) {
    println('[ReloadEvent] Reloading ' + toString_0($this.ha8_1.t9x_1) + ' . doFullReload=' + $this.ia8_1.pa8());
    var tmp;
    if ($this.ia8_1.pa8()) {
      tmp = $this.ia8_1.qa8(getKClassFromExpression(scene), scene.na2());
    } else {
      tmp = getKClassFromExpression(scene);
    }
    var tmp_0 = tmp;
    var sceneClass = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
    var this_0 = $this.ha8_1;
    var injects = [];
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var time = toDuration(0, DurationUnit_SECONDS_getInstance());
    var transition = this_0.r9x_1;
    var sceneInjector = this_0.q9x_1.l9q_1.e6c().c6c(getKClass(SceneContainer), this_0).c6c(getKClass(Resources), new Resources(this_0.b17(), this_0.q9x_1.s9y().t37_1, this_0.q9x_1.s9y()));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < injects.length) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var inject = injects[_unary__edvuaz];
      var tmp_1 = getKClassFromExpression(inject);
      sceneInjector.c6c(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), inject);
    }
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = sceneInjector.l6c(sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $this.ia8_1.i86(scene, this_1);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    var newScene = this_1;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_39().ra8_1;
    var level = Level_INFO_getInstance();
    var tmp_2;
    if (this_2.x2x(level)) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var tmp$ret$4 = 'Changing scene to... ' + toString(sceneClass) + ' ... ' + toString(newScene);
      this_2.y2x(level, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
    if (false) {
      newScene.n6c(sceneInjector);
      var tmp_3 = getKClassFromExpression(newScene);
      var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
      this_0.q9x_1.l9q_1.g6c(tmp_4, SceneContainer$lambda$slambda$lambda(sceneInjector, sceneClass, $this.ia8_1, scene));
    }
    var tmp_5 = this_0.ta8(newScene, time, transition, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var scene_0 = tmp_5;
    scene_0.ka1().m9z(scene_0.ca5());
  }
  return Unit_instance;
}
function SceneContainer$lambda$slambda$lambda($sceneInjector, $sceneClass, $event, $scene) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = $sceneInjector.l6c($sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $event.i86($scene, this_0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    return this_0;
  };
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.ua8_1.ca5();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.ua8_1.pa7(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return this_0;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.va8_1.ca5();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.va8_1.qa7(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  var tmp = $this.wa8_1.sa7($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  var tmp = $this.xa8_1.ta7($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.xa8_1.ua7();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  var tmp = $this.ya8_1.va7($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  var tmp = $this.za8_1.ra7($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator__changeTo__ueovgq($this, clazz, injects, time, transition, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects_0 = injects.slice();
  var sceneInjector = $this.q9x_1.l9q_1.e6c().c6c(getKClass(SceneContainer), $this).c6c(getKClass(Resources), new Resources($this.b17(), $this.q9x_1.s9y().t37_1, $this.q9x_1.s9y()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.c6c(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
  var newScene = sceneInjector.l6c(clazz);
  // Inline function 'korlibs.logger.Logger.info' call
  var this_0 = Companion_getInstance_39().ra8_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_0.x2x(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_0.y2x(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (false) {
    newScene.n6c(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    $this.q9x_1.l9q_1.g6c(tmp_2, SceneContainer$_changeTo$lambda(sceneInjector, clazz));
  }
  var tmp_3 = $this.ta8(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return tmp_3;
}
function _changeTo($this, clazz, injects, time, transition, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq.bind(VOID, $this, clazz, injects, time, transition), $completion);
}
function *_generator__changeTo__ueovgq_0($this, newScene, time, transition, $completion) {
  var oldScene = $this.t9x_1;
  $this.t9x_1 = newScene;
  $this.s9x_1.lab(newScene.ha2_1, transition);
  try {
    var tmp = newScene.b17();
    var tmp_0 = launchUnscopedAndWait(tmp, SceneContainer$_changeTo$slambda_5(newScene), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  finally {
  }
  launchUnscoped(newScene, SceneContainer$_changeTo$slambda_6(newScene));
  if (!(oldScene == null)) {
    var tmp_1 = oldScene.b17();
    var tmp_2 = launchUnscopedAndWait(tmp_1, SceneContainer$_changeTo$slambda_7(oldScene), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$3 = toDuration(0, DurationUnit_SECONDS_getInstance());
  if (Duration__compareTo_impl_pchp0f(time, tmp$ret$3) > 0) {
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = ratio$factory($this.s9x_1);
    var initial = Companion_getInstance_34().mz_1;
    var end = Companion_getInstance_34().pz_1;
    var tmp$ret$4 = new V2(this_0, new Ratio(initial), new Ratio(end), _interpolateRatio$ref(), true);
    var tmp_3 = tween($this.s9x_1, [tmp$ret$4], time, VOID, VOID, VOID, VOID, VOID, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  } else {
    $this.s9x_1.iab_1 = Companion_getInstance_34().pz_1;
  }
  $this.s9x_1.mab();
  if (!(oldScene == null)) {
    var tmp_4 = oldScene.b17();
    var tmp_5 = launchUnscopedAndWait(tmp_4, SceneContainer$_changeTo$slambda_8(oldScene), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    launchUnscoped(oldScene, SceneContainer$_changeTo$slambda_9(oldScene));
  }
  var tmp_6 = newScene.b17();
  launchUnscoped_0(tmp_6, SceneContainer$_changeTo$slambda_10(newScene));
  return newScene;
}
var Companion_instance_17;
function Companion_getInstance_39() {
  if (Companion_instance_17 === VOID)
    new Companion_2();
  return Companion_instance_17;
}
function SceneContainer$lambda$lambda(this$0) {
  return function (it) {
    var tmp;
    if (it instanceof SceneContainer) {
      tmp = !equals(it, this$0);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function SceneContainer$lambda$slambda_0(this$0, $event) {
  var i = new SceneContainer$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$lambda(this$0) {
  return function (event) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var hasChildScenes = !descendantsWith(this$0, VOID, SceneContainer$lambda$lambda(this$0)).h1();
    var tmp;
    if (hasChildScenes) {
      println('[ReloadEvent] Scene ' + toString_0(this$0.t9x_1) + ' not reloaded because has child scenes...');
      return Unit_instance;
    }
    launchImmediately(this$0, SceneContainer$lambda$slambda_0(this$0, event));
    return Unit_instance;
  };
}
function SceneContainer$_changeTo$lambda($sceneInjector, $clazz) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
    return $sceneInjector.l6c($clazz);
  };
}
function SceneContainer$_changeTo$slambda_5($newScene) {
  var i = new SceneContainer$_changeTo$slambda($newScene);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_6($newScene) {
  var i = new SceneContainer$_changeTo$slambda_0($newScene);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_7($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_1($oldScene);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function _interpolateRatio$ref() {
  var l = function (p0, p1, p2) {
    return new Ratio(_interpolateRatio(p0.lz_1, p1.lz_1, p2.lz_1));
  };
  l.callableName = '_interpolateRatio';
  return l;
}
function SceneContainer$_changeTo$slambda_8($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_2($oldScene);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_9($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_3($oldScene);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_10($newScene) {
  var i = new SceneContainer$_changeTo$slambda_4($newScene);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function ratio$factory($b0) {
  return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
    return new Ratio($b0.iab_1);
  }, function (value) {
    $b0.iab_1 = value.lz_1;
    return Unit_instance;
  });
}
function get_AlphaTransition() {
  _init_properties_Transition_kt__s6zoln();
  return AlphaTransition;
}
var AlphaTransition;
function Transition(name, render) {
  name = name === VOID ? 'Transition' : name;
  _init_properties_Transition_kt__s6zoln();
  return new Transition$1(render, name);
}
function withEasing(_this__u8e3s4, easing) {
  _init_properties_Transition_kt__s6zoln();
  return new withEasing$1(_this__u8e3s4, easing);
}
function _get_transitionProcess__5hlux5($this) {
  var tmp = $this.kab_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('transitionProcess');
  }
}
function AlphaTransition$lambda(ctx, prev, next, ratio) {
  _init_properties_Transition_kt__s6zoln();
  var prevAlpha = prev.oaj();
  var nextAlpha = next.oaj();
  try {
    prev.naj(1.0 - Ratio__toFloat_impl_1ftup5(ratio.lz_1));
    next.naj(Ratio__toFloat_impl_1ftup5(ratio.lz_1));
    prev.qae(ctx);
    next.qae(ctx);
  }finally {
    prev.naj(prevAlpha);
    next.naj(nextAlpha);
  }
  return Unit_instance;
}
var properties_initialized_Transition_kt_wb2qvd;
function _init_properties_Transition_kt__s6zoln() {
  if (!properties_initialized_Transition_kt_wb2qvd) {
    properties_initialized_Transition_kt_wb2qvd = true;
    AlphaTransition = Transition('AlphaTransition', AlphaTransition$lambda);
  }
}
function createProgram$_anonymous_$lambda$0_hhid5m($median$delegate) {
  return $median$delegate.mo(null, getLocalDelegateReference('median', KProperty0, false, function () {
    return THROW_ISE();
  }));
}
function MsdfRender$createProgram$lambda($this$FUNC, a, b, c) {
  $this$FUNC.h76($this$FUNC.u7q($this$FUNC.t7q(a, b), $this$FUNC.t7q($this$FUNC.u7q(a, b), c)));
  return Unit_instance;
}
function MsdfRender$createProgram$lambda_0($$this$buildShader) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.y74($this$IF_ELSE_BINARY_LOOKUP.b75(), $this$IF_ELSE_BINARY_LOOKUP.j75(Companion_getInstance_6().m8e_1[n], $this$IF_ELSE_BINARY_LOOKUP.h75($$this$buildShader.u74(), 'xy')));
    return Unit_instance;
  };
}
var MsdfRender_instance;
function MsdfRender_getInstance() {
  if (MsdfRender_instance === VOID)
    new MsdfRender();
  return MsdfRender_instance;
}
function get_timers(_this__u8e3s4) {
  _init_properties_TimerComponents_kt__j84oeh();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = timers$delegate;
    var property = timers$factory();
    var tmp0_elvis_lhs = this_0.c10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var timers$delegate;
function ensureUpdater($this) {
  if (!($this.tal_1 == null))
    return Unit_instance;
  var tmp = $this;
  tmp.tal_1 = addFastUpdater_0($this.pal_1, TimerComponents$ensureUpdater$lambda($this));
}
function addTimer($this, autoRemove, callback) {
  if ($this.sal_1.l2c()) {
    var index = $this.sal_1.p3($this.sal_1.f1() - 1 | 0);
    $this.qal_1.o3(index, callback);
    // Inline function 'korlibs.math.toInt' call
    var tmp$ret$0 = autoRemove ? 1 : 0;
    $this.ral_1.x2o(index, tmp$ret$0);
    ensureUpdater($this);
    return _TimerRef___init__impl__cysrar(index);
  }
  // Inline function 'kotlin.collections.plusAssign' call
  $this.qal_1.h(callback);
  // Inline function 'korlibs.math.toInt' call
  var tmp$ret$1 = autoRemove ? 1 : 0;
  $this.ral_1.s2o(tmp$ret$1);
  ensureUpdater($this);
  return _TimerRef___init__impl__cysrar($this.qal_1.f1() - 1 | 0);
}
function removeTimer($this, ref) {
  $this.qal_1.o3(_TimerRef___get_index__impl__pnrx4q(ref), null);
  $this.ral_1.x2o(_TimerRef___get_index__impl__pnrx4q(ref), 0);
  $this.sal_1.s2o(_TimerRef___get_index__impl__pnrx4q(ref));
}
function _interval($this, time, repeat, callback) {
  var elapsed = {_v: new FastDuration(get_fastMilliseconds(0))};
  var ref = {_v: new TimerRef(_TimerRef___init__impl__cysrar(-1))};
  ref._v = new TimerRef(addTimer($this, false, TimerComponents$_interval$lambda(elapsed, time, repeat, $this, ref, callback)));
  return Closeable(TimerComponents$_interval$lambda_0($this, ref));
}
function TimerComponents$ensureUpdater$lambda(this$0) {
  return function ($this$addFastUpdater, dt) {
    var this_0 = this$0.qal_1;
    var n = 0;
    while (n < this_0.f1()) {
      // Inline function 'korlibs.korge.time.TimerComponents.ensureUpdater.<anonymous>.<anonymous>' call
      var index = n;
      var tmp0_safe_receiver = this_0.e1(n);
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(dt);
      if (!(this$0.ral_1.e1(index) === 0)) {
        removeTimer(this$0, _TimerRef___init__impl__cysrar(index));
      }
      n = n + 1 | 0;
    }
    var tmp;
    if (this$0.qal_1.h1()) {
      var tmp0_safe_receiver_0 = this$0.tal_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        tmp0_safe_receiver_0.n6();
      }
      this$0.tal_1 = null;
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function TimerComponents$wait$lambda($c) {
  return function () {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $c;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    this_0.bd(tmp$ret$0);
    return Unit_instance;
  };
}
function TimerComponents$_interval$lambda($elapsed, $time, $repeat, this$0, $ref, $callback) {
  return function (dt) {
    $elapsed._v = new FastDuration(FastDuration__plus_impl_q1enab($elapsed._v.a1y_1, dt.a1y_1));
    $l$loop: while (FastDuration__compareTo_impl_4fhnj7($elapsed._v.a1y_1, $time) >= 0) {
      if (!$repeat) {
        removeTimer(this$0, $ref._v.ual_1);
      }
      $elapsed._v = new FastDuration(FastDuration__minus_impl_evs237($elapsed._v.a1y_1, $time));
      $callback();
      if (!$repeat)
        break $l$loop;
    }
    return Unit_instance;
  };
}
function TimerComponents$_interval$lambda_0(this$0, $ref) {
  return function () {
    removeTimer(this$0, $ref._v.ual_1);
    return Unit_instance;
  };
}
function _TimerRef___init__impl__cysrar(index) {
  return index;
}
function _TimerRef___get_index__impl__pnrx4q($this) {
  return $this;
}
function TimerRef__toString_impl_8hh2j7($this) {
  return 'TimerRef(index=' + $this + ')';
}
function TimerRef__hashCode_impl_d9ou9o($this) {
  return $this;
}
function TimerRef__equals_impl_2fvpr4($this, other) {
  if (!(other instanceof TimerRef))
    return false;
  if (!($this === (other instanceof TimerRef ? other.ual_1 : THROW_CCE())))
    return false;
  return true;
}
function delay_0(_this__u8e3s4, time, $completion) {
  return get_timers(_this__u8e3s4).val(time, $completion);
}
function timers$delegate$lambda($this$PropertyThis) {
  _init_properties_TimerComponents_kt__j84oeh();
  return new TimerComponents($this$PropertyThis);
}
function timers$factory() {
  return getPropertyCallableRef('timers', 1, KProperty1, function (receiver) {
    return get_timers(receiver);
  }, null);
}
var properties_initialized_TimerComponents_kt_v7ywzv;
function _init_properties_TimerComponents_kt__j84oeh() {
  if (!properties_initialized_TimerComponents_kt_v7ywzv) {
    properties_initialized_TimerComponents_kt_v7ywzv = true;
    timers$delegate = new PropertyThis('__ViewTimerComponents', timers$delegate$lambda);
  }
}
function get_DEFAULT_EASING() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_EASING;
}
var DEFAULT_EASING;
function get_DEFAULT_TIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_TIME;
}
var DEFAULT_TIME;
function get_DEFAULT_FTIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_FTIME;
}
var DEFAULT_FTIME;
function tween(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_TIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  var tmp;
  if (waitTime === VOID) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance();
    tmp = get_DURATION_NIL();
  } else {
    tmp = waitTime;
  }
  waitTime = tmp;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp_0;
  if (callback === VOID) {
    tmp_0 = tween$lambda;
  } else {
    tmp_0 = callback;
  }
  callback = tmp_0;
  return tween_0(_this__u8e3s4, vs.slice(), get_fast(time), easing, get_fast(waitTime), timeout, autoInvalidate, callback, $completion);
}
function *_generator_tween__vopi21(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.y1x() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  if (!(_this__u8e3s4 == null)) {
    var tc = {_v: null};
    try {
      var tmp_0;
      if (timeout) {
        // Inline function 'korlibs.time.FastDuration.times' call
        var tmp$ret$0 = FastDuration__times_impl_h6amcp(time, numberToDouble(2));
        tmp_0 = FastDuration__plus_impl_q1enab(tmp$ret$0, get_fastMilliseconds(300));
      } else {
        tmp_0 = Companion_instance_1.y1x();
      }
      var tmp_1 = tmp_0;
      var tmp_2 = withTimeoutNullable(tmp_1, tween$slambda_0(_this__u8e3s4, tc, vs, time, easing, callback, waitTime, autoInvalidate), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    } catch ($p) {
      if ($p instanceof TimeoutCancellationException) {
        var e = $p;
        var tmp0_safe_receiver = tc._v;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.mam(time);
        }
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function tween_0(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.y1x() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_tween__vopi21.bind(VOID, _this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback), $completion);
}
function _update($this, dt) {
  if ($this.fam_1) {
    $this.yal_1.kah();
  }
  if ($this.iam_1) {
    return $this.ram();
  }
  $this.gam_1 = FastDuration__plus_impl_q1enab($this.gam_1, dt);
  var ratio = clamp(FastDuration__div_impl_rlslck($this.gam_1, $this.ham_1), 0.0, 1.0);
  $this.mam($this.gam_1);
  $this.cam_1($this.bam_1.fz(ratio));
  var tmp;
  var tmp_0 = $this.sam();
  // Inline function 'korlibs.time.NIL' call
  Companion_getInstance();
  var tmp$ret$0 = get_DURATION_NIL();
  if (!equals(tmp_0, tmp$ret$0)) {
    tmp = FastDuration__compareTo_impl_4fhnj7_0($this.gam_1, $this.sam()) >= 0;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.tam();
  }
  if (ratio >= 1.0) {
    return $this.ram();
  }
}
function TweenComponent$updater$lambda(this$0) {
  return function (it) {
    _update(this$0, it.j8s_1);
    return Unit_instance;
  };
}
function TweenComponent$lambda(this$0) {
  return function (it) {
    this$0.iam_1 = true;
    return Unit_instance;
  };
}
function *_generator_withTimeoutNullable__i31xu0(time, block, $completion) {
  var tmp;
  var tmp_0;
  var tmp_1 = time;
  if ((tmp_1 == null ? null : new FastDuration(tmp_1)) == null) {
    tmp_0 = true;
  } else {
    var tmp_2 = time;
    tmp_0 = equals(tmp_2 == null ? null : new FastDuration(tmp_2), new FastDuration(Companion_instance_1.y1x()));
  }
  if (tmp_0) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.zc();
    var tmp_3 = block(CoroutineScope_0(tmp$ret$0), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp = tmp_3;
  } else {
    var tmp_4 = withTimeout(toLongRound(_FastDuration___get_fastMilliseconds__impl__pe68va(time)), block, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp = tmp_4;
  }
  return tmp;
}
function withTimeoutNullable(time, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_withTimeoutNullable__i31xu0.bind(VOID, time, block), $completion);
}
function tween$lambda(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function tween$lambda_0(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $this$withTimeoutNullable, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.s1b();
  // Inline function 'korlibs.korge.tween.tween.<anonymous>.<anonymous>' call
  var view = $this.uam_1;
  $this.vam_1._v = new TweenComponent(view, toList($this.wam_1), $this.xam_1, $this.yam_1, $this.zam_1, cancellable, $this.aan_1, $this.ban_1);
  var tmp$ret$0 = cancellable.e19();
  var tmp = returnIfSuspended(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function tween$slambda_0($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
  var i = new tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate);
  var l = function ($this$withTimeoutNullable, $completion) {
    return i.k1q($this$withTimeoutNullable, $completion);
  };
  l.$arity = 1;
  return l;
}
var properties_initialized_tween_kt_p0n8nv;
function _init_properties_tween_kt__1g7sex() {
  if (!properties_initialized_tween_kt_p0n8nv) {
    properties_initialized_tween_kt_p0n8nv = true;
    DEFAULT_EASING = get_EASE_IN_OUT_QUAD(Companion_getInstance_33());
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_TIME = toDuration(1, DurationUnit_SECONDS_getInstance());
    DEFAULT_FTIME = get_fastSeconds(1);
  }
}
function registerUISupportOnce($this) {
  if ($this.iae_1)
    return Unit_instance;
  var tmp0_elvis_lhs = $this.ba5();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stage = tmp;
  $this.iae_1 = true;
  if (equals(getExtra(stage, 'uiSupport'), true))
    return Unit_instance;
  setExtra(stage, 'uiSupport', true);
  // Inline function 'korlibs.korge.input.keys' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UIView.registerUISupportOnce.<anonymous>' call
  get_keys(stage);
}
var Companion_instance_18;
function Companion_getInstance_40() {
  if (Companion_instance_18 === VOID)
    new Companion_3();
  return Companion_instance_18;
}
function anchor(_this__u8e3s4, anchor) {
  _this__u8e3s4.yap(anchor);
  return _this__u8e3s4;
}
function clearBitmaps($this, onParentChanged) {
  if ($this.las_1.h1())
    return Unit_instance;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.las_1;
  var n = 0;
  while (n < this_0.f1()) {
    // Inline function 'korlibs.korge.view.BaseGraphics.clearBitmaps.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = this_0.e1(_unary__edvuaz);
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    if (!equals(it, get_bmp(tmp$ret$0))) {
      var tmp0_safe_receiver = $this.qas_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e88_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.a8e(it, 'BaseGraphics');
      }
    }
  }
  $this.las_1.k3();
}
function _get_bitmapWidth__ndy7bu($this) {
  return $this.x5a().d2m();
}
function _get_bitmapHeight__5t1vx1($this) {
  return $this.x5a().e2m();
}
function _getLocalBoundsInternal($this, strokes) {
  var bounds = boundsUnsafe($this, strokes);
  return new Rectangle(bounds.k2a_1 - $this.hai(), bounds.l2a_1 - $this.iai(), bounds.m2a_1, bounds.n2a_1);
}
function _getLocalBoundsInternal$default($this, strokes, $super) {
  strokes = strokes === VOID ? $this.uas_1 : strokes;
  return _getLocalBoundsInternal($this, strokes);
}
function boundsUnsafe($this, strokes) {
  if ($this.pas_1) {
    $this.pas_1 = false;
    $this.was_1 = $this.fav(false);
    $this.vas_1 = $this.fav(true);
  }
  return strokes ? $this.vas_1 : $this.was_1;
}
var ZIndexComparator_instance;
function ZIndexComparator_getInstance() {
  return ZIndexComparator_instance;
}
function Container$renderChildrenInternal$lambda(it) {
  var tmp;
  if (it instanceof FixedSizeContainer) {
    tmp = it.a5p();
  } else {
    tmp = false;
  }
  return tmp;
}
function addTo(_this__u8e3s4, parent) {
  parent.ya4(_this__u8e3s4);
  return _this__u8e3s4;
}
function dummyView(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = DummyView.nb9();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.dummyView.<anonymous>' call
  _this__u8e3s4.xah(this_0);
  return this_0;
}
var Companion_instance_19;
function Companion_getInstance_41() {
  return Companion_instance_19;
}
function installFpsDebugOverlay(_this__u8e3s4) {
  var longWindow = new TimeSlidingWindow(240);
  var shortWindow = new TimeSlidingWindow(10);
  var previousTime = {_v: new FastDuration(PerformanceCounter_getInstance().y6c())};
  var frames = {_v: 0};
  var batchCount = {_v: 0};
  var vertexCount = {_v: 0};
  var instanceCount = {_v: 0};
  var tmp = _this__u8e3s4.ka1().h9s_1;
  tmp.w20(installFpsDebugOverlay$lambda(batchCount, vertexCount, instanceCount));
  var tmp_0 = get_debugLineRenderContext(_this__u8e3s4.ka1().i9r_1).l8h_1;
  tmp_0.w20(installFpsDebugOverlay$lambda_0(batchCount, vertexCount));
  var tmp_1 = _this__u8e3s4.ka1().i9r_1.j88_1.r89_1;
  tmp_1.w20(installFpsDebugOverlay$lambda_1(batchCount, vertexCount));
  var tmp_2 = _this__u8e3s4.ka1().i9r_1.j88_1.s89_1;
  tmp_2.w20(installFpsDebugOverlay$lambda_2(instanceCount));
  var tmp_3 = _this__u8e3s4.ka1();
  tmp_3.pb9(installFpsDebugOverlay$lambda_3(previousTime, frames, longWindow, shortWindow, batchCount, vertexCount, instanceCount));
}
function installFpsDebugOverlay$lambda($batchCount, $vertexCount, $instanceCount) {
  return function (it) {
    $batchCount._v = 0;
    $vertexCount._v = 0;
    $instanceCount._v = 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_0($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.t8h_1 | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_1($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.h8f() | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_2($instanceCount) {
  return function (it) {
    $instanceCount._v = $instanceCount._v + it | 0;
    return Unit_instance;
  };
}
function invoke$drawTextWithShadow($this_addDebugRenderer, $ctx, fontSize, matrix, text, x, y) {
  var tmp0_font = $this_addDebugRenderer.o9z();
  var tmp1_colMul = $ctx.i88_1;
  var tmp2_blendMode = Companion_getInstance_13().a87_1;
  drawText($ctx, tmp0_font, fontSize, text, x, y, matrix, tmp1_colMul, tmp2_blendMode, false);
}
function installFpsDebugOverlay$lambda_3($previousTime, $frames, $longWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
  return function ($this$addDebugRenderer, ctx) {
    var scale = ctx.g8i();
    var fontSize = 8.0 * scale;
    var currentTime = PerformanceCounter_getInstance().y6c();
    var elapsedTime = FastDuration__minus_impl_evs237(currentTime, $previousTime._v.a1y_1);
    var tmp;
    if ($frames._v > 3) {
      var tmp_0;
      if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, get_fastMilliseconds(4)) > 0) {
        $longWindow.wb9(elapsedTime);
        $shortWindow.wb9(elapsedTime);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    var _unary__edvuaz = $frames._v;
    $frames._v = _unary__edvuaz + 1 | 0;
    $previousTime._v = new FastDuration(currentTime);
    var matrix = $this$addDebugRenderer.w9q_1.v8g();
    invoke$drawTextWithShadow($this$addDebugRenderer, ctx, fontSize, matrix, 'FPS: ' + ('' + roundDecimalPlaces($shortWindow.ub9(), 1)) + (', batchCount=' + $batchCount._v + ', vertexCount=' + $vertexCount._v + ', instanceCount=' + $instanceCount._v) + (', (' + Companion_getInstance_35().uv() + ')'), 0, 0);
    var graphLeft = 1.0;
    var graphTop = fontSize * 2;
    var overlayLines = 60;
    var overlayWidth = 120.0 * scale;
    var overlayHeight = 30 * scale;
    var overlayHeightGap = 5.0;
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    var this_0 = $this$addDebugRenderer.i9r_1;
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_1 = get_debugLineRenderContext(this_0);
    var this_2 = this_1.k8h_1;
    if (!(this_2.n88_1 === this_1)) {
      this_2.n88_1 = this_1;
      this_2.x89();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_3 = get_debugLineRenderContext(this_0);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory(this_3);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(matrix == null))
          this_3.w8h_1 = matrix;
        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_13().a87_1;
          var doUpdate = !(this_1.v8h_1 === blending);
          var old = this_1.v8h_1;
          try {
            if (doUpdate) {
              this_1.k8h_1.x89();
              this_1.v8h_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var color = Colors_getInstance().w45_1;
            var oldColor = this_1.n8h_1;
            this_1.n8h_1 = color;
            try {
              // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              this_1.b8i(graphLeft, graphTop, graphLeft, graphTop + overlayHeight);
              this_1.b8i(graphLeft, graphTop + overlayHeight, graphLeft + overlayWidth, graphTop + overlayHeight);
            }finally {
              this_1.n8h_1 = oldColor;
            }
            var inductionVariable = 0;
            if (inductionVariable <= 0)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var color_0 = index === 0 ? Colors_getInstance().g40_1 : Colors_getInstance().h40_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_0 = this_1.n8h_1;
                this_1.n8h_1 = color_0;
                try {
                  // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ratio = $longWindow.f1() / $longWindow.qb9_1;
                  var totalOverlayLines = coerceAtLeast(numberToInt(overlayLines * ratio), 1);
                  if ($longWindow.f1() > 0) {
                    var previousX = 0.0;
                    var previousY = 0.0;
                    var minFps = 0.0;
                    var maxFps = 150.0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < totalOverlayLines)
                      do {
                        var n = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'kotlin.run' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        var p0 = convertRange(n, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.f1(), 1));
                        var p1 = convertRange(n + 1 | 0, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.f1(), 1));
                        var plen = 0;
                        var timeSum = get_fastMilliseconds(0);
                        var inductionVariable_1 = p0;
                        var last = coerceAtMost(p1, $longWindow.f1());
                        if (inductionVariable_1 < last)
                          do {
                            var m = inductionVariable_1;
                            inductionVariable_1 = inductionVariable_1 + 1 | 0;
                            timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.vb9(m));
                            plen = plen + 1 | 0;
                          }
                           while (inductionVariable_1 < last);
                        if (plen === 0) {
                          timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.vb9(p0));
                          plen = plen + 1 | 0;
                        }
                        var time = FastDuration__div_impl_rlslck_0(timeSum, plen);
                        var fps = _Frequency___get_hertz__impl__9m7k6x(toFrequency(time));
                        var fps_0 = fps;
                        var scaledFreq = convertRange_0(fps_0, minFps, maxFps, overlayHeightGap, overlayHeight);
                        var y = graphTop + overlayHeight - scaledFreq;
                        var x = graphLeft + n * overlayWidth / overlayLines;
                        if (n > 0) {
                          this_1.b8i(previousX, previousY + index, x, y + index);
                        }
                        previousY = y;
                        previousX = x;
                      }
                       while (inductionVariable_0 < totalOverlayLines);
                  }
                }finally {
                  this_1.n8h_1 = oldColor_0;
                }
              }
               while (inductionVariable <= 0);
            break $l$block;
          }finally {
            if (doUpdate) {
              this_1.k8h_1.x89();
            }
            this_1.v8h_1 = old;
          }
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
    return Unit_instance;
  };
}
function currentMatrix$factory($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.w8h_1;
  }, function (value) {
    $b0.w8h_1 = value;
    return Unit_instance;
  });
}
var GraphicsRenderer_SYSTEM_instance;
var GraphicsRenderer_CPU_instance;
var GraphicsRenderer_GPU_instance;
var GraphicsRenderer_entriesInitialized;
function GraphicsRenderer_initEntries() {
  if (GraphicsRenderer_entriesInitialized)
    return Unit_instance;
  GraphicsRenderer_entriesInitialized = true;
  GraphicsRenderer_SYSTEM_instance = new GraphicsRenderer('SYSTEM', 0);
  GraphicsRenderer_CPU_instance = new GraphicsRenderer('CPU', 1);
  GraphicsRenderer_GPU_instance = new GraphicsRenderer('GPU', 2);
}
function _get_anchorable__ebfoik($this) {
  var tmp0_elvis_lhs = $this.fbc_1;
  return ensureNotNull(tmp0_elvis_lhs == null ? $this.gbc_1 : tmp0_elvis_lhs);
}
function ensure($this) {
  if ($this.mbc_1.r3_1 === 2) {
    if (!($this.fbc_1 == null)) {
      var tmp1_safe_receiver = $this.fbc_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.kak();
      }
      $this.fbc_1 = null;
    }
    if ($this.gbc_1 == null) {
      var tmp = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView' call
      // Inline function 'kotlin.also' call
      var this_0 = GpuShapeView.mbf(EmptyShape_instance, true);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.vector.gpuGraphics.<anonymous>' call
      var tmp$ret$2 = (new ShapeBuilder(null, null)).n4n();
      this_0.nbf(tmp$ret$2);
      var this_1 = addTo(this_0, $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_1.obf($this.hbc_1);
      this_1.nbe_1 = $this.kbc_1;
      this_1.pbe_1 = $this.jbc_1;
      this_1.nbf($this.lbc_1);
      tmp.gbc_1 = this_1;
    }
  } else {
    if (!($this.gbc_1 == null)) {
      var tmp2_safe_receiver = $this.gbc_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.kak();
      }
      $this.gbc_1 = null;
    }
    if ($this.fbc_1 == null) {
      var tmp_0 = $this;
      // Inline function 'kotlin.also' call
      // Inline function 'korlibs.korge.view.cpuGraphics' call
      // Inline function 'kotlin.also' call
      var this_2 = addTo(CpuGraphics.lb7(false), $this);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.korge.view.cpuGraphics.<anonymous>' call
      var tmp$ret$9 = (new ShapeBuilder(null, null)).n4n();
      this_2.mb7(tmp$ret$9);
      if (false) {
        this_2.rav();
      }
      this_2.pas_1 = true;
      this_2.zaj();
      this_2.rav();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.Graphics.ensure.<anonymous>' call
      this_2.fb7_1 = $this.hbc_1;
      this_2.has_1 = $this.kbc_1;
      this_2.wax_1 = $this.jbc_1;
      this_2.mb7($this.lbc_1);
      tmp_0.fbc_1 = this_2;
    }
    var tmp3_safe_receiver = $this.fbc_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.pav($this.mbc_1.equals(GraphicsRenderer_SYSTEM_getInstance()));
    }
  }
}
function GraphicsRenderer_SYSTEM_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_SYSTEM_instance;
}
function GraphicsRenderer_GPU_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_GPU_instance;
}
function *_generator_forceLoadSourceFile__yy5vos($this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.ebi($this, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    var tmp_0 = readBitmapSlice(currentVfs.hi('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    $this.tav(tmp_0);
    $this.wai(1.0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$0 = get_Bitmaps_white();
      $this.tav(tmp$ret$0);
      $this.wai(100.0);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_baseForceLoadSourceFile__natc6b(_this__u8e3s4, $this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.cbi_1.ebi(_this__u8e3s4, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function trySetSourceActually($this) {
  var source = $this.eav_1.b11();
  if (!(source == null)) {
    $this.dav_1 = true;
    $this.iay(source);
  }
}
function sourceFile$factory($b0) {
  return getPropertyCallableRef('sourceFile', 0, KMutableProperty0, function () {
    return $b0.qbi();
  }, function (value) {
    return $b0.pbi(value);
  });
}
var Companion_instance_20;
function Companion_getInstance_42() {
  return Companion_instance_20;
}
var Companion_instance_21;
function Companion_getInstance_43() {
  return Companion_instance_21;
}
function clipBorders$factory($b0) {
  return getPropertyCallableRef('clipBorders', 0, KMutableProperty0, function () {
    return $b0.u9r_1;
  }, function (value) {
    $b0.u9r_1 = value;
    return Unit_instance;
  });
}
function virtualSizeDouble$factory($b0) {
  return getPropertyCallableRef('virtualSizeDouble', 0, KMutableProperty0, function () {
    return $b0.fbl();
  }, function (value) {
    return $b0.gbl(value);
  });
}
function clip$factory() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.a5p();
  }, function (receiver, value) {
    return receiver.ebl(value);
  });
}
function clip$factory_0() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.a5p();
  }, function (receiver, value) {
    return receiver.ebl(value);
  });
}
function unscaledSize$factory() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.pae();
  }, function (receiver, value) {
    return receiver.oae(value);
  });
}
function unscaledSize$factory_0() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.pae();
  }, function (receiver, value) {
    return receiver.oae(value);
  });
}
function get_agProgram(_this__u8e3s4) {
  switch (_this__u8e3s4.n4h()) {
    case 'msdf':
      return MsdfRender_getInstance().jal_1;
    case 'psdf':
      return MsdfRender_getInstance().mal_1;
    case 'sdf':
      return MsdfRender_getInstance().mal_1;
    default:
      return null;
  }
}
function *_generator_invoke__zhh2q8_15($this, $completion) {
  var tmp = $this.hbl_1.fbp(ensureNotNull(get_views($this.ibl_1)).g9r_1, $this.jbl_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_22;
function Companion_getInstance_44() {
  return Companion_instance_22;
}
function updateLineCount($this) {
  var tmp = $this;
  // Inline function 'kotlin.text.count' call
  var count = 0;
  var indexedObject = $this.ibp();
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(indexedObject)) {
    var element = charSequenceGet(indexedObject, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'korlibs.korge.view.Text.updateLineCount.<anonymous>' call
    if (element === _Char___init__impl__6a9atx(10)) {
      count = count + 1 | 0;
    }
  }
  tmp.wbn_1 = count + 1 | 0;
}
function *_generator_forceLoadFontSource__wlrz09($this, currentVfs, sourceFile, $completion) {
  $this.jbp(sourceFile);
  $this.jbo_1 = true;
  if (!(sourceFile == null)) {
    var tmp = readFont(currentVfs.hi('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    $this.kbp(tmp);
  }
  return Unit_instance;
}
function setContainerPosition($this, pos, baseline) {
  var x = pos.nl();
  var y = pos.ol();
  if ($this.obo_1) {
    setRealContainerPosition($this, x, y);
  } else {
    setRealContainerPosition($this, x + HorizontalAlign__getOffsetX_impl_urzzxf($this.gbo_1.d4q_1, $this.nbo_1.m2a_1), y - VerticalAlign__getOffsetY_impl_iso0y6($this.gbo_1.e4q_1, $this.nbo_1.n2a_1, baseline));
  }
}
function setRealContainerPosition($this, x, y) {
  position($this.hbo_1, x, y);
}
function Text$_renderInternal$slambda_0(this$0, $ctx, $fontSource) {
  var i = new Text$_renderInternal$slambda(this$0, $ctx, $fontSource);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function textSize$factory($b0) {
  return getPropertyCallableRef('textSize', 0, KMutableProperty0, function () {
    return $b0.bbo_1;
  }, function (value) {
    return $b0.obp(value);
  });
}
function fontSource$factory($b0) {
  return getPropertyCallableRef('fontSource', 0, KMutableProperty0, function () {
    return $b0.mbo_1;
  }, function (value) {
    return $b0.jbp(value);
  });
}
function fontSize$factory() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.l4h();
  }, function (receiver, value) {
    return receiver.pbp(value);
  });
}
function fontSize$factory_0() {
  return getPropertyCallableRef('fontSize', 1, KMutableProperty1, function (receiver) {
    return receiver.l4h();
  }, function (receiver, value) {
    return receiver.pbp(value);
  });
}
var Companion_instance_23;
function Companion_getInstance_45() {
  return Companion_instance_23;
}
function updateRenderColorTransform($this) {
  $this.i9u_1 = $this.n9u_1;
  $this.p9u_1 = true;
  var parent = $this.k28();
  if (!((parent == null ? null : get_filter(parent)) == null)) {
    $this.h9u_1.v4f($this.g9u_1);
  } else {
    var tmp;
    if (!(parent == null)) {
      tmp = !isInterface($this, ColorReference);
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.h9u_1.w4f($this.g9u_1, parent.vaj());
    } else {
      $this.h9u_1.v4f($this.g9u_1);
    }
  }
}
function updateRenderColorTransformIfRequired($this) {
  if ($this.i9u_1 === $this.n9u_1)
    return Unit_instance;
  updateRenderColorTransform($this);
}
function updateRenderBlendMode($this) {
  $this.k9u_1 = $this.m9u_1;
  $this.o9u_1 = true;
  var tmp = $this;
  var tmp_0;
  if ($this.m9t_1.equals(Companion_getInstance_13().r86_1)) {
    var tmp1_safe_receiver = $this.k28();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.waj();
    tmp_0 = tmp2_elvis_lhs == null ? Companion_getInstance_13().q86_1 : tmp2_elvis_lhs;
  } else {
    tmp_0 = $this.m9t_1;
  }
  tmp.j9u_1 = tmp_0;
}
function updateRenderBlendModeIfRequired($this) {
  if ($this.k9u_1 === $this.m9u_1)
    return Unit_instance;
  updateRenderBlendMode($this);
}
function View$bviewAll$delegate$lambda(this$0) {
  return function () {
    return listOf(this$0);
  };
}
function addFastUpdater(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_instance_1.x1x() : firstTime;
  if (first)
    updatable(_this__u8e3s4, new FastDuration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.x6e(tmp, addFastUpdater$lambda(updatable, _this__u8e3s4));
}
function addFastUpdater_0(_this__u8e3s4, updatable) {
  return addFastUpdater(_this__u8e3s4, true, VOID, updatable);
}
function addUpdaterWithViews(_this__u8e3s4, updatable) {
  var tmp = Companion_instance_24;
  return _this__u8e3s4.x6e(tmp, addUpdaterWithViews$lambda(updatable, _this__u8e3s4));
}
function hasAncestor(_this__u8e3s4, ancestor) {
  var tmp;
  if (equals(_this__u8e3s4, ancestor)) {
    tmp = true;
  } else {
    var tmp0_safe_receiver = _this__u8e3s4.k28();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, ancestor);
    tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  return tmp;
}
function scale(_this__u8e3s4, sx, sy) {
  sy = sy === VOID ? sx : sy;
  _this__u8e3s4.caj(Scale.v2h(sx, sy));
  return _this__u8e3s4;
}
function position(_this__u8e3s4, x, y) {
  return xy(_this__u8e3s4, Vector2D.k2c(x, y));
}
function descendantsWith(_this__u8e3s4, out, check) {
  var tmp;
  if (out === VOID) {
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp = ArrayList.j1();
  } else {
    tmp = out;
  }
  out = tmp;
  if (!(_this__u8e3s4 == null)) {
    if (check(_this__u8e3s4)) {
      // Inline function 'kotlin.collections.plusAssign' call
      out.h(_this__u8e3s4);
    }
    if (_this__u8e3s4.a9t_1) {
      // Inline function 'korlibs.korge.view.View.forEachChild' call
      var tmp0_safe_receiver = _this__u8e3s4.nah();
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < tmp0_safe_receiver.f1()) {
          // Inline function 'korlibs.korge.view.descendantsWith.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var child = tmp0_safe_receiver.e1(_unary__edvuaz);
          descendantsWith(child, out, check);
        }
        tmp_0 = Unit_instance;
      }
    }
  }
  return out;
}
function findFirstAscendant(_this__u8e3s4, cond) {
  var current = _this__u8e3s4;
  while (!(current == null)) {
    if (cond(current))
      return current;
    current = current.k28();
  }
  return null;
}
function get_ancestorCount(_this__u8e3s4) {
  var count = 0;
  var parent = _this__u8e3s4 == null ? null : _this__u8e3s4.k28();
  while (!(parent == null)) {
    count = count + 1 | 0;
    parent = parent.k28();
  }
  return count;
}
function addUpdater(_this__u8e3s4, updatable) {
  return addUpdater_0(_this__u8e3s4, true, VOID, updatable);
}
function xy(_this__u8e3s4, p) {
  _this__u8e3s4.w4s(p);
  return _this__u8e3s4;
}
function size(_this__u8e3s4, size) {
  _this__u8e3s4.iaj(size);
  return _this__u8e3s4;
}
function addUpdater_0(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_getInstance().rj_1 : firstTime;
  if (first)
    updatable(_this__u8e3s4, new Duration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.x6e(tmp, addUpdater$lambda(updatable, _this__u8e3s4));
}
function xy_0(_this__u8e3s4, x, y) {
  _this__u8e3s4.sai(x, y);
  return _this__u8e3s4;
}
function addFastUpdater$lambda($updatable, $this_addFastUpdater) {
  return function (it) {
    $updatable($this_addFastUpdater, new FastDuration(FastDuration__times_impl_h6amcp(it.j8s_1, $this_addFastUpdater.rai())));
    return Unit_instance;
  };
}
function addUpdaterWithViews$lambda($updatable, $this_addUpdaterWithViews) {
  return function (it) {
    $updatable($this_addUpdaterWithViews, it.zbp_1, new Duration(Duration__times_impl_sfuzvp(it.bbq(), $this_addUpdaterWithViews.rai())));
    return Unit_instance;
  };
}
function addUpdater$lambda($updatable, $this_addUpdater) {
  return function (it) {
    $updatable($this_addUpdater, new Duration(Duration__times_impl_sfuzvp(it.k8s(), $this_addUpdater.rai())));
    return Unit_instance;
  };
}
function scale$factory($b0) {
  return getPropertyCallableRef('scale', 0, KMutableProperty0, function () {
    return $b0.xai();
  }, function (value) {
    return $b0.wai(value);
  });
}
function bviewAll$factory() {
  return getPropertyCallableRef('bviewAll', 1, KProperty1, function (receiver) {
    return receiver.gai();
  }, null);
}
function currentMatrix$factory_0($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.w8h_1;
  }, function (value) {
    $b0.w8h_1 = value;
    return Unit_instance;
  });
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  var tmp = $this.cbq_1.nbi(ensureNotNull(get_views($this.dbq_1)), VOID, $this.ebq_1.gbi_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0($view, $ctx, this$0) {
  var i = new ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_17($this, $completion) {
  var tmp = $this.gbq_1.hbq($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_init__qn9atk($this, $completion) {
  var tmp = $this;
  var tmp_0 = debugBmpFont($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.e9r_1 = tmp_0;
  return Unit_instance;
}
function *_generator_closeSuspend__agjafw($this, $completion) {
  KorgeReload_getInstance().p86();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.r9r_1;
  var n = 0;
  while (n < this_0.f1()) {
    // Inline function 'korlibs.korge.view.Views.closeSuspend.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var tmp = this_0.e1(_unary__edvuaz).w1r($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  $this.r9r_1.k3();
  cancel($this.j9q_1);
  $this.p9q_1.r8q();
  return Unit_instance;
}
function Views$_init_$lambda_jivasj(it) {
  return Stage.u9p(it);
}
function Views$realSettingsFolder$delegate$lambda(this$0) {
  return function () {
    return !(this$0.r9q_1 == null) ? ensureNotNull(this$0.r9q_1) : StandardPaths_instance.v32(this$0.ibq());
  };
}
function Views$close$slambda_0(this$0) {
  var i = new Views$close$slambda(this$0);
  var l = function ($completion) {
    return i.ce($completion);
  };
  l.$arity = 0;
  return l;
}
function Views$tempViewsPool$lambda(it) {
  return FastArrayList.q10();
}
function Views$lambda(this$0) {
  return function (it) {
    this$0.i9r_1.z8d();
    return Unit_instance;
  };
}
function Views$lambda_0(this$0) {
  return function (it) {
    this$0.i9r_1.p8i();
    return Unit_instance;
  };
}
var Companion_instance_24;
function Companion_getInstance_46() {
  return Companion_instance_24;
}
var Companion_instance_25;
function Companion_getInstance_47() {
  return Companion_instance_25;
}
function updateSingleViewWithViewsAll(_this__u8e3s4, views, delta) {
  // Inline function 'kotlin.also' call
  var this_0 = views.a9r_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_0.j8s_1 = delta;
  _this__u8e3s4.i6f(this_0);
  // Inline function 'kotlin.also' call
  var this_1 = views.b9r_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_1.abq_1 = delta;
  _this__u8e3s4.i6f(this_1);
}
function setBoundsInfo(_this__u8e3s4, reqVirtualSize, actualSize, scaleMode, anchor, virtualSize, targetSize) {
  scaleMode = scaleMode === VOID ? Companion_getInstance_24().b2k() : scaleMode;
  anchor = anchor === VOID ? Companion_getInstance_25().n29() : anchor;
  virtualSize = virtualSize === VOID ? Ref_0() : virtualSize;
  targetSize = targetSize === VOID ? Ref_0() : targetSize;
  var reqVirtualSize_0 = toInt(reqVirtualSize);
  var actualSize_0 = toInt(actualSize);
  virtualSize.f2v(reqVirtualSize_0);
  targetSize.f2v(scaleMode.e2k(virtualSize.s1(), actualSize_0));
  var ratioX = targetSize.s1().l2k_1 / reqVirtualSize_0.l2k_1;
  var ratioY = targetSize.s1().m2k_1 / reqVirtualSize_0.m2k_1;
  var actualVirtualWidth = toIntRound(actualSize_0.l2k_1 / ratioX);
  var actualVirtualHeight = toIntRound(actualSize_0.m2k_1 / ratioY);
  _this__u8e3s4.y8g(Companion_getInstance_30().m2d_1.o2e(ratioX, ratioY).w2e(toIntRound((actualVirtualWidth - reqVirtualSize_0.l2k_1 | 0) * anchor.k29_1), toIntRound((actualVirtualHeight - reqVirtualSize_0.m2k_1 | 0) * anchor.l29_1)));
  _this__u8e3s4.u8g(_this__u8e3s4.z8g().y2e());
  _this__u8e3s4.a8h(_this__u8e3s4.z8g().z2e());
  _this__u8e3s4.w8g(_this__u8e3s4.v8g().z2e());
  var tl = _this__u8e3s4.f8h(Vector2D.x2c(0, 0));
  var br = _this__u8e3s4.f8h(Vector2D.k2c(actualSize_0.l2k_1, actualSize_0.m2k_1));
  _this__u8e3s4.c8h(Companion_getInstance_28().c2i(tl.a2a_1, tl.b2a_1, br.a2a_1, br.b2a_1));
}
function *_generator_views__wf4006($completion) {
  // Inline function 'korlibs.inject.Injector.get' call
  var tmp = injector($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.l6c(getKClass(Views));
}
function views($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_views__wf4006.bind(VOID), $completion);
}
function quality$factory($b0) {
  return getPropertyCallableRef('quality', 0, KMutableProperty0, function () {
    return $b0.e8i();
  }, function (value) {
    return $b0.l8q(value);
  });
}
function continuousRenderMode$factory($b0) {
  return getPropertyCallableRef('continuousRenderMode', 0, KMutableProperty0, function () {
    return $b0.v8q();
  }, function (value) {
    return $b0.u8q(value);
  });
}
function debugExtraFontScale$factory($b0) {
  return getPropertyCallableRef('debugExtraFontScale', 0, KMutableProperty0, function () {
    return $b0.h88_1;
  }, function (value) {
    $b0.h88_1 = value;
    return Unit_instance;
  });
}
function debugExtraFontColor$factory($b0) {
  return getPropertyCallableRef('debugExtraFontColor', 0, KMutableProperty0, function () {
    return new RGBA($b0.i88_1);
  }, function (value) {
    $b0.i88_1 = value.a4g_1;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory($b0) {
  return getPropertyCallableRef('updatedSinceFrame', 0, KMutableProperty0, function () {
    return $b0.j8o_1;
  }, function (value) {
    $b0.j8o_1 = value;
    return Unit_instance;
  });
}
function forceRenderEveryFrame$factory() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.n9y();
  }, function (receiver, value) {
    return receiver.t9y(value);
  });
}
function forceRenderEveryFrame$factory_0() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.n9y();
  }, function (receiver, value) {
    return receiver.t9y(value);
  });
}
function debugFontExtraScale$factory() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.nbq();
  }, function (receiver, value) {
    return receiver.j9y(value);
  });
}
function debugFontExtraScale$factory_0() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.nbq();
  }, function (receiver, value) {
    return receiver.j9y(value);
  });
}
function debugFontColor$factory() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.obq());
  }, function (receiver, value) {
    return receiver.k9y(value.a4g_1);
  });
}
function debugFontColor$factory_0() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.obq());
  }, function (receiver, value) {
    return receiver.k9y(value.a4g_1);
  });
}
function virtualSize$factory($b0) {
  return getPropertyCallableRef('virtualSize', 0, KMutableProperty0, function () {
    return $b0.e9s_1;
  }, function (value) {
    $b0.e9s_1 = value;
    return Unit_instance;
  });
}
function targetSize$factory($b0) {
  return getPropertyCallableRef('targetSize', 0, KMutableProperty0, function () {
    return $b0.g9s_1;
  }, function (value) {
    $b0.g9s_1 = value;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory_0() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.ubq();
  }, function (receiver, value) {
    return receiver.bbr(value);
  });
}
function updatedSinceFrame$factory_1() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.ubq();
  }, function (receiver, value) {
    return receiver.bbr(value);
  });
}
var renderToTextureResultPool$delegate;
var Companion_instance_26;
function Companion_getInstance_48() {
  if (Companion_instance_26 === VOID)
    new Companion_11();
  return Companion_instance_26;
}
function expandedBorderRectangle(_this__u8e3s4, inp) {
  _init_properties_Filter_kt__xu8pbc();
  return inp.y2i(getBorder(_this__u8e3s4, toIntCeil(inp.m2a_1), toIntCeil(inp.n2a_1)));
}
function getBorder(_this__u8e3s4, texWidth, texHeight) {
  _init_properties_Filter_kt__xu8pbc();
  return _this__u8e3s4.fbr(texWidth, texHeight);
}
function renderToTextureResultPool$delegate$lambda() {
  _init_properties_Filter_kt__xu8pbc();
  var tmp = renderToTextureResultPool$delegate$lambda$lambda;
  return Pool.w2t(tmp, VOID, renderToTextureResultPool$delegate$lambda$lambda_0);
}
function renderToTextureResultPool$delegate$lambda$lambda(it) {
  _init_properties_Filter_kt__xu8pbc();
  it.m1a();
  return Unit_instance;
}
function renderToTextureResultPool$delegate$lambda$lambda_0(it) {
  _init_properties_Filter_kt__xu8pbc();
  return new RenderToTextureResult();
}
var properties_initialized_Filter_kt_lkm0w6;
function _init_properties_Filter_kt__xu8pbc() {
  if (!properties_initialized_Filter_kt_lkm0w6) {
    properties_initialized_Filter_kt_lkm0w6 = true;
    renderToTextureResultPool$delegate = new Property(VOID, renderToTextureResultPool$delegate$lambda);
  }
}
var Companion_instance_27;
function Companion_getInstance_49() {
  if (Companion_instance_27 === VOID)
    new Companion_12();
  return Companion_instance_27;
}
function get_backdropFilter(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.s9u_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseBackdropFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseBackdropFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.tbr_1;
}
function set_filterScale(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var this_0 = filterScale$delegate;
  var property = filterScale$factory();
  var value = this_0.e10_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.c10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_filterScale(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = filterScale$delegate;
    var property = filterScale$factory_0();
    var tmp0_elvis_lhs = this_0.c10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var filterScale$delegate;
function renderFiltered(_this__u8e3s4, ctx, filter, first) {
  first = first === VOID ? true : first;
  _init_properties_ViewFilter_kt__pd9xp9();
  var bounds = _this__u8e3s4.l9z(VOID, false);
  if (bounds.m2a_1 <= 0.0 || bounds.n2a_1 <= 0.0)
    return Unit_instance;
  var tmp = Companion_getInstance_48();
  // Inline function 'kotlin.math.min' call
  var a = get_filterScale(_this__u8e3s4);
  var b = filter.ebr();
  var tmp$ret$0 = Math.min(a, b);
  var tryFilterScale = tmp.dbr(tmp$ret$0);
  var texWidthNoBorder = coerceAtLeast(numberToInt(bounds.m2a_1 * tryFilterScale), 1);
  var texHeightNoBorder = coerceAtLeast(numberToInt(bounds.n2a_1 * tryFilterScale), 1);
  var realFilterScale = clamp_0(texWidthNoBorder / bounds.m2a_1, 0.03125, 1.0);
  var tmp_0;
  switch (false) {
    case true:
      tmp_0 = clamp_1(toIntCeil(1.0 / get_filterScale(_this__u8e3s4)), 1, 8);
      break;
    case false:
      tmp_0 = 0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var edgeSize = tmp_0;
  var texWidth = texWidthNoBorder + imul(edgeSize, 2) | 0;
  var texHeight = texHeightNoBorder + imul(edgeSize, 2) | 0;
  var addx = -bounds.k2a_1 + edgeSize;
  var addy = -bounds.l2a_1 + edgeSize;
  // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
  ctx.x89();
  // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
  var rb = ctx.r8i(texWidth, texHeight, false, true, 1);
  try {
    // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.t8i(rb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.j88_1;
      var this_1 = this_0.s88_1;
      if (!(this_1.n88_1 === this_0)) {
        this_1.n88_1 = this_0;
        this_1.x89();
      }
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var scissor = AGScissor.o6y(0, 0, rb.r6n_1, rb.s6n_1);
        var temp = this_0.q89_1;
        this_0.z8f();
        this_0.q89_1 = scissor;
        try {
          if (true) {
            ctx.m8i(Colors_getInstance().l40_1);
          }
          // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>.<anonymous>' call
          // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
          var mat = _this__u8e3s4.uaj().s2e(addx, addy).n2e(realFilterScale);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          var this_2 = ctx.j88_1.s88_1;
          this_2.x89();
          var temp4 = this_2.y87_1;
          var temp2d = this_2.z87_1;
          this_2.z87_1 = mat;
          this_2.y87_1 = toMatrix4(mat);
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var this_3 = this_2.a6v(ProjViewUB_getInstance());
            var _unary__edvuaz = this_3.p6w();
            this_3.g7j(_unary__edvuaz + 1 | 0);
            this_3.h7j(this_3.p6w() + 1 | 0);
            var blockSize = this_3.t6u_1;
            var index0 = imul(this_3.p6w() - 1 | 0, blockSize);
            var index1 = imul(this_3.p6w(), blockSize);
            var texBlockSize = this_3.q6u_1.p72().f1();
            var texIndex0 = imul(this_3.p6w() - 1 | 0, texBlockSize);
            var texIndex1 = imul(this_3.p6w(), texBlockSize);
            if (this_3.p6w() > 0) {
              arraycopy(this_3.v6u_1, index0, this_3.v6u_1, index1, blockSize);
            } else {
              arrayfill(this_3.v6u_1, 0, 0, blockSize);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
            var $this$push = this_3.q6u_1;
            this_3.w6u_1.q7j($this$push.o72(), this_2.y87_1);
            if (true && this_3.p6w() >= 1) {
              var equals = arrayequal(this_3.v6u_1, index0, this_3.v6u_1, index1, blockSize);
              if (equals) {
                var _unary__edvuaz_0 = this_3.p6w();
                this_3.g7j(_unary__edvuaz_0 - 1 | 0);
                break $l$block;
              }
            }
          }
          var tmp_1;
          try {
            var tmp_2;
            if (first) {
              _this__u8e3s4.cak(ctx);
              tmp_2 = Unit_instance;
            } else {
              _this__u8e3s4.dak(ctx);
              tmp_2 = Unit_instance;
            }
            tmp_1 = tmp_2;
          }finally {
            this_2.x89();
            this_2.y87_1 = temp4;
            this_2.z87_1 = temp2d;
            this_2.a6v(ProjViewUB_getInstance()).i7j();
          }
          break $l$block_0;
        }finally {
          this_0.z8f();
          this_0.q89_1 = temp;
        }
      }
    }finally {
      ctx.u8i();
    }
    // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
    var texture = Texture_0(rb).i3l(0, 0, texWidth, texHeight);
    var mat_0 = _this__u8e3s4.n9z().w2e(-addx, -addy).p2e(1.0 / realFilterScale);
    filter.gbr(ctx, mat_0, texture, texWidth, texHeight, _this__u8e3s4.xaj(), _this__u8e3s4.m9t_1, realFilterScale);
    ctx.x89();
  }finally {
    ctx.s8i(rb);
  }
}
function get_filter(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.s9u_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.ubr_1;
}
function filterScale$delegate$lambda($this$extraPropertyThis, it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return Companion_getInstance_48().dbr(it);
}
function filterScale$delegate$lambda_0($this$extraPropertyThis) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return 1.0;
}
function filterScale$factory() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
function filterScale$factory_0() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
var properties_initialized_ViewFilter_kt_mku9up;
function _init_properties_ViewFilter_kt__pd9xp9() {
  if (!properties_initialized_ViewFilter_kt_mku9up) {
    properties_initialized_ViewFilter_kt_mku9up = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var transform = filterScale$delegate$lambda;
    var default_0 = filterScale$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.e10_1 = transform;
    filterScale$delegate = this_0;
  }
}
function _get_shapeBounds__actvvf($this) {
  var valid = $this.qbe_1 ? $this.bbf_1 : $this.abf_1;
  if (!valid) {
    if ($this.qbe_1)
      $this.bbf_1 = true;
    else
      $this.abf_1 = true;
    var result = $this.ybe_1.s5o($this.qbe_1);
    if ($this.qbe_1)
      $this.ebf_1 = result;
    else
      $this.dbf_1 = result;
    return result;
  }
  return $this.qbe_1 ? $this.ebf_1 : $this.dbf_1;
}
function invalidateShape($this) {
  $this.cbf_1 = 0;
  $this.zbe_1 = false;
  $this.abf_1 = false;
  $this.bbf_1 = false;
  $this.kah();
}
function requireShape($this) {
  if ($this.zbe_1)
    return Unit_instance;
  $this.zbe_1 = true;
  $this.rbe_1.k3();
  $this.rbe_1.fbs();
  $this.rbe_1.gbs(Companion_getInstance_14().k6p_1);
  $this.fbf_1 = true;
  renderShape($this, $this.ybe_1);
  $this.rbe_1.a6o();
  $this.hbf_1 = $this.gbf_1;
}
function renderCommands($this, ctx, doRequireTexture) {
  var mat = doRequireTexture ? $this.n9z().a2e(get_immutable(ctx.m87_1.z8g())) : $this.n9z();
  $this.ibf_1 = mat.u2e(-$this.hai(), -$this.iai());
  requireShape($this);
  $this.rbe_1.hbs(ctx, $this.ibf_1, $this.taj(), $this.vbe_1, $this.xaj(), doRequireTexture);
}
function renderShape($this, shape) {
  if (!equals(shape, EmptyShape_instance)) {
    if (shape instanceof CompoundShape) {
      var _iterator__ex2g4s = shape.f5p_1.b1();
      while (_iterator__ex2g4s.c1()) {
        var v = _iterator__ex2g4s.d1();
        renderShape($this, v);
      }
    } else {
      if (shape instanceof TextShape) {
        renderShape($this, shape.y5p());
      } else {
        if (shape instanceof FillShape) {
          $this.cbf_1 = $this.cbf_1 + 1 | 0;
          if ($this.cbf_1 > $this.jbf_1)
            return Unit_instance;
          renderFill($this, shape);
        } else {
          if (shape instanceof PolylineShape) {
            $this.cbf_1 = $this.cbf_1 + 1 | 0;
            if ($this.cbf_1 > $this.jbf_1)
              return Unit_instance;
            renderStroke$default($this, shape.k5p_1, shape.h5p_1, shape.j5p_1, shape.m5p_1, shape.l5p_1);
          } else {
            var reason = 'shape=' + toString(shape);
            throw NotImplementedError.be('An operation is not implemented: ' + reason);
          }
        }
      }
    }
  }
}
function renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef) {
  var gpuShapeViewCommands = $this.rbe_1;
  var pointsList = toStrokePointsList(toCurvesList(strokePath), strokeInfo, StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance(), VOID, forceClosed);
  gpuShapeViewCommands.gbs(Companion_getInstance_14().k6p_1);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pointsList.f1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var points = pointsList.e1(_unary__edvuaz);
    var startIndex = gpuShapeViewCommands.ibs();
    var vector = points.t3c();
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var inductionVariable = 0;
    var last = vector.f1();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderStroke.<anonymous>.<anonymous>' call
        var x = vector.m2c(n_0, 0);
        var y = vector.m2c(n_0, 1);
        var dx = vector.m2c(n_0, 2);
        var dy = vector.m2c(n_0, 3);
        var len = vector.m2c(n_0, 4);
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = vector.m2c(n_0, 5);
        var maxLen = Math.abs(this_0);
        var px = x + dx * len;
        var py = y + dy * len;
        gpuShapeViewCommands.jbs(px, py, $this.xbe_1 ? len : 0.0, $this.xbe_1 ? maxLen : $this.lbf_1);
      }
       while (inductionVariable < last);
    var endIndex = gpuShapeViewCommands.kbs();
    var info = GpuShapeViewPrograms_getInstance().dbt(stateTransform, paint, globalAlpha, strokeInfo.c3c_1);
    var tmp0_drawType = Companion_getInstance_16().m6x_1;
    var tmp1_blendMode = Companion_getInstance_13().q86_1;
    gpuShapeViewCommands.ebt(tmp0_drawType, info, VOID, stencilOpFunc, stencilRef, tmp1_blendMode, VOID, startIndex, endIndex);
  }
}
function renderStroke$default($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef, $super) {
  forceClosed = forceClosed === VOID ? null : forceClosed;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_17().y6o_1 : stencilOpFunc;
  stencilRef = stencilRef === VOID ? Companion_getInstance_18().w6o_1 : stencilRef;
  return renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef);
}
function getPointsForPath($this, points, type) {
  if (points.f1() < 3)
    return null;
  var vertexStart = $this.rbe_1.ibs();
  var bb = BoundsBuilder__plus_impl_cz7f7x_0(Companion_getInstance_29().a2b(), points);
  var xMid = (_BoundsBuilder___get_xmax__impl__gsz0km(bb) + _BoundsBuilder___get_xmin__impl__o2sib0(bb)) / 2;
  var yMid = (_BoundsBuilder___get_ymax__impl__oia4uz(bb) + _BoundsBuilder___get_ymin__impl__5n2e8j(bb)) / 2;
  var pMid = Vector2D.k2c(xMid, yMid);
  var isStrip = type === Companion_getInstance_16().m6x_1;
  var antialiased = $this.xbe_1;
  var isStripAndAntialiased = antialiased && isStrip;
  if (!isStrip) {
    $this.rbe_1.jbs(xMid, yMid, 0.0, $this.lbf_1);
  }
  var inductionVariable = 0;
  var last = points.f1() + 1 | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = points.e1(n % points.f1() | 0);
      var x = p.nl();
      var y = p.ol();
      var len = isStripAndAntialiased ? Companion_getInstance_27().t2k(p, pMid) : 0.0;
      var maxLen = isStripAndAntialiased ? len : $this.lbf_1;
      if (isStrip) {
        $this.rbe_1.jbs(xMid, yMid, 0.0, maxLen);
      }
      $this.rbe_1.jbs(x, y, len, maxLen);
    }
     while (inductionVariable < last);
  var vertexEnd = $this.rbe_1.kbs();
  return new PointsResult(toAGScissor(_BoundsBuilder___get_bounds__impl__s1l1gx(bb)), points.f1() + 2 | 0, vertexStart, vertexEnd);
}
function getPointsForPath_0($this, path, type) {
  return getPointsForPath($this, get_cachedPoints(path), type);
}
function getPointsForPathList($this, path, type) {
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var this_0 = getPoints2List(path);
  var destination = ArrayList.j1();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.getPointsForPathList.<anonymous>' call
    var tmp0_safe_receiver = getPointsForPath($this, element, type);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  return destination;
}
function renderFill($this, shape) {
  var tmp0_elvis_lhs = GpuShapeViewPrograms_getInstance().dbt(shape.w5o_1, shape.v5o_1, shape.x5o_1, 1.0E7);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var paintShader = tmp;
  var drawFill = !$this.kbf_1;
  var drawAntialiasingBorder = $this.kbf_1 ? true : $this.xbe_1;
  var shapeIsConvex = shape.d5p();
  var isSimpleDraw = shapeIsConvex && shape.u5o_1 == null && !$this.kbf_1;
  var pathDataList = getPointsForPathList($this, shape.t5o_1, isSimpleDraw ? Companion_getInstance_16().m6x_1 : Companion_getInstance_16().n6x_1);
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
  var bb = Companion_getInstance_29().a2b();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pathDataList.f1()) {
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = pathDataList.e1(_unary__edvuaz);
    bb = plus(bb, it.fbt_1);
  }
  var pathBoundsNoExpanded = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  var pathBounds = toAGScissor(pathBoundsNoExpanded.y2i(MarginInt.i2d(2)));
  var clipDataStart = $this.rbe_1.ibs();
  var tmp1_safe_receiver = shape.u5o_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
    tmp_0 = getPointsForPath_0($this, tmp1_safe_receiver, Companion_getInstance_16().n6x_1);
  }
  var clipData = tmp_0;
  var clipDataEnd = $this.rbe_1.kbs();
  var tmp3_elvis_lhs = clipData == null ? null : clipData.fbt_1;
  var clipBounds = tmp3_elvis_lhs == null ? Companion_getInstance_14().k6p_1 : tmp3_elvis_lhs;
  if (!isSimpleDraw || $this.fbf_1) {
    $this.fbf_1 = true;
    $this.rbe_1.gbs(isSimpleDraw ? Companion_getInstance_14().k6p_1 : !clipBounds.equals(Companion_getInstance_14().k6p_1) ? Companion_getInstance_14().t6y(pathBounds, clipBounds) : pathBounds);
  }
  if (isSimpleDraw) {
    $this.fbf_1 = false;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < pathDataList.f1()) {
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var pathData = pathDataList.e1(_unary__edvuaz_0);
      var tmp0_$this = $this.rbe_1;
      var tmp1_drawType = Companion_getInstance_16().m6x_1;
      var tmp2_startIndex = pathData.hbt_1;
      var tmp3_endIndex = pathData.ibt_1;
      var tmp4_colorMask = _AGColorMask___init__impl__j38ai8(true);
      var tmp5_blendMode = $this.waj();
      tmp0_$this.ebt(tmp1_drawType, paintShader, tmp4_colorMask, VOID, VOID, tmp5_blendMode, VOID, tmp2_startIndex, tmp3_endIndex);
    }
    return Unit_instance;
  }
  var winding = shape.t5o_1.y3h_1;
  var stencilReferenceValue = 1;
  var stencilCompare = Companion_getInstance_19().n6z_1;
  if (drawFill) {
    switch (winding.r3_1) {
      case 0:
        stencilReferenceValue = 1;
        stencilCompare = Companion_getInstance_19().n6z_1;
        var stencilOpFunc = AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().y6o_1, true), Companion_getInstance_19().m6z_1), Companion_getInstance_20().y6z_1);
        var stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_18().w6o_1, 1);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_1 = 0;
        while (n_1 < pathDataList.f1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          var pathData_0 = pathDataList.e1(_unary__edvuaz_1);
          writeStencil($this, pathData_0.hbt_1, pathData_0.ibt_1, stencilOpFunc, stencilRef, Companion_getInstance_21().m6p_1);
        }

        break;
      case 1:
        stencilReferenceValue = 0;
        stencilCompare = Companion_getInstance_19().t6z_1;
        var stencilOpFunc_0 = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().y6o_1, true), Companion_getInstance_19().m6z_1);
        var stencilRef_0 = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_18().w6o_1, 255);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_2 = 0;
        while (n_2 < pathDataList.f1()) {
          // Inline function 'korlibs.korge.view.vector.GpuShapeView.renderFill.<anonymous>' call
          var _unary__edvuaz_2 = n_2;
          n_2 = _unary__edvuaz_2 + 1 | 0;
          var pathData_1 = pathDataList.e1(_unary__edvuaz_2);
          writeStencil($this, pathData_1.hbt_1, pathData_1.ibt_1, AGStencilOpFunc__withActionOnBothPass_impl_qbn6at(stencilOpFunc_0, Companion_getInstance_20().x6z_1, Companion_getInstance_20().v6z_1), stencilRef_0, Companion_getInstance_21().m6p_1);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    if (!(clipData == null)) {
      if (winding.equals(Winding_NON_ZERO_getInstance())) {
        writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().y6o_1, true), Companion_getInstance_19().t6z_1), Companion_getInstance_20().y6z_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(Companion_getInstance_18().w6o_1, 0), 255), Companion_getInstance_21().n6p_1);
      }
      writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().y6o_1, true), Companion_getInstance_19().m6z_1), Companion_getInstance_20().y6z_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_18().w6o_1, 2), Companion_getInstance_21().p6p_1);
      stencilReferenceValue = 3;
    }
  }
  if (drawAntialiasingBorder && shape.u5o_1 == null) {
    renderStroke($this, shape.w5o_1, shape.t5o_1, shape.v5o_1, shape.x5o_1, new StrokeInfo(1.6 / $this.gbf_1, VOID, LineScaleMode_NONE_getInstance(), LineCap_BUTT_getInstance(), LineCap_BUTT_getInstance(), LineJoin_MITER_getInstance(), 5.0), true, !drawFill ? Companion_getInstance_17().y6o_1 : AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().y6o_1, true), AGCompareMode__inverted_impl_7xxk8m(stencilCompare)), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_18().w6o_1, stencilReferenceValue), 0));
  }
  if (drawFill) {
    writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare);
    $this.rbe_1.u7d(0);
  }
}
function writeStencil($this, pathDataStart, pathDataEnd, stencilOpFunc, stencilRef, cullFace) {
  var tmp0_$this = $this.rbe_1;
  var tmp1_drawType = Companion_getInstance_16().n6x_1;
  var tmp2_paintShader = GpuShapeViewPrograms_getInstance().cbt_1;
  var tmp3_colorMask = _AGColorMask___init__impl__j38ai8_0(false, false, false, false);
  var tmp4_blendMode = Companion_getInstance_13().s86_1;
  tmp0_$this.jbt(tmp1_drawType, tmp2_paintShader, tmp3_colorMask, stencilOpFunc, stencilRef, tmp4_blendMode, cullFace, pathDataStart, pathDataEnd);
}
function writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare) {
  var vstart = $this.rbe_1.ibs();
  var x0 = pathBounds.r2a();
  var y0 = pathBounds.t2a();
  var x1 = pathBounds.s2a();
  var y1 = pathBounds.u2a();
  $this.rbe_1.jbs(x0, y0, 0.0, $this.lbf_1);
  $this.rbe_1.jbs(x1, y0, 0.0, $this.lbf_1);
  $this.rbe_1.jbs(x1, y1, 0.0, $this.lbf_1);
  $this.rbe_1.jbs(x0, y1, 0.0, $this.lbf_1);
  var vend = $this.rbe_1.kbs();
  var tmp0_$this = $this.rbe_1;
  var tmp1_drawType = Companion_getInstance_16().n6x_1;
  var tmp2_colorMask = _AGColorMask___init__impl__j38ai8(true);
  var tmp3_stencilOpFunc = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_17().y6o_1, true), stencilCompare);
  var tmp4_stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_18().w6o_1, stencilReferenceValue), 0);
  var tmp5_blendMode = $this.waj();
  tmp0_$this.ebt(tmp1_drawType, paintShader, tmp2_colorMask, tmp3_stencilOpFunc, tmp4_stencilRef, tmp5_blendMode, VOID, vstart, vend);
}
var ShapeViewUB_instance;
function ShapeViewUB_getInstance() {
  if (ShapeViewUB_instance === VOID)
    new ShapeViewUB();
  return ShapeViewUB_instance;
}
function GpuShapeViewPrograms$PROGRAM_COMBINED$lambda($$this$FragmentShaderDefault) {
  return function ($this$IF_ELSE_LIST, it) {
    var tmp;
    switch (it) {
      case 0:
        $this$IF_ELSE_LIST.y74($this$IF_ELSE_LIST.b75(), GpuShapeViewPrograms_getInstance().pbu());
        tmp = Unit_instance;
        break;
      case 1:
        $this$IF_ELSE_LIST.y74($this$IF_ELSE_LIST.b75(), $this$IF_ELSE_LIST.j75($$this$FragmentShaderDefault.i75(), $this$IF_ELSE_LIST.p76($this$IF_ELSE_LIST.r76([$this$IF_ELSE_LIST.h75($this$IF_ELSE_LIST.c75(GpuShapeViewPrograms_getInstance().rbu(), $this$IF_ELSE_LIST.f75([$$this$FragmentShaderDefault.u74(), $this$IF_ELSE_LIST.e75(0.0), $this$IF_ELSE_LIST.e75(1.0)])), 'xy')]))));
        tmp = Unit_instance;
        break;
      case 2:
        $this$IF_ELSE_LIST.y74($this$IF_ELSE_LIST.b75(), $this$IF_ELSE_LIST.j75($$this$FragmentShaderDefault.i75(), $this$IF_ELSE_LIST.h75($this$IF_ELSE_LIST.c75(GpuShapeViewPrograms_getInstance().rbu(), $this$IF_ELSE_LIST.f75([$this$IF_ELSE_LIST.s76($$this$FragmentShaderDefault.u74()), $this$IF_ELSE_LIST.t76($$this$FragmentShaderDefault.u74()), $this$IF_ELSE_LIST.e75(0.0), $this$IF_ELSE_LIST.e75(1.0)])), 'xy')));
        tmp = Unit_instance;
        break;
      case 3:
        var rpoint = $this$IF_ELSE_LIST.j76(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.y74($this$IF_ELSE_LIST.h75(rpoint, 'xy'), $this$IF_ELSE_LIST.h75($this$IF_ELSE_LIST.c75(GpuShapeViewPrograms_getInstance().rbu(), $this$IF_ELSE_LIST.f75([$this$IF_ELSE_LIST.s76($$this$FragmentShaderDefault.u74()), $this$IF_ELSE_LIST.t76($$this$FragmentShaderDefault.u74()), $this$IF_ELSE_LIST.e75(0.0), $this$IF_ELSE_LIST.e75(1.0)])), 'xy'));
        var x = $this$IF_ELSE_LIST.s76(rpoint);
        var y = $this$IF_ELSE_LIST.t76(rpoint);
        var x0 = $this$IF_ELSE_LIST.s76(GpuShapeViewPrograms_getInstance().sbu());
        var y0 = $this$IF_ELSE_LIST.t76(GpuShapeViewPrograms_getInstance().sbu());
        var r0 = $this$IF_ELSE_LIST.u76(GpuShapeViewPrograms_getInstance().sbu());
        var x1 = $this$IF_ELSE_LIST.s76(GpuShapeViewPrograms_getInstance().tbu());
        var y1 = $this$IF_ELSE_LIST.t76(GpuShapeViewPrograms_getInstance().tbu());
        var r1 = $this$IF_ELSE_LIST.u76(GpuShapeViewPrograms_getInstance().tbu());
        var ratio = $this$IF_ELSE_LIST.s76($$this$FragmentShaderDefault.m75());
        var r0r1_2 = $this$IF_ELSE_LIST.t76($$this$FragmentShaderDefault.m75());
        var r0pow2 = $this$IF_ELSE_LIST.u76($$this$FragmentShaderDefault.m75());
        var r1pow2 = $this$IF_ELSE_LIST.v76($$this$FragmentShaderDefault.m75());
        var y0_y1 = $this$IF_ELSE_LIST.s76($$this$FragmentShaderDefault.d77());
        var x0_x1 = $this$IF_ELSE_LIST.t76($$this$FragmentShaderDefault.d77());
        var r0_r1 = $this$IF_ELSE_LIST.u76($$this$FragmentShaderDefault.d77());
        var radial_scale = $this$IF_ELSE_LIST.v76($$this$FragmentShaderDefault.d77());
        $this$IF_ELSE_LIST.y74(r0r1_2, $this$IF_ELSE_LIST.c75($this$IF_ELSE_LIST.c75($this$IF_ELSE_LIST.e75(2.0), r0), r1));
        $this$IF_ELSE_LIST.y74(r0pow2, GpuShapeViewPrograms_getInstance().ubu(r0));
        $this$IF_ELSE_LIST.y74(r1pow2, GpuShapeViewPrograms_getInstance().ubu(r1));
        $this$IF_ELSE_LIST.y74(x0_x1, $this$IF_ELSE_LIST.x76(x0, x1));
        $this$IF_ELSE_LIST.y74(y0_y1, $this$IF_ELSE_LIST.x76(y0, y1));
        $this$IF_ELSE_LIST.y74(r0_r1, $this$IF_ELSE_LIST.x76(r0, r1));
        $this$IF_ELSE_LIST.y74(radial_scale, $this$IF_ELSE_LIST.n75($this$IF_ELSE_LIST.e75(1.0), $this$IF_ELSE_LIST.x76($this$IF_ELSE_LIST.x76(GpuShapeViewPrograms_getInstance().ubu($this$IF_ELSE_LIST.x76(r0, r1)), GpuShapeViewPrograms_getInstance().ubu($this$IF_ELSE_LIST.x76(x0, x1))), GpuShapeViewPrograms_getInstance().ubu($this$IF_ELSE_LIST.x76(y0, y1)))));
        $this$IF_ELSE_LIST.y74(ratio, $this$IF_ELSE_LIST.x76($this$IF_ELSE_LIST.e75(1.0), $this$IF_ELSE_LIST.c75($this$IF_ELSE_LIST.x76($this$IF_ELSE_LIST.y76($this$IF_ELSE_LIST.y76($this$IF_ELSE_LIST.c75($this$IF_ELSE_LIST.w76(r1), r0_r1), $this$IF_ELSE_LIST.c75(x0_x1, $this$IF_ELSE_LIST.x76(x1, x))), $this$IF_ELSE_LIST.c75(y0_y1, $this$IF_ELSE_LIST.x76(y1, y))), $this$IF_ELSE_LIST.n76($this$IF_ELSE_LIST.x76($this$IF_ELSE_LIST.y76($this$IF_ELSE_LIST.x76($this$IF_ELSE_LIST.c75(r1pow2, $this$IF_ELSE_LIST.y76(GpuShapeViewPrograms_getInstance().ubu($this$IF_ELSE_LIST.x76(x0, x)), GpuShapeViewPrograms_getInstance().ubu($this$IF_ELSE_LIST.x76(y0, y)))), $this$IF_ELSE_LIST.c75(r0r1_2, $this$IF_ELSE_LIST.y76($this$IF_ELSE_LIST.c75($this$IF_ELSE_LIST.x76(x0, x), $this$IF_ELSE_LIST.x76(x1, x)), $this$IF_ELSE_LIST.c75($this$IF_ELSE_LIST.x76(y0, y), $this$IF_ELSE_LIST.x76(y1, y))))), $this$IF_ELSE_LIST.c75(r0pow2, $this$IF_ELSE_LIST.y76(GpuShapeViewPrograms_getInstance().ubu($this$IF_ELSE_LIST.x76(x1, x)), GpuShapeViewPrograms_getInstance().ubu($this$IF_ELSE_LIST.x76(y1, y))))), GpuShapeViewPrograms_getInstance().ubu($this$IF_ELSE_LIST.x76($this$IF_ELSE_LIST.y76($this$IF_ELSE_LIST.y76($this$IF_ELSE_LIST.x76($this$IF_ELSE_LIST.x76($this$IF_ELSE_LIST.c75(x1, y0), $this$IF_ELSE_LIST.c75(x, y0)), $this$IF_ELSE_LIST.c75(x0, y1)), $this$IF_ELSE_LIST.c75(x, y1)), $this$IF_ELSE_LIST.c75(x0, y)), $this$IF_ELSE_LIST.c75(x1, y)))))), radial_scale)));
        $this$IF_ELSE_LIST.y74($this$IF_ELSE_LIST.b75(), $this$IF_ELSE_LIST.j75($$this$FragmentShaderDefault.i75(), $this$IF_ELSE_LIST.r76([ratio, $this$IF_ELSE_LIST.e75(0.0)])));
        tmp = Unit_instance;
        break;
      case 4:
        var rpoint_0 = $this$IF_ELSE_LIST.j76(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.y74($this$IF_ELSE_LIST.h75(rpoint_0, 'xy'), $this$IF_ELSE_LIST.h75($this$IF_ELSE_LIST.c75(GpuShapeViewPrograms_getInstance().rbu(), $this$IF_ELSE_LIST.f75([$this$IF_ELSE_LIST.s76($$this$FragmentShaderDefault.u74()), $this$IF_ELSE_LIST.t76($$this$FragmentShaderDefault.u74()), $this$IF_ELSE_LIST.e75(0.0), $this$IF_ELSE_LIST.e75(1.0)])), 'xy'));
        var x_0 = $this$IF_ELSE_LIST.s76(rpoint_0);
        var y_0 = $this$IF_ELSE_LIST.t76(rpoint_0);
        var ratio_0 = $this$IF_ELSE_LIST.s76($$this$FragmentShaderDefault.m75());
        var angle = $this$IF_ELSE_LIST.t76($$this$FragmentShaderDefault.m75());
        var x0_0 = $this$IF_ELSE_LIST.s76(GpuShapeViewPrograms_getInstance().sbu());
        var y0_0 = $this$IF_ELSE_LIST.t76(GpuShapeViewPrograms_getInstance().sbu());
        var PI2 = $this$IF_ELSE_LIST.e75(3.141592653589793 * 2);
        $this$IF_ELSE_LIST.y74(angle, $this$IF_ELSE_LIST.l76($this$IF_ELSE_LIST.x76(y_0, y0_0), $this$IF_ELSE_LIST.x76(x_0, x0_0)));
        // Inline function 'korlibs.graphics.shader.Builder.IF' call

        var cond = $this$IF_ELSE_LIST.a77(angle, $this$IF_ELSE_LIST.e75(0.0));
        var body = $this$IF_ELSE_LIST.p75();
        // Inline function 'korlibs.korge.view.vector.GpuShapeViewPrograms.PROGRAM_COMBINED.<anonymous>.<anonymous>.<anonymous>' call

        body.y74(angle, body.y76(angle, PI2));
        var stmIf = new If(cond, body.r75());
        // Inline function 'kotlin.collections.plusAssign' call

        $this$IF_ELSE_LIST.x74_1.h(stmIf);
        $this$IF_ELSE_LIST.y74(ratio_0, $this$IF_ELSE_LIST.n75(angle, PI2));
        $this$IF_ELSE_LIST.y74($this$IF_ELSE_LIST.b75(), $this$IF_ELSE_LIST.j75($$this$FragmentShaderDefault.i75(), $this$IF_ELSE_LIST.p76($this$IF_ELSE_LIST.r76([ratio_0, $this$IF_ELSE_LIST.e75(0.0)]))));
        tmp = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
var GpuShapeViewPrograms_instance;
function GpuShapeViewPrograms_getInstance() {
  if (GpuShapeViewPrograms_instance === VOID)
    new GpuShapeViewPrograms();
  return GpuShapeViewPrograms_instance;
}
function u_ProgramType$factory() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.obu();
  }, null);
}
function u_Color$factory() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.pbu();
  }, null);
}
function u_ColorMul$factory() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.nbu();
  }, null);
}
function u_GlobalAlpha$factory() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.qbu();
  }, null);
}
function u_GlobalPixelScale$factory() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.mbu();
  }, null);
}
function u_Transform$factory() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.rbu();
  }, null);
}
function u_Gradientp0$factory() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.sbu();
  }, null);
}
function u_Gradientp1$factory() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.tbu();
  }, null);
}
function u_ProgramType$factory_0() {
  return getPropertyCallableRef('u_ProgramType', 1, KProperty1, function (receiver) {
    return receiver.obu();
  }, null);
}
function u_Color$factory_0() {
  return getPropertyCallableRef('u_Color', 1, KProperty1, function (receiver) {
    return receiver.pbu();
  }, null);
}
function u_ColorMul$factory_0() {
  return getPropertyCallableRef('u_ColorMul', 1, KProperty1, function (receiver) {
    return receiver.nbu();
  }, null);
}
function u_GlobalAlpha$factory_0() {
  return getPropertyCallableRef('u_GlobalAlpha', 1, KProperty1, function (receiver) {
    return receiver.qbu();
  }, null);
}
function u_GlobalPixelScale$factory_0() {
  return getPropertyCallableRef('u_GlobalPixelScale', 1, KProperty1, function (receiver) {
    return receiver.mbu();
  }, null);
}
function u_Transform$factory_0() {
  return getPropertyCallableRef('u_Transform', 1, KProperty1, function (receiver) {
    return receiver.rbu();
  }, null);
}
function u_Gradientp0$factory_0() {
  return getPropertyCallableRef('u_Gradientp0', 1, KProperty1, function (receiver) {
    return receiver.sbu();
  }, null);
}
function u_Gradientp1$factory_0() {
  return getPropertyCallableRef('u_Gradientp1', 1, KProperty1, function (receiver) {
    return receiver.tbu();
  }, null);
}
function beforeStartingKorge(config) {
}
function completeViews(views) {
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForLambda(Korge$_init_$slambda_ys8r4w, VOID, VOID, [1]);
initMetadataForLambda(Korge$start$slambda, VOID, VOID, [1]);
initMetadataForClass(Korge, 'Korge', Korge, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(KorgeDisplayMode, 'KorgeDisplayMode');
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KorgeRunner$invoke$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$prepareViewsBase$lambda$slambda, VOID, VOID, [0]);
initMetadataForObject(KorgeRunner, 'KorgeRunner', VOID, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForClass(KeysEvents, 'KeysEvents', VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(MouseEventsUpdate, 'MouseEventsUpdate');
initMetadataForClass(MouseEvents, 'MouseEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SceneCancellationException, 'SceneCancellationException');
initMetadataForClass(Scene, 'Scene', VOID, VOID, [InjectorDependency, CoroutineScope], [0]);
initMetadataForClass(EmptyScene, 'EmptyScene', EmptyScene, VOID, VOID, [0]);
initMetadataForClass(VisitEntry, 'VisitEntry');
initMetadataForCompanion(Companion_2);
initMetadataForLambda(SceneContainer$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_1, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_2, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_3, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_4, VOID, VOID, [0]);
initMetadataForClass(BaseView, 'BaseView', BaseView.may);
initMetadataForClass(View, 'View');
initMetadataForClass(Container, 'Container', Container.za4);
initMetadataForClass(CachedContainer, 'CachedContainer', CachedContainer.nay);
initMetadataForClass(FixedSizeCachedContainer, 'FixedSizeCachedContainer', FixedSizeCachedContainer.xap);
initMetadataForClass(UIView, 'UIView', UIView.jae);
initMetadataForClass(SceneContainer, 'SceneContainer', VOID, VOID, [UIView, CoroutineScope], [2, 4, 6, 3]);
initMetadataForInterface(TransitionProcess, 'TransitionProcess');
initMetadataForClass(TransitionView, 'TransitionView', TransitionView.kae);
protoOf(Transition$1).yak = start;
protoOf(Transition$1).zak = end;
initMetadataForClass(Transition$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1$create$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1);
initMetadataForObject(MsdfRender, 'MsdfRender');
initMetadataForClass(TimerComponents, 'TimerComponents', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(TimerRef, 'TimerRef');
initMetadataForClass(TweenComponent, 'TweenComponent');
initMetadataForLambda(tween$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_3);
initMetadataForClass(InternalViewAutoscaling, 'InternalViewAutoscaling', InternalViewAutoscaling);
initMetadataForClass(RectBase, 'RectBase', RectBase.sbi);
initMetadataForClass(BaseImage, 'BaseImage');
initMetadataForClass(BaseGraphics, 'BaseGraphics');
initMetadataForClass(CacheTexture, 'CacheTexture', VOID, VOID, [AutoCloseable]);
initMetadataForClass(FixedSizeContainer, 'FixedSizeContainer', FixedSizeContainer.rb3);
initMetadataForClass(ClipContainer, 'ClipContainer', ClipContainer.fb1);
initMetadataForObject(ZIndexComparator, 'ZIndexComparator', VOID, VOID, [Comparator]);
initMetadataForClass(ContainerCollection$iterator$1);
initMetadataForClass(ContainerCollection, 'ContainerCollection', VOID, VOID, [MutableIterable, Collection, KtList]);
initMetadataForClass(CpuGraphics, 'CpuGraphics', CpuGraphics.lb7);
initMetadataForClass(DummyView, 'DummyView', DummyView.nb9);
initMetadataForCompanion(Companion_4);
initMetadataForClass(SContainer, 'SContainer', SContainer.oa7);
initMetadataForClass(TimeSlidingWindow, 'TimeSlidingWindow');
initMetadataForClass(GraphicsRenderer, 'GraphicsRenderer');
initMetadataForClass(Graphics, 'Graphics', Graphics.pbf);
initMetadataForInterface(ViewFileRef, 'ViewFileRef', VOID, VOID, VOID, [3]);
protoOf(Image).nbi = forceLoadSourceFile$default;
initMetadataForClass(Image, 'Image', VOID, VOID, [BaseImage, ViewFileRef], [3]);
initMetadataForCompanion(Companion_5);
initMetadataForCompanion(Companion_6);
initMetadataForClass(SolidRect, 'SolidRect');
initMetadataForClass(Stage, 'Stage', VOID, VOID, [FixedSizeContainer, CoroutineScope, BoundsProvider]);
initMetadataForCompanion(Companion_7);
initMetadataForLambda(Text$_renderInternal$slambda, VOID, VOID, [0]);
initMetadataForClass(Text, 'Text', VOID, VOID, VOID, [2]);
initMetadataForInterface(ColorReference, 'ColorReference');
initMetadataForCompanion(Companion_8);
initMetadataForInterface(ViewRenderPhase, 'ViewRenderPhase');
initMetadataForLambda(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda, VOID, VOID, [0]);
protoOf(Mixin_0).nbi = forceLoadSourceFile$default;
initMetadataForClass(Mixin_0, 'Mixin', Mixin_0, VOID, [ViewFileRef], [3]);
initMetadataForLambda(Views$close$slambda, VOID, VOID, [0]);
initMetadataForClass(Views, 'Views', VOID, VOID, [BaseEventListener, CoroutineScope, BoundsProvider, AutoCloseable, DeviceDimensionsProvider], [0]);
initMetadataForCompanion(Companion_9);
initMetadataForClass(ViewsUpdateEvent, 'ViewsUpdateEvent');
initMetadataForCompanion(Companion_10);
initMetadataForClass(ViewsResizedEvent, 'ViewsResizedEvent');
initMetadataForCompanion(Companion_11);
initMetadataForInterface(Filter, 'Filter');
initMetadataForClass(RenderToTextureResult, 'RenderToTextureResult', RenderToTextureResult, VOID, [DisposableHandle]);
protoOf(IdentityFilter).ebr = get_recommendedFilterScale;
protoOf(IdentityFilter).fbr = computeBorder;
initMetadataForClass(IdentityFilter, 'IdentityFilter', VOID, VOID, [Filter]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(ViewRenderPhaseBackdropFilter, 'ViewRenderPhaseBackdropFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForClass(ViewRenderPhaseFilter, 'ViewRenderPhaseFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForClass(PointsResult, 'PointsResult');
initMetadataForClass(GpuShapeView, 'GpuShapeView', GpuShapeView.mbf);
initMetadataForClass(ScissorCommand, 'ScissorCommand');
initMetadataForClass(ClearCommand, 'ClearCommand');
initMetadataForClass(ShapeCommand, 'ShapeCommand');
initMetadataForClass(GpuShapeViewCommands, 'GpuShapeViewCommands', GpuShapeViewCommands);
initMetadataForObject(ShapeViewUB, 'ShapeViewUB');
initMetadataForClass(PaintShader, 'PaintShader');
initMetadataForObject(GpuShapeViewPrograms, 'GpuShapeViewPrograms');
//endregion
//region block: init
KorgeRunner_instance = new KorgeRunner();
Companion_instance_16 = new Companion_1();
ZIndexComparator_instance = new ZIndexComparator();
Companion_instance_19 = new Companion_4();
Companion_instance_20 = new Companion_5();
Companion_instance_21 = new Companion_6();
Companion_instance_22 = new Companion_7();
Companion_instance_23 = new Companion_8();
Companion_instance_24 = new Companion_9();
Companion_instance_25 = new Companion_10();
//endregion
//region block: exports
export {
  GraphicsRenderer_SYSTEM_getInstance as GraphicsRenderer_SYSTEM_getInstance3mmjgo01yqcce,
  delay as delay8my8khmz70k5,
  views as views116j359zi8nvf,
  Korge_0 as Korge3fi4cwjkh8up9,
  Companion_getInstance_39 as Companion_getInstance2b4rje0hs8ulh,
  Companion_instance_22 as Companion_instance1qzytx5vkv693,
  MouseEvents as MouseEvents19mapgq8ez76g,
  get_mouse as get_mouse1jstwhfaumelj,
  get_AlphaTransition as get_AlphaTransition23l7sd982osvm,
  SceneContainer as SceneContainer99ijjqni12hp,
  Scene as Scenezu810y12qpqp,
  withEasing as withEasingtnol1eyyo9sf,
  ClipContainer as ClipContainernpx31s3mxtjx,
  Container as Container7486fjmip554,
  FixedSizeContainer as FixedSizeContainersre0rworj71w,
  Graphics as Graphics2q0lx93a2j4b2,
  Image as Image1b2d7ghyim7p5,
  SContainer as SContainerfim2zr5seafm,
  SolidRect as SolidRect131p7hyzlx7j8,
  Stage as Stage1ggtrzujnnkl0,
  Text as Text3kimhvgfxflj3,
  addTo as addTo25e29vq105prw,
  addUpdater as addUpdater1la23qj9g2d42,
  findFirstAscendant as findFirstAscendante8nli1jx4t64,
  position as positionu6441b7hkb4l,
  scale as scalea9fc0mbrr7ub,
  xy_0 as xy1gb51vhy014mx,
};
//endregion
